var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 685,
    viewBox: "0 0 1920 685",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7001_52055)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 685,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    width: 1920,
    height: 1080,
    fill: "url(#paint0_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.412 899.431V868.693C228.412 708.715 354.376 577.346 513.611 570.159L527.254 556.208C354.766 556.208 214.775 696.019 214.775 868.687V899.425H228.418L228.412 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4579 899.431V868.693C31.4579 708.715 157.422 577.346 316.657 570.159L330.3 556.208C157.812 556.208 17.8208 696.019 17.8208 868.687V899.425H31.4637L31.4579 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.401 899.431V868.693C401.401 708.72 527.36 577.346 686.601 570.159L700.244 556.208C527.755 556.208 387.764 696.019 387.764 868.687V899.425H401.407L401.401 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.39 899.431V868.693C574.39 708.726 700.343 577.346 859.59 570.159L873.232 556.208C700.744 556.208 560.753 696.019 560.753 868.687V899.425H574.396L574.39 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.38 899.431V868.693C747.38 708.732 873.327 577.346 1032.58 570.159L1046.22 556.208C873.734 556.208 733.743 696.019 733.743 868.687V899.425H747.386L747.38 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.366 899.431V868.693C920.366 708.738 1046.31 577.346 1205.57 570.159L1219.21 556.208C1046.72 556.208 906.729 696.019 906.729 868.687V899.425H920.371L920.366 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.37 899.431V868.693C1093.37 708.744 1219.3 577.346 1378.57 570.159L1392.21 556.208C1219.72 556.208 1079.73 696.019 1079.73 868.687V899.425H1093.37L1093.37 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.36 899.431V868.693C1266.36 708.749 1392.29 577.346 1551.56 570.159L1565.2 556.208C1392.71 556.208 1252.72 696.019 1252.72 868.687V899.425H1266.36L1266.36 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.35 899.431V868.693C1439.35 708.755 1565.27 577.346 1724.55 570.159L1738.19 556.208C1565.7 556.208 1425.71 696.019 1425.71 868.687V899.425H1439.35L1439.35 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619.25 899.431V868.693C1619.25 708.755 1745.18 577.346 1904.45 570.159L1918.1 556.208C1745.61 556.208 1605.62 696.019 1605.62 868.687V899.425H1619.26L1619.25 899.431Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.6 899.432V867.289C1797.6 766.646 1847.47 677.299 1924.12 623.093V606.58C1839.68 662.506 1783.96 758.36 1783.96 867.289V899.432H1797.61H1797.6Z",
    fill: "#BEAEAE",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.64 594.355H-5.87305V612.217H1923.64V594.355Z",
    fill: "#BEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.464 668.789V737.666C51.464 739.549 49.9359 741.077 48.0533 741.077C46.1707 741.077 44.6426 739.549 44.6426 737.666V668.789H51.464Z",
    fill: "#ECC0BC",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.477 668.789V740.124C115.477 742.006 113.949 743.535 112.066 743.535C110.183 743.535 108.655 742.006 108.655 740.124V668.789H115.477Z",
    fill: "#ECC0BC",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.524 668.665V737.542C484.524 739.425 482.995 740.953 481.113 740.953C479.23 740.953 477.702 739.425 477.702 737.542V668.665H484.524Z",
    fill: "#CBB4B2",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.78 668.665V737.542C596.78 739.425 595.252 740.953 593.37 740.953C591.487 740.953 589.959 739.425 589.959 737.542V668.665H596.78Z",
    fill: "#CBB4B2",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1528.35 668.665V737.542C1528.35 739.425 1526.83 740.953 1524.94 740.953C1523.06 740.953 1521.53 739.425 1521.53 737.542V668.665H1528.35Z",
    fill: "#CBB4B2",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.62 668.665V737.542C1640.62 739.425 1639.09 740.953 1637.2 740.953C1635.32 740.953 1633.79 739.425 1633.79 737.542V668.665H1640.62Z",
    fill: "#CBB4B2",
    stroke: "#575454"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-0.5 1092.75V612.944L1919.5 612.217V1092.75H-0.5Z",
    fill: "url(#paint1_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.15 664.956V511.36L-6.03235 511.36V664.956L1923.15 664.956Z",
    fill: "#C4E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.16 685V663.133L-6.02454 663.133V685L1923.16 685Z",
    fill: "url(#paint2_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1927.45 664.819H-6.5498V647.9H1927.45V664.819Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.95 584.5L440.95 585.5L612.45 648H1281.45L1333.95 584.5Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.71 546.163C328.553 545.393 326.279 545 323.989 545H-17.5498L-18.5498 568H255.874C256.918 568 257.956 568.163 258.95 568.485L325.13 589.871L463.45 648H612.45L440.95 585.5L330.71 546.163Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.45 648L325.13 589.871H-7.19477L-6.5498 648H463.45Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.45 648L1565.45 647.5L1937.45 648L1923.45 602.001L1520.1 600.654C1489.92 600.553 1460 594.988 1431.8 584.228L1386.43 566.914C1381.22 564.926 1382.68 557.194 1388.26 557.243L1933.45 562V545L1320.44 543.156C1305.4 543.111 1299.66 562.775 1312.37 570.827L1333.95 584.5L1281.45 648H1436.45Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.71 599.879C1546.71 599.879 1551.05 596.805 1551.18 593.605C1551.3 590.404 1545.36 593.605 1545.36 593.605C1545.36 593.605 1546.35 592.23 1544.99 591.874C1543.64 591.524 1540.66 593.796 1540.66 593.796C1540.66 593.796 1540.58 587.777 1535.05 587.221C1529.53 586.666 1527.96 589.953 1527.96 589.953C1527.96 589.953 1526.89 587.522 1524.83 587.476C1522.77 587.435 1523.09 589.27 1523.09 589.27C1523.09 589.27 1520.45 586.283 1514.02 586.88C1507.59 587.476 1506.52 592.129 1506.52 592.129C1506.52 592.129 1504.48 590.627 1502.56 590.946C1500.65 591.264 1501.88 594.497 1501.88 594.497C1501.88 594.497 1498.42 590.335 1496.07 590.304C1493.72 590.272 1495.33 593.855 1495.33 593.855C1495.33 593.855 1492.8 589.407 1485 588.573C1477.21 587.74 1479.99 593.336 1479.99 593.336C1479.99 593.336 1476.84 591.647 1474.99 592.125C1473.14 592.603 1476.66 595.936 1476.66 595.936C1476.66 595.936 1472.14 594.237 1469.3 594.943C1466.45 595.649 1472.47 599.874 1472.47 599.874H1546.7L1546.71 599.879Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.12 648.175C1358.12 648.175 1362.47 645.101 1362.59 641.9C1362.72 638.7 1356.78 641.9 1356.78 641.9C1356.78 641.9 1357.77 640.525 1356.41 640.17C1355.05 639.82 1352.08 642.092 1352.08 642.092C1352.08 642.092 1352 636.072 1346.47 635.517C1340.94 634.961 1339.38 638.249 1339.38 638.249C1339.38 638.249 1338.3 635.817 1336.24 635.772C1334.18 635.731 1334.51 637.566 1334.51 637.566C1334.51 637.566 1331.87 634.579 1325.44 635.175C1319.01 635.772 1317.93 640.425 1317.93 640.425C1317.93 640.425 1315.89 638.923 1313.98 639.241C1312.06 639.56 1313.3 642.793 1313.3 642.793C1313.3 642.793 1309.83 638.631 1307.48 638.599C1305.13 638.568 1306.74 642.151 1306.74 642.151C1306.74 642.151 1304.21 637.702 1296.42 636.869C1288.62 636.036 1291.41 641.632 1291.41 641.632C1291.41 641.632 1288.25 639.943 1286.4 640.421C1284.55 640.899 1288.07 644.232 1288.07 644.232C1288.07 644.232 1283.56 642.533 1280.71 643.239C1277.87 643.945 1283.88 648.17 1283.88 648.17H1358.11L1358.12 648.175Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.056 568.654C252.056 568.654 255.139 566.474 255.227 564.204C255.314 561.934 251.104 564.204 251.104 564.204C251.104 564.204 251.804 563.229 250.842 562.977C249.879 562.729 247.769 564.34 247.769 564.34C247.769 564.34 247.712 560.071 243.791 559.677C239.874 559.283 238.762 561.614 238.762 561.614C238.762 561.614 238.001 559.89 236.539 559.858C235.077 559.829 235.309 561.13 235.309 561.13C235.309 561.13 233.435 559.012 228.875 559.435C224.315 559.858 223.554 563.158 223.554 563.158C223.554 563.158 222.107 562.092 220.749 562.318C219.39 562.544 220.265 564.837 220.265 564.837C220.265 564.837 217.81 561.886 216.142 561.863C214.475 561.841 215.617 564.382 215.617 564.382C215.617 564.382 213.821 561.227 208.294 560.636C202.766 560.045 204.742 564.014 204.742 564.014C204.742 564.014 202.504 562.816 201.191 563.155C199.879 563.494 202.375 565.858 202.375 565.858C202.375 565.858 199.174 564.653 197.156 565.154C195.139 565.654 199.405 568.651 199.405 568.651H252.051L252.056 568.654Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.354609
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.747 638.68C437.747 638.68 429.156 641.085 432.346 648.661H491.951C492.623 647.642 493.108 646.466 493.252 645.126C490.416 639.749 485.4 640.297 485.4 640.297C485.4 640.297 487.841 637.985 486.557 637.653C485.274 637.322 483.084 638.493 483.084 638.493C483.084 638.493 485.017 634.612 479.612 635.19C474.206 635.768 472.45 638.853 472.45 638.853C472.45 638.853 473.567 636.368 471.936 636.39C470.305 636.412 467.905 639.299 467.905 639.299C467.905 639.299 468.76 637.057 467.432 636.836C466.103 636.614 464.689 637.657 464.689 637.657C464.689 637.657 463.944 634.429 459.484 634.016C455.025 633.602 453.193 635.673 453.193 635.673C453.193 635.673 453.42 634.401 451.99 634.429C450.561 634.461 449.816 636.147 449.816 636.147C449.816 636.147 448.729 633.867 444.899 634.252C441.063 634.638 441.008 638.812 441.008 638.812C441.008 638.812 438.944 637.237 438.003 637.48C437.062 637.726 437.747 638.68 437.747 638.68Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.974 354.425H279.941V354.467H279.974V354.425Z",
    fill: "url(#paint3_linear_7001_52055)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1661.64 229.01L1663.24 139.051L1665.9 229.266C1666.5 229.266 1666.99 229.754 1666.99 230.35V241.162H1668.08C1668.68 241.162 1669.17 241.65 1669.17 242.246V246.606C1669.95 247.326 1670.49 248.327 1670.59 249.46L1670.81 252.273C1671.16 256.393 1671.15 260.537 1670.77 264.657L1670.6 266.427C1670.42 268.413 1668.91 269.985 1666.99 270.299V280.086H1668.08C1668.68 280.086 1669.17 280.574 1669.17 281.17V282.253C1669.17 282.849 1668.68 283.337 1668.08 283.337H1666.99V288.739H1668.08C1668.68 288.739 1669.17 289.227 1669.17 289.823V291.982C1669.17 292.578 1668.68 293.066 1668.08 293.066H1666.99V301.711H1668.08C1668.68 301.711 1669.17 302.199 1669.17 302.795V304.954C1669.17 305.55 1668.68 306.038 1668.08 306.038H1666.99V307.121H1668.08C1668.68 307.121 1669.17 307.609 1669.17 308.205V310.364C1669.17 310.96 1668.68 311.448 1668.08 311.448H1666.99V313.607H1669.16C1669.76 313.607 1670.25 314.095 1670.25 314.691V322.261C1670.25 322.856 1669.76 323.344 1669.16 323.344H1668.07V346.045C1668.67 346.045 1669.16 346.533 1669.16 347.129V349.288C1669.16 349.883 1668.67 350.372 1668.07 350.372V352.531C1668.67 352.531 1669.16 353.019 1669.16 353.615V355.774C1669.16 356.369 1668.67 356.857 1668.07 356.857V381.717H1670.24C1670.84 381.717 1671.33 382.205 1671.33 382.801V394.085H1679.53C1680.72 394.085 1681.7 395.053 1681.7 396.244V397.924H1703.91V391.148C1703.91 390.503 1703.4 389.982 1702.75 389.982C1702.1 389.982 1701.58 389.461 1701.58 388.815V384.704C1701.58 383.761 1700.81 382.991 1699.85 382.991C1698.66 382.991 1697.83 381.792 1698.25 380.675L1708.54 353.639C1708.85 352.795 1709.65 352.241 1710.57 352.241H1838.77C1839.55 352.241 1840.25 352.638 1840.64 353.3L1856.9 380.691C1857.49 381.709 1856.77 382.991 1855.58 382.991C1854.74 382.991 1854.05 383.67 1854.05 384.513V387.814C1854.05 389.006 1853.08 389.973 1851.88 389.973H1851.55C1850.36 389.973 1849.38 390.941 1849.38 392.133V397.907H1863.64V345.747C1863.64 345.209 1864.08 344.771 1864.62 344.771C1865.16 344.771 1865.61 344.332 1865.61 343.795V324.412C1865.61 323.22 1866.57 322.252 1867.77 322.252H1903.55V320.093C1903.55 318.902 1904.52 317.934 1905.72 317.934H1915.51C1916.47 317.934 1917.31 317.313 1917.59 316.403L1922.62 300.007C1922.89 299.097 1923.74 298.476 1924.7 298.476H2047.33C2048.52 298.476 2049.5 299.444 2049.5 300.635V397.915V512.132H1509.09H657.303H129.5V377.242V371.484C129.5 370.292 130.472 369.325 131.668 369.325H132.839C134.034 369.325 135.006 368.357 135.006 367.165V356.709C135.006 355.517 135.978 354.549 137.174 354.549H176.497C177.693 354.549 178.664 355.517 178.664 356.709V367.165C178.664 368.357 179.636 369.325 180.832 369.325H185.017C186.188 369.325 187.135 370.268 187.135 371.434C187.135 372.601 188.082 373.544 189.253 373.544H201.087C201.893 373.544 202.64 373.99 203.006 374.702L211.053 389.965C211.219 390.271 211.302 390.619 211.302 390.966V398.85H220.62V383.653C220.62 382.362 222.497 382.164 222.771 383.43L223.269 385.746L226.218 385.738L226.525 383.67C226.699 382.462 228.435 382.42 228.659 383.62L229.058 385.688V385.746L234.896 385.738L235.203 383.67C235.378 382.462 237.113 382.42 237.338 383.62L237.736 385.688V385.746L239.231 385.738L239.538 383.67C239.713 382.462 241.449 382.42 241.673 383.62L242.063 385.688C242.071 385.696 242.071 385.721 242.071 385.721V385.746L242.487 385.738L242.794 383.67C242.968 382.462 244.704 382.42 244.928 383.62L245.327 385.688V385.721V385.746H245.941L246.44 383.43C246.714 382.156 248.591 382.354 248.591 383.653V398.85H271.944V339.427H272.118L272.334 337.516C272.484 336.266 274.294 336.225 274.493 337.474L274.784 339.427H275.639L275.855 337.516C276.013 336.266 277.823 336.225 278.006 337.474L278.338 339.65H286.627L286.867 337.516C287.017 336.266 288.827 336.225 289.027 337.474L289.351 339.65H290.156L290.397 337.516C290.555 336.266 292.365 336.225 292.548 337.474L292.88 339.65H293.304V354.334H298.818V321.872H299.159V321.83V321.764L299.574 317.818C299.707 316.503 301.633 316.528 301.733 317.843L302.04 321.789V321.872H307.098V321.764L307.513 317.818C307.646 316.503 309.573 316.528 309.672 317.843L309.98 321.789V321.872H311.176V292.462H312.155L312.43 291.337C312.712 290.203 314.34 290.253 314.556 291.395L314.755 292.454H315.453L319.555 280.599L321.15 257.336H321.091C319.273 257.336 317.794 255.863 317.794 254.043C317.794 252.223 319.256 250.75 321.091 250.75C322.927 250.75 324.405 252.223 324.405 254.043C324.405 255.722 323.134 257.112 321.507 257.311L323.301 280.599L326.98 292.454H327.478L328.283 290.03C328.624 289.004 330.11 289.054 330.368 290.112L330.941 292.462H331.016V292.818C331.024 292.892 331.024 292.967 331.016 293.033V321.872H333.997V321.83V321.764L334.412 317.818C334.545 316.503 336.472 316.528 336.572 317.843L336.879 321.789V321.872L337.086 321.863V321.814C337.086 321.797 337.095 321.764 337.095 321.764L337.493 317.818C337.626 316.503 339.553 316.528 339.653 317.843L339.96 321.789C339.96 321.814 339.968 321.872 339.968 321.872H340.276V354.334H342.036V339.65H342.46L342.792 337.474C342.991 336.233 344.802 336.266 344.943 337.516L345.192 339.65H345.981L346.313 337.474C346.512 336.233 348.323 336.266 348.464 337.516L348.713 339.65H356.993L357.325 337.474C357.525 336.233 359.335 336.266 359.476 337.516L359.7 339.427H360.547L360.855 337.474C361.054 336.233 362.865 336.266 363.006 337.516L363.23 339.427H363.62V398.85H377.639L377.506 382.18C377.489 380.898 379.333 380.667 379.64 381.916L380.521 385.514H381.376L381.692 382.586C381.833 381.32 383.668 381.287 383.851 382.544L384.274 385.506H384.631L384.947 382.578C385.088 381.312 386.923 381.279 387.106 382.536L387.53 385.498H387.887L388.202 382.569C388.344 381.304 390.179 381.27 390.362 382.528L390.785 385.49H392.23L392.546 382.561C392.687 381.295 394.522 381.262 394.705 382.52L395.129 385.481H395.486L395.801 382.553C395.943 381.287 397.778 381.254 397.961 382.511L398.417 385.696H399.804L400.145 382.553C400.286 381.287 402.121 381.254 402.304 382.511L402.761 385.696H403.284L404.015 382.735C404.33 381.494 406.157 381.717 406.149 382.999L406.083 398.809H418.174V363.062C418.174 362.342 417.809 361.664 417.211 361.267L416.929 361.085C416.322 360.679 415.965 360.001 415.965 359.281V357.949C415.965 356.758 416.937 355.79 418.133 355.79H418.316C419.13 355.79 419.885 355.335 420.251 354.616L429.369 336.895C429.743 336.175 430.49 335.72 431.304 335.72H493.956C494.803 335.72 495.575 336.209 495.932 336.97L504.486 355.36C504.619 355.641 504.694 355.956 504.694 356.27V363.137C504.694 363.674 505.134 364.113 505.674 364.113C506.213 364.113 506.662 364.551 506.662 365.089V398.809H569.878L600.921 372.303C601.32 371.972 601.81 371.79 602.333 371.79H613.736C614.259 371.79 614.765 371.98 615.156 372.319L619.906 376.439L628.111 283.155H631.906L647.42 398.809H657.303V358.959C657.303 358.512 657.444 358.074 657.701 357.71L678.837 327.836C679.053 327.53 679.335 327.299 679.642 327.15V326.38H743.681C744.636 326.38 745.483 327.001 745.757 327.911L750.79 344.308C751.064 345.218 751.911 345.838 752.866 345.838H762.657C763.845 345.838 764.825 346.806 764.825 347.997V405.286H784.357V358.901C784.357 358.487 784.482 358.082 784.706 357.734L803.018 329.342C804.023 327.77 806.415 328.126 806.921 329.921L828.298 405.286H852.199V390.95C852.199 390.304 851.684 389.783 851.036 389.783C850.388 389.783 849.865 389.262 849.865 388.617V384.505C849.865 383.562 849.093 382.793 848.138 382.793C846.95 382.793 846.111 381.593 846.535 380.476L856.825 353.441C857.14 352.597 857.938 352.043 858.851 352.043H915.805C916.328 352.043 916.752 351.629 916.752 351.108C916.752 350.587 916.328 350.173 915.805 350.173H915.34C914.568 350.173 913.937 349.544 913.937 348.775V348.543C913.937 347.642 914.676 346.914 915.573 346.914H942.231C943.385 346.914 944.332 347.848 944.332 349.007V349.701C944.332 350.471 943.701 351.1 942.92 351.1H941.99C941.733 351.1 941.525 351.306 941.525 351.563C941.525 351.819 941.733 352.026 941.99 352.026H987.052C987.824 352.026 988.53 352.423 988.921 353.085L1005.17 380.476C1005.77 381.494 1005.05 382.776 1003.85 382.776C1003.02 382.776 1002.32 383.454 1002.32 384.298V387.599C1002.32 388.79 1001.36 389.758 1000.16 389.758H999.817C998.629 389.758 997.649 390.726 997.649 391.918V397.692H1011.91V344.448C1011.91 343.911 1012.35 343.472 1012.89 343.472C1013.43 343.472 1013.88 343.034 1013.88 342.496V323.113C1013.88 321.921 1014.84 320.953 1016.04 320.953H1101.39C1102.58 320.953 1103.56 321.921 1103.56 323.113V342.496C1103.56 343.034 1104 343.472 1104.54 343.472C1105.08 343.472 1105.53 343.911 1105.53 344.448V351.174H1126.81L1131.64 335.447C1131.91 334.537 1132.76 333.917 1133.71 333.917H1195.59C1196.77 333.917 1197.75 334.885 1197.75 336.076V351.174H1272.11L1281.14 333.603C1281.51 332.883 1282.26 332.428 1283.08 332.428H1345.73C1346.57 332.428 1347.35 332.916 1347.7 333.677L1356.26 352.067C1356.39 352.349 1356.47 352.663 1356.47 352.977V359.844C1356.47 360.382 1356.91 360.82 1357.45 360.82C1357.99 360.82 1358.43 361.259 1358.43 361.796V397.684H1419.13L1453.31 368.497H1466.33L1499.96 397.684H1509.09V355.674C1509.09 355.228 1509.23 354.789 1509.49 354.425L1530.63 324.552C1530.84 324.246 1531.12 324.014 1531.43 323.866V323.096H1595.47C1596.42 323.096 1597.27 323.717 1597.55 324.627L1602.58 341.023C1602.85 341.933 1603.7 342.554 1604.65 342.554H1614.45C1615.63 342.554 1616.61 343.522 1616.61 344.713V397.675H1636.15V395.996C1636.15 394.805 1637.12 393.837 1638.31 393.837H1656.22V382.553C1656.22 381.957 1656.71 381.469 1657.31 381.469H1659.47V356.609C1658.88 356.609 1658.39 356.121 1658.39 355.526V353.366C1658.39 352.771 1658.88 352.283 1659.47 352.283V350.123C1658.88 350.123 1658.39 349.635 1658.39 349.04V346.88C1658.39 346.285 1658.88 345.797 1659.47 345.797V323.096H1658.39C1657.79 323.096 1657.3 322.608 1657.3 322.012V314.443C1657.3 313.847 1657.79 313.359 1658.39 313.359H1660.55V311.2H1659.47C1658.87 311.2 1658.38 310.712 1658.38 310.116V307.957C1658.38 307.361 1658.87 306.873 1659.47 306.873H1660.55V305.789H1659.47C1658.87 305.789 1658.38 305.301 1658.38 304.706V302.546C1658.38 301.951 1658.87 301.463 1659.47 301.463H1660.55V292.818H1659.47C1658.87 292.818 1658.38 292.33 1658.38 291.734V289.575C1658.38 288.979 1658.87 288.491 1659.47 288.491H1660.55V283.089H1659.47C1658.87 283.089 1658.38 282.601 1658.38 282.005V280.921C1658.38 280.326 1658.87 279.838 1659.47 279.838H1660.55V270.101C1658.67 269.993 1657.09 268.57 1656.83 266.676C1656.06 261.05 1656.03 255.358 1656.73 249.733L1656.82 249.005C1656.97 247.863 1657.54 246.879 1658.38 246.2V241.99C1658.38 241.394 1658.87 240.906 1659.47 240.906H1660.55V230.093C1660.55 229.498 1661.04 229.01 1661.64 229.01ZM279.974 354.425H279.941V354.467H279.974V354.425Z",
    fill: "url(#paint4_linear_7001_52055)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.66 483.507H-12.6558V514.523H2298.66V483.507Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.83936 493.374L2285.79 493.194",
    stroke: "white",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.643 396.453H-0.397461V438.044H68.643V396.453Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.756 428.172H-0.322266V438.039H68.756V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09055 404.801H2.94141V410.217H4.09055V404.801Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 416.54H-1.02979V425.35H69.462V416.54Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61421 428.172H-0.322266V438.039H4.61421V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.756 428.172H-0.322266V438.039H68.756V428.172Z",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.775 428.172H8.13721V438.039H13.775V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2345 428.172H16.5967V438.039H22.2345V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6935 428.172H25.0557V438.039H30.6935V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1476 428.172H33.5098V438.039H39.1476V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6076 428.172H41.9697V438.039H47.6076V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.066 428.172H50.4282V438.039H56.066V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5265 428.172H58.8887V438.039H64.5265V428.172Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 403.855H-1.02979V413.723H69.462V403.855Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 403.855H-1.02979V405.264H69.462V403.855Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 416.54H-1.02979V417.948H69.462V416.54Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 428.172H-1.02979V429.58H69.462V428.172Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 396.453H-1.02979V401.034H69.462V396.453Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.462 396.453H-1.02979V397.861H69.462V396.453Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8128 399.27H-1.38037V401.384H69.8128V399.27Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31556 403.855H-0.322266V410.2H5.31556V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6603 403.855H6.02246V410.2H11.6603V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0045 403.855H12.3667V410.2H18.0045V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3493 403.855H18.7114V410.2H24.3493V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6935 403.855H25.0557V410.2H30.6935V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0333 403.855H31.3955V410.2H37.0333V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3771 403.855H37.7393V410.2H43.3771V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7228 403.855H44.085V410.2H49.7228V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.066 403.855H50.4282V410.2H56.066V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4108 403.855H56.7729V410.2H62.4108V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7555 403.855H63.1177V410.2H68.7555V403.855Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31556 416.54H-0.322266V422.178H5.31556V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6603 416.54H6.02246V422.178H11.6603V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0045 416.54H12.3667V422.178H18.0045V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3493 416.54H18.7114V422.178H24.3493V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6935 416.54H25.0557V422.178H30.6935V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0333 416.54H31.3955V422.178H37.0333V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3771 416.54H37.7393V422.178H43.3771V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7228 416.54H44.085V422.178H49.7228V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.066 416.54H50.4282V422.178H56.066V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4108 416.54H56.7729V422.178H62.4108V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7555 416.54H63.1177V422.178H68.7555V416.54Z",
    fill: "#FAEAC7",
    stroke: "#3A3A36",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.112 468.072L577.045 466.227C582.743 465.865 587.587 461.927 589.103 456.424L589.778 453.969C590.085 452.853 590.107 451.682 589.848 450.554L589.222 447.884C587.76 441.609 578.896 441.426 577.175 447.636L574.914 443.303C571.785 437.309 562.808 438.885 561.896 445.58C559.49 436.797 547.276 436.155 543.963 444.641L543.828 444.981L542.312 443.368C538.023 438.793 530.697 439.004 526.672 443.816C523.133 448.051 523.494 454.309 527.503 458.107L531.198 461.603C527.271 463.654 528.992 469.615 533.41 469.259L548.106 468.067L548.112 468.072Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.01 468.072L734.943 466.227C740.646 465.865 745.48 461.927 747.007 456.424L747.681 453.969C747.983 452.853 748.01 451.682 747.746 450.554L747.125 447.884C745.658 441.609 736.799 441.426 735.073 447.636L732.818 443.303C729.689 437.309 720.706 438.885 719.799 445.58C717.393 436.797 705.179 436.155 701.866 444.641L701.731 444.981L700.215 443.368C695.932 438.793 688.6 439.004 684.575 443.816C681.036 448.051 681.398 454.309 685.406 458.107L689.102 461.603C685.174 463.654 686.895 469.615 691.314 469.259L706.01 468.067V468.072Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.529 468.072L492.462 466.227C498.16 465.865 503.004 461.927 504.52 456.424L505.195 453.969C505.502 452.853 505.524 451.682 505.265 450.554L504.639 447.884C503.177 441.609 494.313 441.426 492.592 447.636L490.331 443.303C487.202 437.309 478.225 438.885 477.313 445.58C474.907 436.797 462.693 436.155 459.38 444.641L459.245 444.981L457.729 443.368C453.44 438.793 446.114 439.004 442.089 443.816C438.55 448.051 438.911 454.309 442.92 458.107L446.615 461.603C442.688 463.654 444.409 469.615 448.827 469.259L463.523 468.067L463.529 468.072Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.436 462.662L654.253 454.489C659.729 452.881 663.586 447.971 663.856 442.269L663.975 439.728C664.029 438.573 663.791 437.424 663.29 436.383L662.092 433.912C659.281 428.118 650.595 429.887 650.282 436.324L647.121 432.596C642.751 427.438 634.34 430.95 634.928 437.683C630.644 429.644 618.586 431.711 617.227 440.72L617.173 441.082L615.338 439.841C610.143 436.324 603.043 438.142 600.184 443.726C597.664 448.635 599.396 454.661 604.144 457.483L608.519 460.083C605.142 462.948 608.13 468.386 612.36 467.065L626.436 462.668V462.662Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.806 456.571L819.693 449.137C815.112 446.725 812.334 441.897 812.544 436.728L812.749 431.894C812.798 430.642 813.159 429.429 813.801 428.35L815.506 425.458C819.072 419.426 828.33 422.156 828.044 429.159L831.999 425.161C837.167 419.939 845.977 424.497 844.699 431.732C850.11 423.294 863.161 426.693 863.776 436.701L865.955 435.439C871.917 431.986 879.551 434.586 882.167 440.958C884.417 446.445 882.06 452.741 876.767 455.406L871.394 458.119H840.048C837.869 458.119 835.727 457.591 833.801 456.576L833.806 456.571Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.954 454.032L819.395 450.363C816.126 447.736 814.275 443.727 814.399 439.535L814.561 434.108C814.588 432.953 814.912 431.826 815.5 430.827L816.881 428.459C820.124 422.897 828.648 425.325 828.47 431.761L831.901 428.286C836.654 423.479 844.774 427.617 843.673 434.291C848.556 426.603 860.419 429.581 861.094 438.666L861.121 439.033L865.302 436.233C869.321 433.547 874.587 433.638 878.503 436.465L879.928 437.49C883.515 440.08 884.81 444.828 883.035 448.885C882.156 450.913 880.575 452.559 878.595 453.541L868.301 458.639H843.673L830.568 456.88C828.151 456.556 825.859 455.575 823.954 454.042V454.032Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.171 430.352H667.52V449.321H691.171V430.352Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.291 429.608H667.401V430.078H691.291V429.608Z",
    stroke: "#615E66",
    strokeWidth: 0.356074
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.554 426.564L667.801 429.418H690.897L689.144 426.564C688.949 426.251 688.61 426.062 688.243 426.062H670.455C670.088 426.062 669.748 426.251 669.554 426.564Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.171 442.84H667.52V449.319H691.171V442.84Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.502 444.718H669.711V447.135H671.502V444.718Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.559 444.718H673.768V447.135H675.559V444.718Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.304 444.718H682.513V447.135H684.304V444.718Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.675 444.718H686.884V447.135H688.675V444.718Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.367 436.599H687.196V441.201H688.367V436.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.367 431.597H687.196V433.701H688.367V431.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.996 436.599H683.139V441.201H683.996V436.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.996 431.597H683.139V433.701H683.996V431.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.622 436.599H678.764V441.201H679.622V436.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.622 431.597H678.764V433.701H679.622V431.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.252 436.599H674.395V441.201H675.252V436.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.252 431.597H674.395V433.701H675.252V431.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.19 436.599H670.332V441.201H671.19V436.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.19 431.597H670.332V433.701H671.19V431.597Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.241 444.718H678.45V449.32H680.241V444.718Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.785 421.828H899.744V449.321H968.785V421.828Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.785 441.118H899.744V449.319H968.785V441.118Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.239 427.396H903.09V430.773H904.239V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.998 423.705H897.539V424.816H970.998V423.705Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.239 435.186H903.09V438.563H904.239V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.612 442.975H901.234V449.319H904.612V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.518 442.975H908.285V449.319H913.518V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.681 442.975H916.448V449.319H921.681V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.844 442.975H924.61V449.319H929.844V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.023 444.11C932.023 442.869 933.032 441.865 934.273 441.865C935.514 441.865 936.512 442.869 936.512 444.11V449.321H932.023V444.11Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.942 442.975H938.709V449.319H943.942V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.104 442.975H946.871V449.319H952.104V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.634 442.975H955.4V449.319H960.634V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.94 442.975H963.935V449.319H966.94V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.546 427.396H909.396V430.773H910.546V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.546 435.186H909.396V438.563H910.546V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.63 427.396H913.48V430.773H914.63V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.63 435.186H913.48V438.563H914.63V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.709 427.396H917.56V430.773H918.709V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.709 435.186H917.56V438.563H918.709V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.416 427.396H921.267V430.773H922.416V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.416 435.186H921.267V438.563H922.416V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.872 427.396H925.723V430.773H926.872V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.872 435.186H925.723V438.563H926.872V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.577 427.396H929.428V430.773H930.577V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.577 435.186H929.428V438.563H930.577V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.034 427.396H933.885V430.773H935.034V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.034 435.186H933.885V438.563H935.034V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.485 427.396H938.336V430.773H939.485V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.485 435.186H938.336V438.563H939.485V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.563 427.396H942.414V430.773H943.563V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.563 435.186H942.414V438.563H943.563V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.27 427.396H946.121V430.773H947.27V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.27 435.186H946.121V438.563H947.27V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.727 427.396H950.578V430.773H951.727V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.727 435.186H950.578V438.563H951.727V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.811 427.396H954.662V430.773H955.811V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.811 435.186H954.662V438.563H955.811V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.516 427.396H958.367V430.773H959.516V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.516 435.186H958.367V438.563H959.516V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.452 427.396H964.303V430.773H965.452V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.452 435.186H964.303V438.563H965.452V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.907 421.828H898.639V423.722H969.907V421.828Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.975 421.828H724.935V449.321H793.975V421.828Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.088 442.975H725.01V449.319H794.088V442.975Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.423 427.396H728.273V430.773H729.423V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.188 423.705H722.729V424.816H796.188V423.705Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.088 435.222H725.01V440.86H794.088V435.222Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.946 442.975H725.01V449.319H729.946V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.088 442.975H725.01V449.319H794.088V442.975Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.702 442.975H733.469V449.319H738.702V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.273 442.975H742.635V449.319H748.273V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.028 442.975H749.795V449.319H755.028V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.213 444.11C757.213 442.869 758.222 441.865 759.463 441.865C760.704 441.865 761.702 442.869 761.702 444.11V449.321H757.213V444.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.126 442.975H763.893V449.319H769.126V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.289 442.975H772.056V449.319H777.289V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.817 442.975H780.584V449.319H785.817V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.093 442.975H789.156V449.319H794.093V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.501 426.763H725.01V433.107H795.501V426.763Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.501 426.763H725.01V427.469H795.501V426.763Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.501 435.222H725.01V435.928H795.501V435.222Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.501 442.975H725.01V443.681H795.501V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.635 435.186H789.486V438.563H790.635V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.097 421.828H723.828V424.423H795.097V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.501 421.828H725.01V422.535H795.501V421.828Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.82 421.828H1508.78V449.321H1577.82V421.828Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.93 442.975H1508.85V449.319H1577.93V442.975Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.27 427.396H1512.12V430.773H1513.27V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.03 423.705H1506.57V424.816H1580.03V423.705Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.93 435.222H1508.85V440.86H1577.93V435.222Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.79 442.975H1508.85V449.319H1513.79V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.93 442.975H1508.85V449.319H1577.93V442.975Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522.55 442.975H1517.31V449.319H1522.55V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.11 442.975H1526.47V449.319H1532.11V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.87 442.975H1533.64V449.319H1538.87V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.05 444.11C1541.05 442.869 1542.06 441.865 1543.3 441.865C1544.54 441.865 1545.54 442.869 1545.54 444.11V449.321H1541.05V444.11Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.97 442.975H1547.73V449.319H1552.97V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.13 442.975H1555.9V449.319H1561.13V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1569.66 442.975H1564.43V449.319H1569.66V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.94 442.975H1573V449.319H1577.94V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.34 426.763H1508.85V433.107H1579.34V426.763Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.34 426.763H1508.85V427.469H1579.34V426.763Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.34 435.222H1508.85V435.928H1579.34V435.222Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.34 442.975H1508.85V443.681H1579.34V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.48 435.186H1573.33V438.563H1574.48V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.94 421.828H1507.67V424.423H1578.94V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.34 421.828H1508.85V422.535H1579.34V421.828Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.51 407.73H1736.46V449.321H1805.51V407.73Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.61 439.453H1736.54V449.321H1805.61V439.453Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740.95 416.081H1739.8V421.498H1740.95V416.081Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.32 427.821H1735.83V436.631H1806.32V427.821Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.47 439.453H1736.54V449.321H1741.47V439.453Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.61 439.453H1736.54V449.321H1805.61V439.453Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.63 439.453H1745V449.321H1750.63V439.453Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.09 439.453H1753.45V449.321H1759.09V439.453Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.54 439.453H1761.91V449.321H1767.54V439.453Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776 439.453H1770.37V449.321H1776V439.453Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.46 439.453H1778.83V449.321H1784.46V439.453Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.92 439.453H1787.29V449.321H1792.92V439.453Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.38 439.453H1795.75V449.321H1801.38V439.453Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.32 415.131H1735.83V424.998H1806.32V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.32 415.131H1735.83V416.539H1806.32V415.131Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.32 427.821H1735.83V429.229H1806.32V427.821Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.32 439.453H1735.83V440.861H1806.32V439.453Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.32 407.73H1735.83V412.311H1806.32V407.73Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.32 407.73H1735.83V409.139H1806.32V407.73Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.67 410.552H1735.48V412.667H1806.67V410.552Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.17 415.131H1736.54V421.475H1742.17V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.52 415.131H1742.88V421.475H1748.52V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.86 415.131H1749.22V421.475H1754.86V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.2 415.131H1755.56V421.475H1761.2V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.54 415.131H1761.91V421.475H1767.54V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.89 415.131H1768.25V421.475H1773.89V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.23 415.131H1774.6V421.475H1780.23V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.58 415.131H1780.94V421.475H1786.58V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.92 415.131H1787.29V421.475H1792.92V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.27 415.131H1793.63V421.475H1799.27V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.61 415.131H1799.97V421.475H1805.61V415.131Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.17 427.821H1736.54V433.459H1742.17V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.52 427.821H1742.88V433.459H1748.52V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.86 427.821H1749.22V433.459H1754.86V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.2 427.821H1755.56V433.459H1761.2V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.54 427.821H1761.91V433.459H1767.54V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.89 427.821H1768.25V433.459H1773.89V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.23 427.821H1774.6V433.459H1780.23V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.58 427.821H1780.94V433.459H1786.58V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.92 427.821H1787.29V433.459H1792.92V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.27 427.821H1793.63V433.459H1799.27V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.61 427.821H1799.97V433.459H1805.61V427.821Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.44 421.828H1397.4V449.321H1466.44V421.828Z",
    fill: "#E4D4B1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.44 441.118H1397.4V449.319H1466.44V441.118Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401.89 427.396H1400.74V430.773H1401.89V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1468.65 423.705H1395.19V424.816H1468.65V423.705Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401.89 435.186H1400.74V438.563H1401.89V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.27 442.975H1398.89V449.319H1402.27V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.17 442.975H1405.94V449.319H1411.17V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.33 442.975H1414.1V449.319H1419.33V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.49 442.975H1422.26V449.319H1427.49V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.68 444.11C1429.68 442.869 1430.69 441.865 1431.93 441.865C1433.17 441.865 1434.17 442.869 1434.17 444.11V449.321H1429.68V444.11Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.59 442.975H1436.36V449.319H1441.59V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.76 442.975H1444.52V449.319H1449.76V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.28 442.975H1453.05V449.319H1458.28V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.6 442.975H1461.59V449.319H1464.6V442.975Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.2 427.396H1407.05V430.773H1408.2V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.2 435.186H1407.05V438.563H1408.2V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.28 427.396H1411.13V430.773H1412.28V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.28 435.186H1411.13V438.563H1412.28V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.37 427.396H1415.22V430.773H1416.37V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.37 435.186H1415.22V438.563H1416.37V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.07 427.396H1418.92V430.773H1420.07V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.07 435.186H1418.92V438.563H1420.07V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.53 427.396H1423.38V430.773H1424.53V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.53 435.186H1423.38V438.563H1424.53V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.23 427.396H1427.08V430.773H1428.23V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.23 435.186H1427.08V438.563H1428.23V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.69 427.396H1431.54V430.773H1432.69V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.69 435.186H1431.54V438.563H1432.69V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.14 427.396H1435.99V430.773H1437.14V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.14 435.186H1435.99V438.563H1437.14V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.22 427.396H1440.07V430.773H1441.22V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.22 435.186H1440.07V438.563H1441.22V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.93 427.396H1443.78V430.773H1444.93V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.93 435.186H1443.78V438.563H1444.93V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.38 427.396H1448.23V430.773H1449.38V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.38 435.186H1448.23V438.563H1449.38V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.46 427.396H1452.31V430.773H1453.46V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.46 435.186H1452.31V438.563H1453.46V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.17 427.396H1456.02V430.773H1457.17V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1457.17 435.186H1456.02V438.563H1457.17V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.11 427.396H1461.96V430.773H1463.11V427.396Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.11 435.186H1461.96V438.563H1463.11V435.186Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.56 421.828H1396.29V423.722H1467.56V421.828Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.218 407.448H431.919V449.319H445.218V407.448Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.341 409.703H445.482V449.319H451.341V409.703Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.717 407.448H435.421V449.319H441.717V407.448Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.909 407.448H451.61V449.319H464.909V407.448Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.407 407.448H455.111V449.319H461.407V407.448Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.402 407.448H458.607V449.319H461.402V407.448Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.711 407.448H438.916V449.319H441.711V407.448Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.584 400.441H437.363V407.272H437.584V400.441Z",
    stroke: "#615E66",
    strokeWidth: 0.167247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.211 404.951H439.99V407.271H440.211V404.951Z",
    stroke: "#615E66",
    strokeWidth: 0.167247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.69 409.703H1490.83V449.319H1496.69V409.703Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.55 399.27H1496.16V449.319H1509.55V399.27Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506.03 399.27H1499.69V449.319H1506.03V399.27Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506.04 399.27H1503.21V449.319H1506.04V399.27Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8271 405.613H-7.90186V449.319H17.8271V405.613Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7115 404.205H-8.78174V404.912H18.7115V404.205Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8271 405.613H-7.90186V408.435H17.8271V405.613Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8271 440.153H-7.90186V442.975H17.8271V440.153Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48816 405.613H-5.25879V435.923H5.48816V405.613Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72936 445.091H-5.25879V449.321H3.72936V445.091Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72884 445.091H0.027832V447.206H3.72884V445.091Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1884 445.091H6.2002V449.321H15.1884V445.091Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9012 445.091H6.2002V447.206H9.9012V445.091Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1829 445.091H11.4819V447.206H15.1829V445.091Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48816 409.845H-5.25879V416.896H5.48816V409.845Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48816 419.712H-5.25879V426.763H5.48816V419.712Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48816 428.879H-5.25879V435.93H5.48816V428.879Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31506 409.845H3.2002V416.896H5.31506V409.845Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31506 419.712H3.2002V426.763H5.31506V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31506 428.879H3.2002V435.93H5.31506V428.879Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8271 437.338H-7.90186V438.045H17.8271V437.338Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1829 409.845H10.6025V416.896H15.1829V409.845Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1829 419.712H10.6025V426.763H15.1829V419.712Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1829 428.879H10.6025V435.93H15.1829V428.879Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1835 409.845H13.7754V416.896H15.1835V409.845Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1835 419.712H13.7754V426.763H15.1835V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1835 428.879H13.7754V435.93H15.1835V428.879Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96517 409.845H-2.61523V416.896H1.96517V409.845Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96517 419.712H-2.61523V426.763H1.96517V419.712Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.96517 428.879H-2.61523V435.93H1.96517V428.879Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.92 388.701H1219.84V449.32H1245.92V388.701Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.64 387.287H1219.14V387.994H1246.64V387.287Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.75 388.701H1220.02V391.523H1245.75V388.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.75 423.24H1220.02V426.062H1245.75V423.24Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.41 388.701H1222.67V419.011H1233.41V388.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.83 443.682H1222.67V449.319H1231.83V443.682Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.83 443.682H1226.9V449.319H1231.83V443.682Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.76 443.682H1233.59V449.319H1242.76V443.682Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 443.682H1238.17V449.319H1243.11V443.682Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.37 428.172H1222.67V430.287H1226.37V428.172Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.65 428.172H1227.95V430.287H1231.65V428.172Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 428.172H1234.12V432.402H1243.11V428.172Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.82 428.172H1234.12V430.287H1237.82V428.172Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 428.172H1239.41V430.287H1243.11V428.172Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.41 392.932H1222.67V399.983H1233.41V392.932Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.41 402.799H1222.67V409.85H1233.41V402.799Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.41 411.958H1222.67V419.009H1233.41V411.958Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.24 392.932H1231.12V399.983H1233.24V392.932Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.24 402.799H1231.12V409.85H1233.24V402.799Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.24 411.958H1231.12V419.009H1233.24V411.958Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.75 420.42H1220.02V421.127H1245.75V420.42Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 392.932H1238.53V399.983H1243.11V392.932Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 402.799H1238.53V409.85H1243.11V402.799Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 411.958H1238.53V419.009H1243.11V411.958Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 392.932H1241.7V399.983H1243.11V392.932Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 402.799H1241.7V409.85H1243.11V402.799Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.11 411.958H1241.7V419.009H1243.11V411.958Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.89 392.932H1225.31V399.983H1229.89V392.932Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.89 402.799H1225.31V409.85H1229.89V402.799Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.89 411.958H1225.31V419.009H1229.89V411.958Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4795 449.669H47.5808C50.9797 449.669 54.2491 448.38 56.7308 446.06L59.11 443.837C59.752 443.233 60.2268 442.472 60.475 441.625L60.6692 440.961C62.0395 436.322 56.4071 432.842 52.8733 436.138V433.63C52.8733 428.526 46.464 426.249 43.2432 430.209C44.7807 424.026 37.6808 419.354 32.6149 423.212L31.2068 424.28L30.8129 423.05C29.4534 418.809 24.846 416.543 20.6594 418.059C16.4945 419.565 14.4012 424.215 16.0251 428.332L16.7642 430.209C10.5545 430.209 7.08011 437.368 10.9214 442.245L13.8401 445.957C15.6852 448.299 18.5014 449.669 21.4849 449.669H21.4795Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1804 451.389L48.2331 453.995C52.0744 454.378 55.8941 453.088 58.7157 450.45L60.5176 448.767C61.1596 448.163 61.6344 447.402 61.8826 446.555L62.0768 445.891C63.4471 441.252 57.8147 437.772 54.2809 441.068V438.56C54.2809 433.456 47.8716 431.179 44.6508 435.139C46.1884 428.956 39.0885 424.284 34.0225 428.142L32.6144 429.21L30.1381 426.351C28.1689 424.079 24.9426 423.362 22.202 424.592C19.7526 425.692 18.1773 428.126 18.1773 430.812V435.139C12.9656 435.139 10.2303 441.322 13.7263 445.179L16.9634 448.751C18.3175 450.245 20.1788 451.179 22.1804 451.384V451.389Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6366 449.318L23.292 426.055",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5677 429.935L28.2231 443.325",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2979 440.509L27.8722 443.681",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.684 449.669H825.785C829.174 449.669 832.448 448.38 834.93 446.06L837.315 443.837C837.957 443.233 838.426 442.472 838.674 441.625L838.874 440.961C840.239 436.322 834.612 432.842 831.078 436.138V433.63C831.078 428.526 824.663 426.249 821.448 430.209C822.985 424.026 815.886 419.354 810.82 423.212L809.411 424.28L809.018 423.05C807.658 418.809 803.056 416.543 798.859 418.059C794.699 419.565 792.6 424.215 794.23 428.332L794.969 430.209C788.759 430.209 785.29 437.368 789.126 442.245L792.05 445.957C793.89 448.299 796.711 449.669 799.69 449.669H799.684Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.288 449.667H824.361C827.587 449.667 830.705 448.497 833.138 446.376L835.043 444.715C835.642 444.191 836.084 443.512 836.327 442.751C837.643 438.586 832.669 435.273 829.367 438.144V436.379C829.367 431.75 823.622 429.603 820.584 433.094C822.014 427.737 815.955 423.534 811.434 426.744L809.611 428.044L809.271 427.062C808.003 423.367 803.989 421.392 800.288 422.644C796.377 423.965 794.418 428.33 796.026 432.128L796.436 433.099C790.911 433.099 787.906 439.557 791.472 443.781L793.954 446.727C795.524 448.594 797.844 449.673 800.293 449.673L800.288 449.667Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.337 447.959C743.337 444.948 743.958 441.976 745.156 439.219L746.359 436.457C748.689 431.094 756.307 431.094 758.638 436.457L759.841 439.219C761.039 441.976 761.659 444.948 761.659 447.959C761.659 448.709 761.055 449.318 760.299 449.318H744.692C743.936 449.318 743.332 448.709 743.332 447.959H743.337Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.809 447.614C745.809 445.159 746.321 442.731 747.319 440.487L747.891 439.203C750.076 434.283 757.057 434.283 759.242 439.203L759.814 440.487C760.807 442.731 761.325 445.159 761.325 447.614C761.325 448.358 760.721 448.968 759.971 448.968H747.168C746.418 448.968 745.814 448.364 745.814 447.614H745.809Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.504 444.03V449.668",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.083 442.623L752.503 446.853",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.98 444.737L752.503 448.616",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.528 449.668H774.904C776.717 449.668 778.454 448.983 779.782 447.748L780.731 446.857C781.049 446.566 781.276 446.199 781.395 445.789L781.486 445.487C782.15 443.248 779.436 441.56 777.721 443.151V441.953C777.721 439.488 774.619 438.382 773.059 440.297C773.804 437.319 770.389 435.059 767.934 436.914L767.238 437.443L767.055 436.855C766.391 434.81 764.174 433.715 762.151 434.443C760.133 435.172 759.119 437.422 759.912 439.412L760.262 440.297C757.268 440.297 755.59 443.755 757.452 446.108L758.854 447.888C759.744 449.01 761.093 449.668 762.528 449.668Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.602 449.318L762.372 442.623",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.193 446.496L767.659 441.209",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.595 449.668L776.118 445.088",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.24 444.03L774.706 446.496",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.124 449.318L763.072 437.687",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.27 449.672H1500.37C1503.75 449.672 1507.03 448.383 1509.51 446.063L1511.9 443.84C1512.54 443.236 1513.01 442.475 1513.26 441.628L1513.45 440.964C1514.82 436.325 1509.19 432.845 1505.66 436.141V433.632C1505.66 428.529 1499.24 426.252 1496.03 430.212C1497.57 424.029 1490.47 419.357 1485.4 423.215L1483.99 424.283L1483.6 423.053C1482.24 418.812 1477.64 416.546 1473.44 418.062C1469.28 419.568 1467.18 424.218 1468.81 428.334L1469.55 430.212C1463.34 430.212 1459.87 437.371 1463.71 442.248L1466.63 445.96C1468.47 448.302 1471.29 449.672 1474.27 449.672H1474.27Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.87 449.67H1498.94C1502.17 449.67 1505.29 448.5 1507.72 446.379L1509.62 444.718C1510.22 444.194 1510.67 443.515 1510.91 442.754C1512.22 438.589 1507.25 435.276 1503.95 438.147V436.382C1503.95 431.753 1498.2 429.606 1495.17 433.097C1496.59 427.739 1490.54 423.537 1486.02 426.747L1484.19 428.047L1483.85 427.065C1482.58 423.369 1478.57 421.395 1474.87 422.647C1470.96 423.968 1469 428.333 1470.61 432.131L1471.02 433.102C1465.49 433.102 1462.49 439.56 1466.05 443.784L1468.54 446.73C1470.11 448.597 1472.43 449.676 1474.87 449.676L1474.87 449.67Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.41 448.969L1497.58 435.929",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.64 443.325L1505.33 441.917",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.58 432.757L1495.11 439.452",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.23 445.09L1487.71 440.153",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.66 471.525H-12.6558V478.577H2298.66V471.525Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.084 431.701H512.838V449.321H548.084V431.701Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.084 442.27H512.838V449.321H548.084V442.27Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.582 445.188H517.766V449.321H520.582V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.3 445.188H523.483V449.321H526.3V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.898 445.188H530.082V449.321H532.898V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.617 445.188H535.801V449.321H538.617V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.777 445.188H541.961V449.321H544.777V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.582 433.749H517.766V440.083H520.582V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.3 433.749H523.483V440.083H526.3V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.898 433.749H530.082V440.083H532.898V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.617 433.749H535.801V440.083H538.617V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.777 433.749H541.961V440.083H544.777V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.605 422.712L513.886 431.695H547.055L530.605 422.712Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.131 432.758L510.367 431.555L530.825 420.775L550.62 431.555L549.136 433.114L530.458 422.89L512.131 432.758Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.36 431.701H1243.11V449.321H1278.36V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.36 442.27H1243.11V449.321H1278.36V442.27Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.85 445.188H1248.04V449.321H1250.85V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.57 445.188H1253.75V449.321H1256.57V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.17 445.188H1260.35V449.321H1263.17V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.88 445.188H1266.06V449.321H1268.88V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.04 445.188H1272.23V449.321H1275.04V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.85 433.749H1248.04V440.083H1250.85V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.57 433.749H1253.75V440.083H1256.57V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.17 433.749H1260.35V440.083H1263.17V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.88 433.749H1266.06V440.083H1268.88V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.04 433.749H1272.23V440.083H1275.04V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.88 422.712L1244.16 431.695H1277.32L1260.88 422.712Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1242.4 432.758L1240.64 431.555L1261.1 420.775L1280.9 431.555L1279.41 433.114L1260.73 422.89L1242.4 432.758Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.78 431.701H1779.53V449.321H1814.78V431.701Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.78 442.27H1779.53V449.321H1814.78V442.27Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.28 445.188H1784.46V449.321H1787.28V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.99 445.188H1790.18V449.321H1792.99V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.59 445.188H1796.77V449.321H1799.59V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.3 445.188H1802.49V449.321H1805.3V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.47 445.188H1808.65V449.321H1811.47V445.188Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.28 433.749H1784.46V440.083H1787.28V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.99 433.749H1790.18V440.083H1792.99V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.59 433.749H1796.77V440.083H1799.59V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.3 433.749H1802.49V440.083H1805.3V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.47 433.749H1808.65V440.083H1811.47V433.749Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.3 422.712L1780.58 431.695H1813.74L1797.3 422.712Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.82 432.758L1777.06 431.555L1797.52 420.775L1817.32 431.555L1815.83 433.114L1797.15 422.89L1778.82 432.758Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.083 435.572C627.872 435.572 657.696 405.748 657.696 368.959C657.696 332.171 627.872 302.347 591.083 302.347C554.295 302.347 524.471 332.171 524.471 368.959C524.471 405.748 554.295 435.572 591.083 435.572ZM591.083 429.934C624.759 429.934 652.058 402.635 652.058 368.959C652.058 335.283 624.759 307.985 591.083 307.985C557.408 307.985 530.109 335.283 530.109 368.959C530.109 402.635 557.408 429.934 591.083 429.934Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.083 404.557C610.743 404.557 626.68 388.777 626.68 369.311C626.68 349.846 610.743 334.065 591.083 334.065C571.423 334.065 555.486 349.846 555.486 369.311C555.486 388.777 571.423 404.557 591.083 404.557ZM591.083 399.626C608.018 399.626 621.748 386.058 621.748 369.317C621.748 352.576 608.018 339.007 591.083 339.007C574.148 339.007 560.417 352.576 560.417 369.317C560.417 386.058 574.148 399.626 591.083 399.626Z",
    fill: "#EBC7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.083 435.572C627.873 435.572 657.696 405.749 657.696 368.959C657.696 332.17 627.873 302.347 591.083 302.347C554.294 302.347 524.471 332.17 524.471 368.959C524.471 405.749 554.294 435.572 591.083 435.572Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.785 429.934V435.571",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.451 428.879L578.394 434.166",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.083 429.936C624.759 429.936 652.058 402.637 652.058 368.961C652.058 335.286 624.759 307.986 591.083 307.986C557.408 307.986 530.108 335.286 530.108 368.961C530.108 402.637 557.408 429.936 591.083 429.936Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.084 422.889C620.865 422.889 645.007 398.904 645.007 369.316C645.007 339.729 620.865 315.743 591.084 315.743C561.303 315.743 537.16 339.729 537.16 369.316C537.16 398.904 561.303 422.889 591.084 422.889Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.083 415.838C616.582 415.838 637.254 395.01 637.254 369.316C637.254 343.623 616.582 322.795 591.083 322.795C565.584 322.795 544.912 343.623 544.912 369.316C544.912 395.01 565.584 415.838 591.083 415.838Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.083 410.201C613.469 410.201 631.616 391.897 631.616 369.317C631.616 346.738 613.469 328.434 591.083 328.434C568.697 328.434 550.55 346.738 550.55 369.317C550.55 391.897 568.697 410.201 591.083 410.201Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.083 404.564C610.742 404.564 626.68 388.784 626.68 369.318C626.68 349.852 610.742 334.072 591.083 334.072C571.424 334.072 555.486 349.852 555.486 369.318C555.486 388.784 571.424 404.564 591.083 404.564Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.083 399.627C608.02 399.627 621.749 386.057 621.749 369.317C621.749 352.578 608.02 339.008 591.083 339.008C574.147 339.008 560.418 352.578 560.418 369.317C560.418 386.057 574.147 399.627 591.083 399.627Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.084 388.351C601.789 388.351 610.468 379.829 610.468 369.317C610.468 358.805 601.789 350.283 591.084 350.283C580.378 350.283 571.699 358.805 571.699 369.317C571.699 379.829 580.378 388.351 591.084 388.351Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.318 440.152H628.795C627.948 438.744 628.444 436.98 628.795 436.273H632.318C633.165 437.967 632.669 439.564 632.318 440.152Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.105 444.384H612.582C611.735 442.976 612.232 441.212 612.582 440.505H616.105C616.952 442.199 616.456 443.796 616.105 444.384Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.301 447.205H597.778C596.931 445.797 597.427 444.033 597.778 443.326H601.301C602.148 445.02 601.651 446.617 601.301 447.205Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.797 447.205H582.274C581.427 445.797 581.923 444.033 582.274 443.326H585.797C586.644 445.02 586.147 446.617 585.797 447.205Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.699 445.09H568.176C567.329 443.682 567.825 441.918 568.176 441.211H571.699C572.546 442.905 572.05 444.502 571.699 445.09Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.008 430.993H641.485C640.638 429.585 641.134 427.821 641.485 427.114H645.008C645.855 428.808 645.358 430.405 645.008 430.993Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.283 418.304H652.76C651.913 416.896 652.409 415.132 652.76 414.425H656.283C657.13 416.119 656.634 417.716 656.283 418.304Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.041 404.206H660.518C659.671 402.798 660.167 401.034 660.518 400.327H664.041C664.888 402.021 664.391 403.618 664.041 404.206Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.678 388.701H666.155C665.308 387.293 665.805 385.529 666.155 384.822H669.678C670.526 386.516 670.029 388.113 669.678 388.701Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.086 372.488H667.563C666.716 371.08 667.212 369.316 667.563 368.609H671.086C671.933 370.303 671.436 371.9 671.086 372.488Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.972 356.272H665.449C664.602 354.864 665.099 353.099 665.449 352.393H668.972C669.819 354.087 669.323 355.684 668.972 356.272Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.334 340.766H659.811C658.964 339.358 659.46 337.593 659.811 336.887H663.334C664.181 338.581 663.684 340.178 663.334 340.766Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.582 325.963H652.059C651.212 324.555 651.708 322.791 652.059 322.084H655.582C656.429 323.778 655.932 325.375 655.582 325.963Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.301 314.688H640.778C639.931 313.28 640.427 311.515 640.778 310.809H644.301C645.148 312.503 644.651 314.1 644.301 314.688Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.91 304.819H627.387C626.54 303.411 627.036 301.647 627.387 300.94H630.91C631.757 302.634 631.261 304.231 630.91 304.819Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.105 299.175H612.582C611.735 297.767 612.232 296.003 612.582 295.296H616.105C616.952 296.99 616.456 298.587 616.105 299.175Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.894 295.652H596.371C595.524 294.244 596.021 292.48 596.371 291.773H599.894C600.741 293.467 600.245 295.064 599.894 295.652Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.681 296.36H580.158C579.311 294.951 579.808 293.187 580.158 292.48H583.681C584.528 294.175 584.032 295.771 583.681 296.36Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.469 299.883H563.947C563.099 298.475 563.596 296.711 563.947 296.004H567.469C568.317 297.698 567.82 299.295 567.469 299.883Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.373 306.226H549.85C549.003 304.818 549.499 303.053 549.85 302.347H553.373C554.22 304.041 553.723 305.638 553.373 306.226Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.976 316.095H536.453C535.606 314.687 536.103 312.923 536.453 312.216H539.976C540.823 313.91 540.327 315.507 539.976 316.095Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.402 328.077H525.879C525.032 326.669 525.528 324.905 525.879 324.198H529.402C530.249 325.892 529.753 327.489 529.402 328.077Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.948 342.881H517.425C516.578 341.473 517.074 339.709 517.425 339.002H520.948C521.795 340.696 521.299 342.293 520.948 342.881Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.717 357.686H513.195C512.348 356.278 512.844 354.513 513.195 353.807H516.717C517.565 355.501 517.068 357.098 516.717 357.686Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.304 373.899H511.781C510.934 372.49 511.431 370.726 511.781 370.02H515.304C516.151 371.714 515.655 373.311 515.304 373.899Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.717 390.11H513.195C512.348 388.701 512.844 386.937 513.195 386.23H516.717C517.565 387.925 517.068 389.521 516.717 390.11Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.649 405.613H518.126C517.279 404.205 517.776 402.441 518.126 401.734H521.649C522.496 403.428 522 405.025 521.649 405.613Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.109 419.712H526.586C525.739 418.304 526.235 416.54 526.586 415.833H530.109C530.956 417.527 530.46 419.124 530.109 419.712Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.39 431.7H537.867C537.02 430.292 537.517 428.528 537.867 427.821H541.39C542.237 429.515 541.741 431.112 541.39 431.7Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.78 440.861H551.257C550.41 439.453 550.906 437.689 551.257 436.982H554.78C555.627 438.676 555.131 440.273 554.78 440.861Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.758 326.319L590.377 368.967",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.682 314.686L590.375 368.96",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.373 305.876L590.378 368.61",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.469 299.883L590.732 368.61",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.623 296.359L590.732 368.61",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.777 295.651L591.082 367.551",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.932 299.175L591.082 368.609",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.385 304.817L591.082 368.965",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.425 313.272L591.082 368.96",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.701 324.203L591.082 368.966",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.455 337.594L591.785 368.961",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.448 352.397L591.434 368.96",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.971 368.609L590.727 369.316",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.564 384.822L591.79 369.316",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.275 399.977L591.082 369.312",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.524 414.428L590.732 368.964",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.599 427.114L591.439 369.312",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.553 436.28L590.727 368.961",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.697 440.154L590.732 368.961",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.298 339.357L590.732 369.316",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.069 354.512L590.377 369.316",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.66 370.372L591.083 368.964",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.718 386.23L590.733 369.312",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.24 401.739L591.789 368.964",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.345 415.838L590.377 369.316",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.625 427.82L591.434 368.609",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.016 436.98L591.078 368.604",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.877 441.211L591.083 368.254",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.031 443.325L591.083 368.609",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.893 442.975L590.727 368.609",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.43 320.324L551.258 315.743",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.911 328.783L540.682 325.61",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.863 339.358L533.282 336.536",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.573 350.991L527.286 349.583",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.108 364.028L525.172 363.321",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.459 376.713L525.172 377.42",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.281 389.052L528.345 391.167",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.918 400.327L534.338 403.149",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.32 410.552L542.441 414.431",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.188 419.01L553.016 423.59",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.705 313.274L563.239 308.693",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.687 309.398L576.279 304.111",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.376 302.347V307.985",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.474 303.763L603.417 309.05",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.87 307.991L615.404 312.928",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.852 315.038L626.68 319.268",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.072 323.847L635.842 327.726",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.53 335.479L643.949 337.944",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.168 347.817L649.231 349.582",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.34 361.559L651.702 362.265",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.34 375.655L652.053 374.948",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.875 388.702L649.588 387.294",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.885 401.384L644.305 398.562",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.778 412.664L636.898 409.492",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.553 422.183L627.381 417.953",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.22 429.227L616.105 424.646",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.532 428.527L606.94 433.464",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.723 303.054L568.171 306.226",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.303 310.807L564.297 299.531",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.82 296.359L581.567 303.055",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.699 305.169L579.808 295.302",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.388 293.889L594.962 302.348",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.446 302.703L596.021 293.893",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.055 304.82L600.596 294.597",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.543 302.703L612.232 295.651",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.456 298.476L622.45 310.107",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.934 305.876L626.68 302.704",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.554 304.817L633.726 317.857",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.623 311.515L640.778 310.809",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.898 320.675L652.053 322.083",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.242 327.375V314.686",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.064 331.25L661.219 336.537",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.995 339.709L652.759 325.962",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.408 342.531L667.212 352.399",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.932 353.106L660.868 340.772",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.283 355.57L668.616 368.61",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.45 355.921L657.697 366.846",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.697 370.725L667.565 384.471",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.639 380.943L667.213 371.426",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.283 384.114L662.277 399.976",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.76 393.988L665.8 385.879",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.702 397.156L654.524 414.075",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.415 406.321L660.162 401.74",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.3 409.143L643.949 426.763",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.76 414.779L636.898 417.245",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.784 419.359L631.261 436.278",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.329 425.354L641.484 427.119",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.794 436.28L612.231 432.757",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.507 426.763L616.456 440.86",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.699 432.757L554.78 436.987",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.658 427.47L568.175 440.86",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.511 408.789L522.006 402.795",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.166 398.212L527.994 415.481",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.46 396.804L517.42 387.994",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.586 385.529L520.592 401.741",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.47 368.611L516.718 357.686",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.528 357.686L513.896 370.019",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.878 354.514L520.941 342.531",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.701 344.646L517.069 353.812",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.46 341.118L528.345 328.078",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.745 331.957L520.941 339.008",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.512 329.135V316.095",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.205 321.383L529.05 323.848",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.487 312.572H540.332",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.377 318.561L549.842 306.228",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.879 382.707L515.655 372.84",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.47 371.782L514.953 386.23",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.568 410.552V427.471",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.97 417.954L530.108 415.839",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.244 426.415L541.383 427.823",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.436 420.068L553.016 436.987",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.074 449.671L589.67 368.254L591.078 372.834L560.062 449.665H554.068L554.074 449.671Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.973 451.085L592.141 366.852L590.732 371.432L621.042 451.085H625.978H625.973Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.727 375.661C594.231 375.661 597.072 372.82 597.072 369.316C597.072 365.812 594.231 362.972 590.727 362.972C587.223 362.972 584.383 365.812 584.383 369.316C584.383 372.82 587.223 375.661 590.727 375.661Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.107 433.108L582.274 442.976",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.975 435.222L572.05 441.566",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.561 435.572L597.428 443.325",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.429 435.572L585.797 443.681",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.951 434.872L612.227 440.866",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.761 433.108L601.652 443.332",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356 461.654L1388.25 465.242C1393.95 465.873 1399.41 462.819 1401.85 457.635L1403.44 454.257C1403.97 453.124 1404.22 451.878 1404.15 450.632L1403.97 447.276C1403.61 440.279 1394.14 438.412 1391.15 444.746L1389.49 439.367C1387.33 432.348 1377.42 432.305 1375.2 439.308C1374.3 429.321 1361.17 426.289 1355.99 434.873L1354.64 432.742C1350.96 426.921 1342.99 425.69 1337.72 430.125C1333.18 433.945 1332.35 440.613 1335.81 445.431L1339.32 450.324C1334.45 451.819 1335.05 458.881 1340.09 459.544L1355.99 461.649L1356 461.654Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.27 461.652L1386.06 465.11C1391.73 465.79 1397.21 462.801 1399.7 457.665L1400.81 455.372C1401.32 454.331 1401.56 453.182 1401.5 452.027L1401.37 449.286C1401.08 442.85 1392.39 441.059 1389.57 446.848L1388.13 442.176C1386.15 435.713 1377.03 435.621 1374.93 442.041C1374.16 432.966 1362.26 430.112 1357.46 437.849L1357.27 438.162L1356.08 436.301C1352.69 431.019 1345.45 429.891 1340.61 433.889C1336.36 437.407 1335.57 443.632 1338.82 448.094L1341.82 452.205C1337.58 453.505 1338.19 459.683 1342.59 460.136L1357.26 461.647L1357.27 461.652Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.2 462.21L1294.09 454.775C1289.51 452.364 1286.73 447.535 1286.94 442.367L1287.14 437.533C1287.19 436.281 1287.55 435.067 1288.2 433.988L1289.9 431.096C1293.47 425.065 1302.72 427.795 1302.44 434.797L1306.39 430.8C1311.56 425.577 1320.37 430.136 1319.09 437.371C1324.5 428.933 1337.55 432.332 1338.17 442.34L1340.35 441.077C1346.31 437.624 1353.94 440.225 1356.56 446.596C1358.81 452.083 1356.45 458.379 1351.16 461.044L1345.79 463.758H1314.44C1312.26 463.758 1310.12 463.229 1308.19 462.215L1308.2 462.21Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.35 459.668L1293.79 456C1290.52 453.372 1288.67 449.364 1288.79 445.172L1288.95 439.744C1288.98 438.59 1289.31 437.462 1289.89 436.464L1291.27 434.096C1294.52 428.533 1303.04 430.961 1302.86 437.398L1306.29 433.923C1311.05 429.116 1319.17 433.254 1318.07 439.928C1322.95 432.24 1334.81 435.218 1335.49 444.303L1335.51 444.67L1337.44 443.575C1342.88 440.462 1349.83 442.82 1352.26 448.603C1354.39 453.691 1352.21 459.566 1347.26 462.021L1342.7 464.276H1318.07L1304.97 462.517C1302.55 462.193 1300.26 461.211 1298.35 459.679L1298.35 459.668Z",
    fill: "#7CC69A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.26 439.781C1246.67 437.246 1247.15 433.437 1245.44 430.383L1235.74 413.016C1234.8 411.328 1232.37 411.328 1231.43 413.016L1221.45 430.896C1219.89 433.68 1220.23 437.143 1222.29 439.576C1223.75 441.287 1225.88 442.268 1228.13 442.268H1238.47C1240.66 442.268 1242.75 441.368 1244.26 439.781Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.68 440.139C1246.01 437.97 1246.46 434.452 1244.78 431.76L1236.68 418.925C1235.58 417.172 1233.02 417.172 1231.92 418.925L1222.68 433.589C1221.64 435.24 1221.86 437.387 1223.21 438.801C1225.12 440.797 1227.77 441.925 1230.53 441.925H1239.17C1240.85 441.925 1242.46 441.288 1243.69 440.144L1243.68 440.139Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.59 424.298V450.378",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.3 426.415L1233.24 431.352",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.88 432.048L1233.94 436.984",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.17 426.415L1233.24 431.352",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.29 449.979C1263.57 447.028 1263.1 441.763 1259.36 439.432L1253.15 435.569C1252.19 434.976 1250.98 434.997 1250.05 435.634L1244.53 439.394C1240.97 441.833 1240.49 446.91 1243.55 449.963C1243.59 450.001 1243.64 450.022 1243.69 450.022H1260.17C1260.22 450.022 1260.26 450.006 1260.29 449.974V449.979Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.29 449.974C1260.26 450.006 1260.22 450.022 1260.17 450.022H1243.69C1243.64 450.022 1243.59 450.001 1243.55 449.963C1240.49 446.91 1240.97 441.833 1244.53 439.394L1250.05 435.634C1250.98 434.997 1252.19 434.976 1253.15 435.569L1259.36 439.432C1263.1 441.763 1263.57 447.028 1260.29 449.979V449.974ZM1260.29 449.974L1260.53 450.238",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.21 449.525C1263.35 446.952 1262.66 443.067 1259.76 441.384L1252.81 437.354C1252.05 436.911 1251.09 436.922 1250.34 437.381L1245.57 440.289C1242.19 442.355 1241.94 447.184 1245.11 449.579C1245.18 449.638 1245.27 449.665 1245.37 449.665H1260.89C1261.01 449.665 1261.12 449.611 1261.21 449.514V449.525Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.62 444.033V449.671",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.04 442.625L1252.63 446.855",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.15 444.739L1252.62 448.618",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.84 370.375H1462.33V383.064H1477.84V370.375Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.8 373.709V383.058H1462.33V370.769L1458.8 373.703V373.709Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.47 387.287H1267.07V391.517H1483.47V387.287Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.22 397.862L1263.8 393.632H1488.08L1485.06 397.862H1266.22Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.63 397.861H1266.37V449.319H1289.63V397.861Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.63 397.861H1266.37V402.798H1289.63V397.861Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.89 397.861H1461.62V402.798H1484.89V397.861Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.69 430.995H1271.3V449.322H1284.69V430.995Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286.81 426.763H1269.9V428.171H1286.81V426.763Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.19 430.993L1270.06 428.172H1286.54L1284.85 430.993H1271.19Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.17 433.814H1275.53V449.32H1281.17V433.814Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.58 417.597H1274.12V420.418H1282.58V417.597Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.76 435.222H1276.94V442.273H1279.76V435.222Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.89 397.861H1461.62V449.319H1484.89V397.861Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.62 397.861H1289.63V402.091H1461.62V397.861Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.62 402.091H1289.63V407.729H1461.62V402.091Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.09 407.73H1289.63V449.321H1298.09V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.35 407.73H1312.89V449.321H1321.35V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.73 407.73H1338.27V449.321H1346.73V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.7 407.73H1362.24V449.321H1370.7V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.14 407.73H1382.68V449.321H1391.14V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.81 407.73H1405.94V449.321H1415.81V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.48 407.73H1428.49V449.321H1440.48V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.62 407.73H1449.64V449.321H1461.62V407.73Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.57 402.091H1289.63V404.206H1294.57V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.86 404.205H1289.63V449.319H1293.86V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.63 402.091H1456.69V404.206H1461.63V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.62 404.205H1457.39V449.319H1461.62V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.82 402.091H1312.19V404.206H1317.82V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.12 404.205H1312.89V449.319H1317.12V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.2 402.091H1337.57V404.206H1343.2V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.5 404.205H1338.27V449.319H1342.5V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.17 402.091H1361.53V404.206H1367.17V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.47 404.205H1362.24V449.319H1366.47V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.84 402.091H1386.2V404.206H1391.84V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.14 404.205H1386.91V449.319H1391.14V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.51 402.091H1410.87V404.206H1416.51V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.81 404.205H1411.58V449.319H1415.81V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.18 402.091H1435.54V404.206H1441.18V402.091Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.48 404.205H1436.25V449.319H1440.48V404.205Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.9 385.172L1265.31 383.058H1486.65L1485.07 385.172H1266.9Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.9 387.288L1265.31 385.173H1486.65L1485.07 387.288H1266.9Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.44 393.631L1261.8 391.517H1490.16L1488.52 393.631H1263.44Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.35 416.196C1281.08 416.196 1283.29 413.986 1283.29 411.26C1283.29 408.533 1281.08 406.323 1278.35 406.323C1275.63 406.323 1273.42 408.533 1273.42 411.26C1273.42 413.986 1275.63 416.196 1278.35 416.196Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.36 414.78C1280.3 414.78 1281.88 413.203 1281.88 411.257C1281.88 409.312 1280.3 407.734 1278.36 407.734C1276.41 407.734 1274.83 409.312 1274.83 411.257C1274.83 413.203 1276.41 414.78 1278.36 414.78Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.28 371.782L1373.16 374.604L1378.45 383.063C1377.16 383.063 1374.15 382.993 1372.45 382.713C1369.07 380.738 1369.4 376.017 1369.99 373.902L1369.28 371.788V371.782Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.47 373.188L1370.35 375.654L1375.63 383.056C1374.34 383.056 1371.33 382.997 1369.64 382.749C1366.26 381.022 1366.59 376.889 1367.17 375.039L1366.47 373.188Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.65 373.896L1367.52 376.189L1372.81 383.063C1371.52 383.063 1368.51 383.003 1366.82 382.777C1363.44 381.174 1363.76 377.333 1364.35 375.618L1363.65 373.896Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.12 375.305L1364 377.242L1369.29 383.057C1368 383.057 1364.99 383.009 1363.29 382.815C1359.91 381.455 1360.24 378.213 1360.83 376.756L1360.12 375.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.01 378.129L1361.89 379.364L1367.17 383.065C1365.88 383.065 1362.87 383.033 1361.18 382.909C1357.8 382.046 1358.13 379.979 1358.71 379.051L1358.01 378.129Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.5 371.782L1381.62 374.604L1376.33 383.063C1377.62 383.063 1380.63 382.993 1382.32 382.713C1385.71 380.738 1385.38 376.017 1384.79 373.902L1385.5 371.788V371.782Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388.32 373.188L1384.44 375.654L1379.15 383.056C1380.44 383.056 1383.45 382.997 1385.14 382.749C1388.53 381.022 1388.2 376.889 1387.61 375.039L1388.32 373.188Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.14 373.896L1387.26 376.189L1381.97 383.063C1383.26 383.063 1386.27 383.003 1387.96 382.777C1391.35 381.174 1391.02 377.333 1390.43 375.618L1391.14 373.896Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1394.66 375.305L1390.78 377.242L1385.5 383.057C1386.78 383.057 1389.8 383.009 1391.49 382.815C1394.87 381.455 1394.54 378.213 1393.95 376.756L1394.66 375.305Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.78 378.129L1392.9 379.364L1387.61 383.065C1388.9 383.065 1391.91 383.033 1393.6 382.909C1396.99 382.046 1396.66 379.979 1396.07 379.051L1396.78 378.129Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.39 381.649C1379.92 381.649 1381.97 379.598 1381.97 377.069C1381.97 374.539 1379.92 372.488 1377.39 372.488C1374.86 372.488 1372.81 374.539 1372.81 377.069C1372.81 379.598 1374.86 381.649 1377.39 381.649Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.39 380.241C1379.14 380.241 1380.56 378.821 1380.56 377.069C1380.56 375.317 1379.14 373.896 1377.39 373.896C1375.64 373.896 1374.22 375.317 1374.22 377.069C1374.22 378.821 1375.64 380.241 1377.39 380.241Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.59 408.204L1271.21 406.866C1271.08 406.419 1271.42 405.965 1271.89 405.965H1273.64C1273.73 405.965 1273.82 405.949 1273.89 405.917L1278.06 404.315C1278.25 404.244 1278.45 404.255 1278.63 404.342L1283 406.527C1283.18 406.618 1283.39 406.624 1283.58 406.548L1284.32 406.251C1284.71 406.095 1285.15 406.311 1285.26 406.71L1285.69 408.194C1285.73 408.345 1285.73 408.507 1285.66 408.647L1285.19 409.839C1285.1 410.055 1285.12 410.298 1285.25 410.492L1285.56 410.956C1285.68 411.139 1285.71 411.366 1285.65 411.571L1285.16 413.033C1285.09 413.238 1285.12 413.465 1285.24 413.648L1285.53 414.08C1285.67 414.29 1285.69 414.56 1285.58 414.786L1285.21 415.515C1285.11 415.714 1285.11 415.946 1285.21 416.146L1285.62 416.955C1285.71 417.133 1285.72 417.344 1285.64 417.532L1285.2 418.655C1285.11 418.87 1285.14 419.113 1285.26 419.307L1285.5 419.664C1285.66 419.901 1285.66 420.208 1285.5 420.446L1285.28 420.77C1285.14 420.98 1285.12 421.25 1285.24 421.476L1285.6 422.205C1285.7 422.404 1285.7 422.636 1285.6 422.836L1285.19 423.661C1285.1 423.828 1285.12 424.028 1285.23 424.179C1285.45 424.524 1285.21 424.988 1284.79 424.988H1272.05C1271.81 424.988 1271.59 424.87 1271.45 424.676L1271.18 424.271C1271.04 424.06 1271.03 423.791 1271.14 423.564L1271.51 422.836C1271.6 422.636 1271.6 422.404 1271.51 422.205L1271.14 421.476C1271.03 421.25 1271.04 420.98 1271.18 420.77L1271.4 420.446C1271.56 420.208 1271.56 419.901 1271.4 419.664L1271.17 419.307C1271.04 419.113 1271.01 418.87 1271.1 418.655L1271.55 417.532C1271.62 417.344 1271.62 417.133 1271.52 416.955L1271.11 416.146C1271.02 415.946 1271.02 415.714 1271.11 415.515L1271.51 414.732C1271.6 414.533 1271.6 414.301 1271.51 414.101L1271.1 413.292C1271.01 413.114 1271 412.904 1271.08 412.715L1271.52 411.593C1271.61 411.377 1271.58 411.134 1271.45 410.94L1271.16 410.497C1271.03 410.303 1271 410.06 1271.09 409.845L1271.57 408.652C1271.63 408.507 1271.64 408.345 1271.59 408.199V408.204Z",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.95 430.995H1466.56V449.322H1479.95V430.995Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.07 426.763H1465.15V428.171H1482.07V426.763Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.45 430.993L1465.32 428.172H1481.8L1480.11 430.993H1466.45Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.43 433.814H1470.79V449.32H1476.43V433.814Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.84 417.597H1469.38V420.418H1477.84V417.597Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.02 435.222H1472.2V442.273H1475.02V435.222Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.61 416.196C1476.33 416.196 1478.54 413.986 1478.54 411.26C1478.54 408.533 1476.33 406.323 1473.61 406.323C1470.88 406.323 1468.67 408.533 1468.67 411.26C1468.67 413.986 1470.88 416.196 1473.61 416.196Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.61 414.78C1475.55 414.78 1477.13 413.203 1477.13 411.257C1477.13 409.312 1475.55 407.734 1473.61 407.734C1471.66 407.734 1470.08 409.312 1470.08 411.257C1470.08 413.203 1471.66 414.78 1473.61 414.78Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.85 408.204L1466.46 406.866C1466.33 406.419 1466.67 405.965 1467.14 405.965H1468.89C1468.98 405.965 1469.07 405.949 1469.15 405.917L1473.32 404.315C1473.51 404.244 1473.71 404.255 1473.88 404.342L1478.26 406.527C1478.44 406.618 1478.65 406.624 1478.84 406.548L1479.57 406.251C1479.96 406.095 1480.4 406.311 1480.51 406.71L1480.94 408.194C1480.99 408.345 1480.98 408.507 1480.92 408.647L1480.44 409.839C1480.35 410.055 1480.38 410.298 1480.51 410.492L1480.82 410.956C1480.93 411.139 1480.96 411.366 1480.9 411.571L1480.41 413.033C1480.35 413.238 1480.37 413.465 1480.5 413.648L1480.79 414.08C1480.93 414.29 1480.94 414.56 1480.83 414.786L1480.46 415.515C1480.37 415.714 1480.37 415.946 1480.46 416.146L1480.87 416.955C1480.97 417.133 1480.97 417.344 1480.9 417.532L1480.45 418.655C1480.36 418.87 1480.39 419.113 1480.52 419.307L1480.76 419.664C1480.91 419.901 1480.91 420.208 1480.76 420.446L1480.54 420.77C1480.4 420.98 1480.38 421.25 1480.5 421.476L1480.86 422.205C1480.96 422.404 1480.96 422.636 1480.86 422.836L1480.45 423.661C1480.36 423.828 1480.38 424.028 1480.49 424.179C1480.71 424.524 1480.46 424.988 1480.05 424.988H1467.31C1467.07 424.988 1466.85 424.87 1466.71 424.676L1466.44 424.271C1466.3 424.06 1466.29 423.791 1466.4 423.564L1466.77 422.836C1466.86 422.636 1466.86 422.404 1466.77 422.205L1466.4 421.476C1466.29 421.25 1466.3 420.98 1466.44 420.77L1466.66 420.446C1466.82 420.208 1466.82 419.901 1466.66 419.664L1466.42 419.307C1466.29 419.113 1466.26 418.87 1466.36 418.655L1466.8 417.532C1466.87 417.344 1466.87 417.133 1466.78 416.955L1466.37 416.146C1466.27 415.946 1466.27 415.714 1466.37 415.515L1466.76 414.732C1466.86 414.533 1466.86 414.301 1466.76 414.101L1466.35 413.292C1466.26 413.114 1466.25 412.904 1466.33 412.715L1466.77 411.593C1466.86 411.377 1466.84 411.134 1466.71 410.94L1466.41 410.497C1466.28 410.303 1466.25 410.06 1466.35 409.845L1466.82 408.652C1466.89 408.507 1466.89 408.345 1466.85 408.199V408.204Z",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.92 370.375H1273.42V383.064H1288.92V370.375Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.45 373.709V383.058H1288.93V370.769L1292.45 373.703V373.709Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.2 375.477L1271.55 382.491C1271.61 382.825 1271.91 383.062 1272.24 383.062H1348.14C1348.53 383.062 1348.85 382.744 1348.85 382.356V380.489C1348.85 380.327 1348.79 380.171 1348.69 380.047L1347.56 378.639C1347.48 378.531 1347.43 378.401 1347.42 378.266L1347.09 375.045C1347.09 374.981 1347.07 374.921 1347.05 374.862L1346.13 372.467C1345.92 371.906 1345.09 371.997 1345 372.596C1344.91 373.222 1344.04 373.281 1343.86 372.672L1343.83 372.558C1343.66 371.959 1342.8 371.976 1342.66 372.58L1342.45 373.395C1342.3 374.02 1341.4 373.999 1341.27 373.368L1341.17 372.86C1341.06 372.348 1340.34 372.332 1340.21 372.839L1340.17 373.017C1340.05 373.481 1339.38 373.465 1339.29 372.995C1339.2 372.553 1338.58 372.504 1338.42 372.931L1338.1 373.837C1337.93 374.29 1337.28 374.263 1337.15 373.799C1337.01 373.276 1336.25 373.33 1336.18 373.864L1336.17 373.95C1336.1 374.517 1335.29 374.554 1335.16 373.999L1334.82 372.548C1334.69 372.03 1333.97 371.992 1333.8 372.504L1333.67 372.877C1333.51 373.341 1332.84 373.26 1332.8 372.774C1332.75 372.294 1332.09 372.202 1331.93 372.655L1331.74 373.146C1331.57 373.643 1330.86 373.643 1330.69 373.146L1330.41 372.386C1330.23 371.884 1329.51 371.922 1329.38 372.44L1329.3 372.747C1329.18 373.243 1328.46 373.217 1328.38 372.709C1328.29 372.218 1327.6 372.17 1327.45 372.65L1327.15 373.67C1327.01 374.117 1326.36 374.091 1326.27 373.637L1326.22 373.438C1326.14 373.055 1325.61 373.017 1325.47 373.384C1325.32 373.772 1324.75 373.697 1324.71 373.287V373.222C1324.66 372.79 1324.06 372.715 1323.91 373.125L1323.78 373.492C1323.6 373.977 1322.9 373.907 1322.81 373.395L1322.75 372.995C1322.68 372.515 1322.01 372.494 1321.89 372.963L1321.88 373.022C1321.77 373.486 1321.1 373.454 1321.04 372.985L1321 372.715C1320.94 372.272 1320.3 372.262 1320.24 372.709C1320.17 373.13 1319.57 373.157 1319.48 372.747L1319.38 372.353C1319.26 371.873 1318.57 371.884 1318.46 372.369L1318.37 372.758C1318.25 373.351 1317.4 373.351 1317.27 372.758L1317.25 372.666C1317.12 372.073 1316.29 372.046 1316.12 372.628L1316 373.065C1315.81 373.729 1314.87 373.734 1314.66 373.071C1314.46 372.396 1313.5 372.413 1313.31 373.092L1313.26 373.308C1313.07 374.015 1312.06 374.004 1311.9 373.287L1311.68 372.38C1311.55 371.83 1310.76 371.841 1310.65 372.396L1310.61 372.58C1310.5 373.119 1309.73 373.103 1309.65 372.558C1309.57 372.057 1308.88 371.986 1308.7 372.456L1308.44 373.13C1308.23 373.707 1307.38 373.605 1307.29 372.995C1307.21 372.348 1306.29 372.289 1306.12 372.92L1306.03 373.308C1305.86 373.923 1304.99 373.961 1304.78 373.362L1304.69 373.103C1304.5 372.585 1303.76 372.618 1303.61 373.146C1303.46 373.713 1302.65 373.697 1302.51 373.125L1302.35 372.407C1302.22 371.868 1301.49 371.798 1301.27 372.305L1301.07 372.742C1300.91 373.109 1300.36 373.055 1300.28 372.661C1300.18 372.218 1299.55 372.229 1299.46 372.672L1299.31 373.4C1299.22 373.891 1298.5 373.869 1298.44 373.373C1298.38 372.877 1297.66 372.855 1297.57 373.346L1297.51 373.616C1297.4 374.139 1296.66 374.139 1296.55 373.616L1296.5 373.346C1296.39 372.801 1295.61 372.812 1295.51 373.357C1295.41 373.923 1294.59 373.88 1294.52 373.308C1294.45 372.763 1293.68 372.688 1293.54 373.222C1293.41 373.68 1292.78 373.724 1292.59 373.287L1292.57 373.238C1292.39 372.823 1291.79 372.817 1291.61 373.233L1291.21 374.144C1290.98 374.652 1290.29 374.711 1289.98 374.247L1289.05 372.86C1288.84 372.542 1288.36 372.569 1288.18 372.914C1287.97 373.346 1287.33 373.254 1287.25 372.78L1287.23 372.688C1287.12 372.132 1286.34 372.094 1286.19 372.645L1286.16 372.763C1286.02 373.27 1285.33 373.324 1285.11 372.85L1284.54 371.603C1284.35 371.193 1283.75 371.242 1283.63 371.674L1283.45 372.316C1283.34 372.704 1282.78 372.655 1282.74 372.251C1282.7 371.852 1282.15 371.798 1282.03 372.181L1281.93 372.526C1281.8 372.936 1281.22 372.936 1281.1 372.526L1281.01 372.218C1280.85 371.706 1280.12 371.722 1279.99 372.24L1279.93 372.483C1279.81 372.979 1279.1 372.952 1279.01 372.45C1278.92 371.976 1278.27 371.922 1278.1 372.375L1277.93 372.823C1277.73 373.373 1276.94 373.341 1276.78 372.774L1276.69 372.418C1276.55 371.911 1275.84 371.895 1275.67 372.391C1275.52 372.877 1274.83 372.877 1274.67 372.391L1274.64 372.316C1274.48 371.808 1273.75 371.808 1273.58 372.316L1273.34 373.06C1273.22 373.422 1272.74 373.508 1272.51 373.211C1272.21 372.855 1271.65 373.055 1271.65 373.513V374.873C1271.65 375.261 1271.16 375.434 1270.91 375.137C1270.64 374.808 1270.11 375.062 1270.19 375.482L1270.2 375.477Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.76 375.477L1480.42 382.491C1480.35 382.825 1480.05 383.062 1479.72 383.062H1403.82C1403.43 383.062 1403.12 382.744 1403.12 382.356V380.489C1403.12 380.327 1403.17 380.171 1403.27 380.047L1404.4 378.639C1404.49 378.531 1404.53 378.401 1404.54 378.266L1404.87 375.045C1404.87 374.981 1404.89 374.921 1404.91 374.862L1405.83 372.467C1406.04 371.906 1406.87 371.997 1406.96 372.596C1407.05 373.222 1407.92 373.281 1408.1 372.672L1408.13 372.558C1408.31 371.959 1409.16 371.976 1409.3 372.58L1409.51 373.395C1409.66 374.02 1410.57 373.999 1410.7 373.368L1410.79 372.86C1410.9 372.348 1411.62 372.332 1411.75 372.839L1411.8 373.017C1411.91 373.481 1412.58 373.465 1412.67 372.995C1412.76 372.553 1413.38 372.504 1413.54 372.931L1413.86 373.837C1414.03 374.29 1414.68 374.263 1414.81 373.799C1414.95 373.276 1415.71 373.33 1415.78 373.864L1415.79 373.95C1415.86 374.517 1416.67 374.554 1416.8 373.999L1417.14 372.548C1417.27 372.03 1417.99 371.992 1418.16 372.504L1418.29 372.877C1418.45 373.341 1419.12 373.26 1419.17 372.774C1419.21 372.294 1419.87 372.202 1420.03 372.655L1420.22 373.146C1420.4 373.643 1421.1 373.643 1421.27 373.146L1421.55 372.386C1421.73 371.884 1422.45 371.922 1422.59 372.44L1422.66 372.747C1422.78 373.243 1423.5 373.217 1423.58 372.709C1423.67 372.218 1424.36 372.17 1424.51 372.65L1424.81 373.67C1424.95 374.117 1425.6 374.091 1425.69 373.637L1425.74 373.438C1425.82 373.055 1426.35 373.017 1426.49 373.384C1426.64 373.772 1427.21 373.697 1427.25 373.287V373.222C1427.3 372.79 1427.9 372.715 1428.05 373.125L1428.19 373.492C1428.36 373.977 1429.07 373.907 1429.15 373.395L1429.21 372.995C1429.28 372.515 1429.96 372.494 1430.07 372.963L1430.09 373.022C1430.19 373.486 1430.86 373.454 1430.92 372.985L1430.96 372.715C1431.02 372.272 1431.67 372.262 1431.73 372.709C1431.8 373.13 1432.39 373.157 1432.49 372.747L1432.58 372.353C1432.7 371.873 1433.39 371.884 1433.5 372.369L1433.59 372.758C1433.72 373.351 1434.56 373.351 1434.69 372.758L1434.71 372.666C1434.84 372.073 1435.67 372.046 1435.84 372.628L1435.97 373.065C1436.15 373.729 1437.09 373.734 1437.3 373.071C1437.5 372.396 1438.46 372.413 1438.65 373.092L1438.7 373.308C1438.89 374.015 1439.9 374.004 1440.07 373.287L1440.28 372.38C1440.41 371.83 1441.2 371.841 1441.31 372.396L1441.35 372.58C1441.46 373.119 1442.23 373.103 1442.32 372.558C1442.39 372.057 1443.08 371.986 1443.26 372.456L1443.52 373.13C1443.74 373.707 1444.58 373.605 1444.67 372.995C1444.75 372.348 1445.67 372.289 1445.84 372.92L1445.94 373.308C1446.1 373.923 1446.97 373.961 1447.18 373.362L1447.27 373.103C1447.46 372.585 1448.2 372.618 1448.35 373.146C1448.5 373.713 1449.31 373.697 1449.45 373.125L1449.61 372.407C1449.74 371.868 1450.47 371.798 1450.69 372.305L1450.89 372.742C1451.06 373.109 1451.6 373.055 1451.68 372.661C1451.78 372.218 1452.42 372.229 1452.5 372.672L1452.65 373.4C1452.74 373.891 1453.46 373.869 1453.52 373.373C1453.59 372.877 1454.3 372.855 1454.4 373.346L1454.45 373.616C1454.56 374.139 1455.3 374.139 1455.41 373.616L1455.46 373.346C1455.57 372.801 1456.35 372.812 1456.45 373.357C1456.55 373.923 1457.37 373.88 1457.44 373.308C1457.51 372.763 1458.28 372.688 1458.43 373.222C1458.55 373.68 1459.19 373.724 1459.37 373.287L1459.39 373.238C1459.57 372.823 1460.17 372.817 1460.35 373.233L1460.75 374.144C1460.98 374.652 1461.67 374.711 1461.99 374.247L1462.91 372.86C1463.12 372.542 1463.6 372.569 1463.78 372.914C1463.99 373.346 1464.63 373.254 1464.72 372.78L1464.73 372.688C1464.84 372.132 1465.62 372.094 1465.77 372.645L1465.8 372.763C1465.94 373.27 1466.63 373.324 1466.85 372.85L1467.42 371.603C1467.61 371.193 1468.21 371.242 1468.33 371.674L1468.51 372.316C1468.62 372.704 1469.18 372.655 1469.22 372.251C1469.26 371.852 1469.81 371.798 1469.93 372.181L1470.03 372.526C1470.16 372.936 1470.74 372.936 1470.86 372.526L1470.95 372.218C1471.11 371.706 1471.84 371.722 1471.97 372.24L1472.03 372.483C1472.15 372.979 1472.86 372.952 1472.95 372.45C1473.04 371.976 1473.69 371.922 1473.87 372.375L1474.03 372.823C1474.23 373.373 1475.02 373.341 1475.18 372.774L1475.27 372.418C1475.41 371.911 1476.12 371.895 1476.29 372.391C1476.44 372.877 1477.14 372.877 1477.29 372.391L1477.32 372.316C1477.49 371.808 1478.21 371.808 1478.38 372.316L1478.62 373.06C1478.74 373.422 1479.22 373.508 1479.46 373.211C1479.75 372.855 1480.31 373.055 1480.31 373.513V374.873C1480.31 375.261 1480.8 375.434 1481.05 375.137C1481.32 374.808 1481.85 375.062 1481.78 375.482L1481.76 375.477Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1403.47 382.706L1403.6 376.756C1403.62 375.752 1404.44 374.954 1405.44 374.954C1406.43 374.954 1407.24 375.736 1407.28 376.723L1407.51 382.706L1407.71 376.642C1407.74 375.704 1408.52 374.954 1409.45 374.954C1410.39 374.954 1411.16 375.698 1411.2 376.637L1411.43 382.706L1411.66 376.691C1411.7 375.72 1412.49 374.954 1413.46 374.954C1414.43 374.954 1415.23 375.72 1415.26 376.691L1415.49 382.706L1415.77 376.48C1415.81 375.623 1416.52 374.948 1417.38 374.948C1418.26 374.948 1418.98 375.666 1418.98 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.98 382.706L1419.11 376.756C1419.13 375.752 1419.94 374.954 1420.94 374.954C1421.93 374.954 1422.75 375.736 1422.78 376.723L1423.01 382.706L1423.21 376.642C1423.25 375.704 1424.02 374.954 1424.96 374.954C1425.9 374.954 1426.67 375.698 1426.71 376.637L1426.93 382.706L1427.17 376.691C1427.2 375.72 1428 374.954 1428.97 374.954C1429.94 374.954 1430.74 375.72 1430.77 376.691L1431 382.706L1431.28 376.48C1431.32 375.623 1432.03 374.948 1432.88 374.948C1433.76 374.948 1434.49 375.666 1434.49 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.49 382.706L1434.62 376.756C1434.64 375.752 1435.46 374.954 1436.46 374.954C1437.44 374.954 1438.26 375.736 1438.3 376.723L1438.52 382.706L1438.72 376.642C1438.76 375.704 1439.53 374.954 1440.47 374.954C1441.41 374.954 1442.18 375.698 1442.22 376.637L1442.44 382.706L1442.68 376.691C1442.71 375.72 1443.51 374.954 1444.48 374.954C1445.45 374.954 1446.25 375.72 1446.28 376.691L1446.51 382.706L1446.79 376.48C1446.83 375.623 1447.54 374.948 1448.39 374.948C1449.27 374.948 1450 375.666 1450 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449.99 382.706L1450.12 376.756C1450.14 375.752 1450.96 374.954 1451.96 374.954C1452.95 374.954 1453.76 375.736 1453.8 376.723L1454.03 382.706L1454.23 376.642C1454.27 375.704 1455.04 374.954 1455.98 374.954C1456.92 374.954 1457.69 375.698 1457.72 376.637L1457.95 382.706L1458.18 376.691C1458.22 375.72 1459.01 374.954 1459.98 374.954C1460.96 374.954 1461.75 375.72 1461.79 376.691L1462.01 382.706L1462.29 376.48C1462.34 375.623 1463.04 374.948 1463.9 374.948C1464.78 374.948 1465.5 375.666 1465.5 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.5 382.706L1465.63 376.756C1465.65 375.752 1466.47 374.954 1467.47 374.954C1468.46 374.954 1469.27 375.736 1469.31 376.723L1469.54 382.706L1469.74 376.642C1469.78 375.704 1470.55 374.954 1471.49 374.954C1472.42 374.954 1473.2 375.698 1473.23 376.637L1473.46 382.706L1473.69 376.691C1473.73 375.72 1474.52 374.954 1475.49 374.954C1476.47 374.954 1477.26 375.72 1477.3 376.691L1477.52 382.706L1477.8 376.48C1477.85 375.623 1478.55 374.948 1479.41 374.948C1480.29 374.948 1481.01 375.666 1481.01 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.25 382.706L1270.37 376.756C1270.4 375.752 1271.21 374.954 1272.21 374.954C1273.2 374.954 1274.02 375.736 1274.05 376.723L1274.28 382.706L1274.48 376.642C1274.52 375.704 1275.29 374.954 1276.23 374.954C1277.17 374.954 1277.94 375.698 1277.98 376.637L1278.2 382.706L1278.43 376.691C1278.47 375.72 1279.27 374.954 1280.24 374.954C1281.21 374.954 1282.01 375.72 1282.04 376.691L1282.27 382.706L1282.55 376.48C1282.59 375.623 1283.3 374.948 1284.15 374.948C1285.03 374.948 1285.76 375.666 1285.76 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.76 382.706L1285.89 376.756C1285.91 375.752 1286.72 374.954 1287.73 374.954C1288.71 374.954 1289.53 375.736 1289.56 376.723L1289.79 382.706L1289.99 376.642C1290.03 375.704 1290.8 374.954 1291.74 374.954C1292.68 374.954 1293.45 375.698 1293.49 376.637L1293.71 382.706L1293.95 376.691C1293.98 375.72 1294.78 374.954 1295.75 374.954C1296.72 374.954 1297.52 375.72 1297.55 376.691L1297.78 382.706L1298.06 376.48C1298.1 375.623 1298.81 374.948 1299.66 374.948C1300.54 374.948 1301.27 375.666 1301.27 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.26 382.706L1301.39 376.756C1301.41 375.752 1302.23 374.954 1303.23 374.954C1304.22 374.954 1305.03 375.736 1305.07 376.723L1305.3 382.706L1305.5 376.642C1305.53 375.704 1306.31 374.954 1307.24 374.954C1308.18 374.954 1308.95 375.698 1308.99 376.637L1309.22 382.706L1309.45 376.691C1309.49 375.72 1310.28 374.954 1311.25 374.954C1312.22 374.954 1313.02 375.72 1313.05 376.691L1313.28 382.706L1313.56 376.48C1313.6 375.623 1314.31 374.948 1315.17 374.948C1316.05 374.948 1316.77 375.666 1316.77 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.77 382.706L1316.9 376.756C1316.92 375.752 1317.73 374.954 1318.74 374.954C1319.72 374.954 1320.54 375.736 1320.58 376.723L1320.8 382.706L1321 376.642C1321.04 375.704 1321.81 374.954 1322.75 374.954C1323.69 374.954 1324.46 375.698 1324.5 376.637L1324.73 382.706L1324.96 376.691C1324.99 375.72 1325.79 374.954 1326.76 374.954C1327.73 374.954 1328.53 375.72 1328.56 376.691L1328.79 382.706L1329.07 376.48C1329.11 375.623 1329.82 374.948 1330.68 374.948C1331.56 374.948 1332.28 375.666 1332.28 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.28 382.706L1332.41 376.756C1332.43 375.752 1333.24 374.954 1334.25 374.954C1335.23 374.954 1336.05 375.736 1336.09 376.723L1336.31 382.706L1336.51 376.642C1336.55 375.704 1337.32 374.954 1338.26 374.954C1339.2 374.954 1339.97 375.698 1340.01 376.637L1340.24 382.706L1340.47 376.691C1340.5 375.72 1341.3 374.954 1342.27 374.954C1343.24 374.954 1344.04 375.72 1344.07 376.691L1344.3 382.706L1344.58 376.48C1344.62 375.623 1345.33 374.948 1346.19 374.948C1347.07 374.948 1347.79 375.666 1347.79 376.551V382.701",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.69 385.173H1271.3V389.403H1284.69V385.173Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.59 387.287H1315.71C1316.87 387.287 1317.82 388.231 1317.82 389.402C1317.82 390.567 1316.88 391.517 1315.71 391.517H1313.59C1312.43 391.517 1311.48 390.573 1311.48 389.402C1311.48 388.237 1312.42 387.287 1313.59 387.287Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.33 377.437C1464.7 377.615 1466.56 379.595 1466.56 382.006V383.064H1462.33V377.437Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.47 377.437C1481.11 377.615 1479.24 379.595 1479.24 382.006V383.064H1483.47V377.437Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.81 379.535C1415.81 378.369 1414.86 377.42 1413.69 377.42C1412.52 377.42 1411.58 378.364 1411.58 379.535V383.058H1415.81V379.535Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.48 379.535C1440.48 378.369 1439.53 377.42 1438.36 377.42C1437.19 377.42 1436.25 378.364 1436.25 379.535V383.058H1440.48V379.535Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.97 387.287H1341.09C1342.25 387.287 1343.2 388.231 1343.2 389.402C1343.2 390.567 1342.26 391.517 1341.09 391.517H1338.97C1337.81 391.517 1336.86 390.573 1336.86 389.402C1336.86 388.237 1337.8 387.287 1338.97 387.287Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.99 387.287H1415.1C1416.27 387.287 1417.22 388.231 1417.22 389.402C1417.22 390.567 1416.27 391.517 1415.1 391.517H1412.99C1411.82 391.517 1410.87 390.573 1410.87 389.402C1410.87 388.237 1411.82 387.287 1412.99 387.287Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.66 387.287H1439.77C1440.94 387.287 1441.89 388.231 1441.89 389.402C1441.89 390.567 1440.94 391.517 1439.77 391.517H1437.66C1436.49 391.517 1435.54 390.573 1435.54 389.402C1435.54 388.237 1436.49 387.287 1437.66 387.287Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.78 377.437C1270.15 377.615 1272.01 379.595 1272.01 382.006V383.064H1267.78V377.437Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.93 377.437C1286.56 377.615 1284.7 379.595 1284.7 382.006V383.064H1288.93V377.437Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.42 379.535C1316.42 378.369 1315.47 377.42 1314.3 377.42C1313.13 377.42 1312.19 378.364 1312.19 379.535V383.058H1316.42V379.535Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.8 379.535C1341.8 378.369 1340.85 377.42 1339.68 377.42C1338.51 377.42 1337.57 378.364 1337.57 379.535V383.058H1341.8V379.535Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.95 385.173H1466.56V389.403H1479.95V385.173Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.885 385.172L683.775 427.113V430.636L720.079 423.585L865.993 393.977L874.453 396.799L840.62 417.947L823.702 432.751C832.868 428.171 852.813 418.373 859.298 415.832C867.407 412.66 900.182 396.799 904.762 394.684C913.572 390.616 910.756 385.167 904.762 384.109C888.971 380.727 866.932 383.403 857.885 385.167V385.172Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.906 449.671H705.981L708.463 440.775C709.343 437.629 706.974 434.516 703.71 434.516H683.775V430.637L861.801 395.03C867.639 393.865 873.557 393.147 879.508 392.894C881.601 392.807 882.459 395.543 880.689 396.665L823.556 432.995C820.529 434.916 819.218 438.66 820.378 442.048L822.984 449.666H814.174V439.437C814.174 437.931 812.642 436.906 811.25 437.484L803.956 440.505V434.511L843.782 406.667C845.255 405.863 844.284 403.419 842.66 403.846C813.543 411.453 767.852 421.25 753.555 424.643C740.537 427.735 727.821 431.096 720.375 433.481C717.435 434.419 715.693 437.306 715.989 440.375L716.901 449.666L716.906 449.671Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.981 426.057V435.223",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.791 424.646V433.457",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.051 420.068V428.177",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.193 422.883V432.4",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.596 421.476V430.286",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.333 435.22L722.896 432.048",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.294 449.671V440.019C816.294 437.877 817.26 435.854 818.943 434.527C822.644 431.608 827.505 427.837 832.08 424.357C834.961 422.043 838.452 419.437 842.655 416.529C843.232 416.125 843.739 415.774 844.187 415.477C852.091 410.098 862.336 403.748 875.505 396.443C859.298 405.432 849.501 411.943 844.192 415.472H844.187C843.664 415.833 843.156 416.178 842.655 416.524C840.049 418.358 836.175 421.239 832.08 424.352C824.22 430.653 820.902 434.754 820.168 436.62V449.66H816.289L816.294 449.671Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.725 438.983L710.562 449.32H716.906C716.674 448.381 716.766 445.371 716.199 440.861C715.633 436.35 718.082 434.516 719.722 434.165L747.917 426.057L718.525 433.027C715.601 433.723 713.335 436.043 712.725 438.983Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.961 436.981L862.114 403.148L875.861 396.453",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.885 385.173L683.775 427.114V424.999L857.885 380.236C868.108 378.24 891.792 375.445 904.762 380.236C909.839 381.93 912.396 383.527 913.222 384.115C913.222 386.937 913.572 390.109 911.814 391.517C910.405 392.645 852.484 419.48 823.701 432.752C832.868 428.171 852.813 418.374 859.298 415.833C867.407 412.66 900.182 396.799 904.762 394.684C913.572 390.616 910.756 385.167 904.762 384.11C888.971 380.727 866.932 383.403 857.885 385.167V385.173Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.775 421.476V424.999L733.469 412.31C772.821 401.385 856.687 379.179 877.269 377.771C897.851 376.363 909.812 381.413 913.216 384.116V377.161C913.216 375.489 912.741 373.811 911.441 372.77C908.086 370.099 901.606 367.483 895.596 367.197C876.988 365.503 855.888 370.25 847.661 372.835L683.775 421.471V421.476Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.775 426.763V430.642",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.73 403.855L875.505 396.453",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.792 382.707L875.855 392.931",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.93 384.114L872.332 393.28",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.597 382.707L878.678 392.931",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.391 383.058V393.281",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.12 449.671V409.494H1692.83L1709.04 399.978L1725.96 406.673L1746.05 394.69L1749.93 449.671H1532.12H1532.12Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536.35 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.58 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.8 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.03 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.26 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.49 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.72 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.95 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.18 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.41 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.64 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.87 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.1 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.33 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.56 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.79 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.01 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.24 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.47 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.7 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.93 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.16 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.39 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.62 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.85 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.08 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.31 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.54 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.77 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.23 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.45 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.68 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675.91 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.14 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.37 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.6 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.83 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.06 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.29 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.52 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.75 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.98 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.21 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.44 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726.67 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.89 415.131V449.67",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.12 414.075V449.672",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.35 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.58 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.81 412.315V449.676",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.47 397.155C1524.85 397.436 1513.31 394.69 1508.5 393.276C1526.48 411.603 1529.29 415.126 1532.47 416.891C1547.27 418.299 1543.74 414.776 1562.78 414.776C1581.81 414.776 1592.38 419.712 1602.25 420.063C1612.12 420.413 1614.58 414.776 1626.57 414.776C1638.56 414.776 1644.9 422.884 1653.01 422.884C1661.12 422.884 1660.76 414.425 1671.69 414.074C1682.61 413.724 1687.55 424.999 1692.83 424.999C1703.06 424.999 1697.77 413.368 1707.99 413.017C1718.21 412.666 1717.86 426.407 1724.55 426.407C1731.25 426.407 1730.9 413.368 1739.36 412.31C1747.82 411.253 1747.47 441.918 1749.93 449.315C1756.63 429.93 1759.8 393.276 1749.93 393.276C1740.06 393.276 1740.76 414.776 1732.31 415.126C1723.85 415.477 1729.14 397.15 1717.86 395.742C1706.59 394.334 1706.59 411.603 1697.77 412.305C1688.96 413.011 1690.72 395.742 1678.39 395.742C1666.05 395.742 1664.64 408.782 1655.12 408.782C1645.61 408.782 1642.79 395.742 1626.57 395.742C1615.65 395.742 1610.01 403.851 1600.14 403.851C1590.26 403.851 1579.1 395.942 1565.6 394.684C1550.44 393.276 1541.98 396.799 1532.47 397.15V397.155Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.24 412.666C1749.36 388.982 1750.75 426.764 1749.92 448.613C1747.46 421.12 1744.99 418.234 1743.58 415.132C1741.82 411.253 1739.35 412.31 1737.24 412.666Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.47 428.527H1536.35",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.47 439.804H1536.35",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.8 422.883H1548.68",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.8 434.166H1548.68",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.8 445.44H1548.68",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.26 422.883H1557.14",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.26 434.166H1557.14",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.26 445.44H1557.14",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.72 422.883H1565.6",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.72 434.166H1565.6",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.72 445.44H1565.6",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.18 422.883H1574.06",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.18 434.166H1574.06",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.18 445.44H1574.06",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.64 422.883H1582.52",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.64 434.166H1582.52",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.64 445.44H1582.52",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.1 422.883H1590.98",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.1 434.166H1590.98",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.1 445.44H1590.98",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.56 422.883H1599.44",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.56 434.166H1599.44",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.56 445.44H1599.44",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.01 422.883H1607.89",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.01 434.166H1607.89",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.01 445.44H1607.89",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.47 422.883H1616.35",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.47 434.166H1616.35",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.47 445.44H1616.35",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.93 422.883H1624.81",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.93 434.166H1624.81",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.93 445.44H1624.81",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.39 422.883H1633.27",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.39 434.166H1633.27",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.39 445.44H1633.27",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.85 422.883H1641.73",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.85 434.166H1641.73",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.85 445.44H1641.73",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.31 422.883H1650.19",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.31 434.166H1650.19",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.31 445.44H1650.19",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.77 422.883H1658.65",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.77 434.166H1658.65",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.77 445.44H1658.65",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.23 422.883H1667.11",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.23 434.166H1667.11",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.23 445.44H1667.11",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.68 422.883H1675.56",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.68 434.166H1675.56",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.68 445.44H1675.56",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.14 422.883H1684.02",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.14 434.166H1684.02",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.14 445.44H1684.02",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.52 422.883H1709.4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.52 434.166H1709.4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.52 445.44H1709.4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.98 422.883H1717.86",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.98 434.166H1717.86",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.98 445.44H1717.86",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.89 422.883H1734.77",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.89 434.166H1734.77",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.89 445.44H1734.77",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.6 434.166H1692.48",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.6 445.44H1692.48",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.06 434.166H1700.94",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.06 445.44H1700.94",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536.7 422.883H1540.57",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536.7 434.166H1540.57",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536.7 445.44H1540.57",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.93 428.527H1544.8",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.93 439.804H1544.8",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.39 428.527H1553.26",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.39 439.804H1553.26",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.85 428.527H1561.72",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1557.85 439.804H1561.72",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.3 428.527H1570.18",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.3 439.804H1570.18",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.76 428.527H1578.64",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.76 439.804H1578.64",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.22 428.527H1587.1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1583.22 439.804H1587.1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.68 428.527H1595.56",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.68 439.804H1595.56",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.14 428.527H1604.02",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.14 439.804H1604.02",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.6 428.527H1612.47",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.6 439.804H1612.47",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.06 428.527H1620.93",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.06 439.804H1620.93",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.51 428.527H1629.39",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.51 439.804H1629.39",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.97 428.527H1637.85",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.97 439.804H1637.85",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.43 428.527H1646.31",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.43 439.804H1646.31",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.89 428.527H1654.77",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.89 439.804H1654.77",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.35 428.527H1663.23",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.35 439.804H1663.23",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.81 428.527H1671.69",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.81 439.804H1671.69",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.27 428.527H1680.15",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.27 439.804H1680.15",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.73 428.527H1688.61",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.73 439.804H1688.61",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.18 428.527H1697.06",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.18 439.804H1697.06",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.64 428.527H1705.52",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.64 439.804H1705.52",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.1 428.527H1713.98",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.1 439.804H1713.98",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.56 428.527H1722.44",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.56 439.804H1722.44",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.02 428.527H1730.9",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1727.02 439.804H1730.9",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.48 428.527H1739.36",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.48 439.804H1739.36",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.94 428.527H1747.11",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.94 439.804H1747.82",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.44 412.666C1713.82 410.254 1706.58 409.494 1702.35 415.132C1709.4 410.195 1712.88 413.799 1715.03 416.189C1718.21 419.712 1718.21 426.995 1725.26 426.057C1718.91 420.769 1720.68 416.54 1716.45 412.666H1716.44Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.86 412.882C1677.98 410.217 1666.75 410.551 1661.46 418.304C1668.16 411.959 1675.7 414.414 1678.73 415.482C1684.73 417.597 1686.49 425.587 1693.54 424.648C1688 423.24 1687.5 416.761 1681.86 412.882Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1636.08 412.668C1631.56 411.373 1622.69 411.61 1612.12 417.955C1624.45 413.018 1631.99 414.772 1635.03 415.84C1641.02 417.955 1645.25 422.184 1652.65 422.535C1647.11 421.127 1643.48 414.782 1636.08 412.668Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.82 411.958C1568.41 411.251 1558.53 410.928 1541.98 416.895C1559.96 413.372 1569.92 414.812 1574.76 415.13C1584.28 415.756 1590.67 419.732 1602.25 420.067C1593.6 418.74 1587.52 413.075 1575.82 411.958Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.86 421.476H964.324V449.67H1170.86V421.476Z",
    fill: "#D8D0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.9 342.88L1176.85 379.885L1190.24 380.942L1183.89 342.88H1183.9Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.9 342.88L1181.43 380.942H1190.24L1183.9 342.88Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.38 380.942C1180.38 379.777 1181.32 378.827 1182.49 378.827C1183.66 378.827 1184.6 379.771 1184.6 380.942V392.574H1180.38V380.942Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.85 380.591C1176.85 379.62 1177.63 378.827 1178.61 378.827C1179.59 378.827 1180.38 379.615 1180.38 380.591V392.574H1176.85V380.591H1176.85Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.6 381.649C1184.6 380.09 1185.87 378.827 1187.43 378.827C1188.99 378.827 1190.25 380.09 1190.25 381.649V392.574H1184.61V381.649H1184.6Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.49 391.166C1182.49 388.636 1184.54 386.586 1187.07 386.586C1189.6 386.586 1191.65 388.636 1191.65 391.166V398.919H1182.48V391.166H1182.49Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.44 390.817C1175.44 388.869 1177.02 387.294 1178.96 387.294C1180.9 387.294 1182.48 388.875 1182.48 390.817V402.449H1175.43V390.817H1175.44Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.6 392.404C1184.6 391.136 1185.63 390.111 1186.9 390.111H1187.25C1188.51 390.111 1189.54 391.136 1189.54 392.404C1189.54 393.672 1188.51 394.697 1187.25 394.697H1186.9C1185.63 394.697 1184.6 393.672 1184.6 392.404Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.55 392.93C1177.55 392.153 1178.19 391.521 1178.96 391.521C1179.73 391.521 1180.37 392.153 1180.37 392.93V393.987C1180.37 394.764 1179.73 395.395 1178.96 395.395C1178.19 395.395 1177.55 394.764 1177.55 393.987V392.93Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.61 409.144L1189.54 395.397L1213.86 409.144H1178.61Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.54 395.397L1168.39 405.972L1169.09 406.679V413.023L1178.61 409.5L1189.54 395.403V395.397Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.5 450.377V409.143H1178.96L1169.09 413.022V450.382H1213.5V450.377Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.09 421.828H966.084V450.023H1169.09V421.828Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.083 409.846V421.829H1169.09V406.323H963.305L966.002 409.625L966.078 409.722V409.846H966.083Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.71 303.406H1062.3C1061.72 303.406 1061.25 303.88 1061.25 304.464V408.081C1061.25 408.665 1061.72 409.139 1062.3 409.139H1063.71C1064.3 409.139 1064.77 408.665 1064.77 408.081V304.464C1064.77 303.88 1064.3 303.406 1063.71 303.406Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.17 303.406H1070.76C1070.18 303.406 1069.71 303.88 1069.71 304.464V408.081C1069.71 408.665 1070.18 409.139 1070.76 409.139H1072.17C1072.76 409.139 1073.23 408.665 1073.23 408.081V304.464C1073.23 303.88 1072.76 303.406 1072.17 303.406Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.364 431.701H967.496V450.028H977.364V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.364 431.701H967.496V435.224H977.364V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.611 423.942H967.496V428.879H969.611V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.841 423.942H971.02V428.879H973.841V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.363 423.942H975.248V428.879H977.363V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.577 431.701H983.709V450.028H993.577V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.824 423.942H983.709V428.879H985.824V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.053 423.942H987.231V428.879H990.053V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.576 423.942H991.461V428.879H993.576V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.59 431.701H1014.72V450.028H1024.59V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.84 423.942H1014.72V428.879H1016.84V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.07 423.942H1018.25V428.879H1021.07V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.59 423.942H1022.48V428.879H1024.59V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 431.701H1030.94V450.028H1040.8V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.05 423.942H1030.94V428.879H1033.05V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.28 423.942H1034.46V428.879H1037.28V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 423.942H1038.69V428.879H1040.8V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.02 431.701H1047.15V450.028H1057.02V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.26 423.942H1047.15V428.879H1049.26V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.49 423.942H1050.67V428.879H1053.49V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.02 423.942H1054.9V428.879H1057.02V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.73 431.701H1078.87V450.028H1088.73V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.98 423.942H1078.87V428.879H1080.98V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.22 423.942H1082.39V428.879H1085.22V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.73 423.942H1086.62V428.879H1088.73V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.95 431.701H1095.08V450.028H1104.95V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.19 423.942H1095.08V428.879H1097.19V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.43 423.942H1098.61V428.879H1101.43V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.95 423.942H1102.84V428.879H1104.95V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.68 431.701H1157.82V450.028H1167.68V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.93 423.942H1157.82V428.879H1159.93V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.16 423.942H1161.34V428.879H1164.16V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.13 437.338H1183.9V450.027H1188.13V437.338Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.55 438.039H1175.44V445.792H1177.55V438.039Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.32 438.039H1171.21V445.792H1173.32V438.039Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.44 434.517H1177.55V426.154L1175.44 426.683V434.517Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.21 434.515H1173.32V426.859L1171.21 427.388V434.515Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.44 415.409V420.728L1177.55 420.464V414.88L1175.44 415.409Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.21 416.112V421.431L1173.32 421.167V415.583L1171.21 416.112Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.28 438.039H1205.05V445.792H1209.28V438.039Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.69 423.942H1165.57V428.879H1167.69V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.47 431.701H1141.61V450.028H1151.47V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.72 423.942H1141.61V428.879H1143.72V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.95 423.942H1145.13V428.879H1147.95V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.47 423.942H1149.36V428.879H1151.47V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.16 431.701H1111.29V450.028H1121.16V431.701Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.41 423.942H1111.29V428.879H1113.41V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.64 423.942H1114.82V428.879H1117.64V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.16 423.942H1119.05V428.879H1121.16V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.4 419.01H1152.88V450.026H1156.4V419.01Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.88 419.01H1106.36V450.026H1109.88V419.01Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.67 419.01H1090.15V450.026H1093.67V419.01Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.74 419.01H1042.21V450.026H1045.74V419.01Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.52 419.01H1026V450.026H1029.52V419.01Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.294 419.01H978.771V450.026H982.294V419.01Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.69 422.181C995.69 417.315 999.64 413.371 1004.5 413.371C1009.36 413.371 1013.31 417.315 1013.31 422.181V450.025H995.69V422.181Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.57 422.181C1122.57 417.315 1126.52 413.371 1131.38 413.371C1136.24 413.371 1140.19 417.315 1140.19 422.181V450.025H1122.57V422.181Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.96 407.028C1178.96 406.251 1179.6 405.62 1180.37 405.62C1181.14 405.62 1181.78 406.251 1181.78 407.028V450.377H1178.96V407.028H1178.96Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.75 415.486C1205.75 414.709 1206.38 414.078 1207.16 414.078C1207.93 414.078 1208.56 414.709 1208.56 415.486V420.067H1205.74V415.486H1205.75Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.61 415.486C1184.61 414.709 1185.24 414.078 1186.01 414.078C1186.78 414.078 1187.42 414.709 1187.42 415.486V420.067H1184.6V415.486H1184.61Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.9 426.761C1183.9 425.596 1184.84 424.646 1186.01 424.646C1187.18 424.646 1188.13 425.591 1188.13 426.761V433.457H1183.9V426.761Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.05 426.761C1205.05 425.596 1205.99 424.646 1207.16 424.646C1208.33 424.646 1209.28 425.591 1209.28 426.761V433.457H1205.05V426.761Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.13 418.655C1059.13 413.789 1063.08 409.845 1067.94 409.845C1072.8 409.845 1076.75 413.789 1076.75 418.655V450.022H1059.13V418.655Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.082 450.027V417.954L957.623 416.189H925.198V450.022H966.082V450.027Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.963 416.189L949.52 400.327L957.979 416.189H926.963Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.629 415.838L949.876 400.684L963.267 406.677L966.088 409.85V418.309L957.629 415.844V415.838Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.843 444.386H935.072V433.11C935.072 431.945 934.128 430.995 932.958 430.995C931.787 430.995 930.843 431.939 930.843 433.11V444.386Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.545 426.058H934.367V422.535C934.367 421.758 933.73 421.127 932.958 421.127C932.187 421.127 931.55 421.758 931.55 422.535V426.058H931.545Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.87 426.058H952.692V422.535C952.692 421.758 952.055 421.127 951.284 421.127C950.512 421.127 949.876 421.758 949.876 422.535V426.058H949.87Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.169 444.386H953.399V433.11C953.399 431.945 952.454 430.995 951.284 430.995C950.113 430.995 949.169 431.939 949.169 433.11V444.386Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.888 415.837C937.888 413.307 939.938 411.257 942.469 411.257C944.999 411.257 947.049 413.307 947.049 415.837V450.026H937.883V415.837H937.888Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.198 413.018C925.198 412.047 925.986 411.254 926.962 411.254C927.939 411.254 928.727 412.042 928.727 413.018V450.023H925.204V413.018H925.198Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.513 412.665C955.513 411.888 956.15 411.257 956.921 411.257C957.693 411.257 958.329 411.888 958.329 412.665V450.026H955.508V412.665H955.513Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.709 426.058H943.531V422.535C943.531 421.758 942.894 421.127 942.122 421.127C941.351 421.127 940.714 421.758 940.714 422.535V426.058H940.709Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.004 444.386H944.94V433.461C944.94 432.096 943.834 430.995 942.475 430.995C941.115 430.995 940.009 432.101 940.009 433.461V444.386H940.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.098 422.883C997.098 418.794 1000.41 415.481 1004.5 415.481C1008.59 415.481 1011.9 418.794 1011.9 422.883V450.021H997.098V422.883Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.214 450.028H1009.08V436.638C1009.08 433.913 1006.88 431.701 1004.15 431.701C1001.42 431.701 999.209 433.908 999.209 436.638V450.028H999.214Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.33 423.942H999.214V428.879H1001.33V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.56 423.942H1002.74V428.879H1005.56V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.08 423.942H1006.97V428.879H1009.08V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.98 422.883C1123.98 418.794 1127.29 415.481 1131.38 415.481C1135.47 415.481 1138.78 418.794 1138.78 422.883V450.021H1123.98V422.883Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.54 419.36C1060.54 415.271 1063.85 411.958 1067.94 411.958C1072.03 411.958 1075.34 415.271 1075.34 419.36V450.026H1060.54V419.36Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.65 450.028H1072.52V436.638C1072.52 433.913 1070.31 431.701 1067.58 431.701C1064.85 431.701 1062.65 433.908 1062.65 436.638V450.028H1062.65Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.77 423.942H1062.65V428.879H1064.77V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069 423.942H1066.18V428.879H1069V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.52 423.942H1070.41V428.879H1072.52V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.09 450.028H1135.96V436.638C1135.96 433.913 1133.76 431.701 1131.03 431.701C1128.3 431.701 1126.09 433.908 1126.09 436.638V450.028H1126.09Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126.09 450.026H1135.96V439.452C1135.96 436.728 1133.76 434.516 1131.03 434.516C1128.3 434.516 1126.09 436.722 1126.09 439.452V450.026H1126.09Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.65 450.026H1072.52V439.452C1072.52 436.728 1070.31 434.516 1067.58 434.516C1064.85 434.516 1062.65 436.722 1062.65 439.452V450.026H1062.65Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.214 450.026H1009.08V439.452C1009.08 436.728 1006.88 434.516 1004.15 434.516C1001.42 434.516 999.209 436.722 999.209 439.452V450.026H999.214Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.21 423.942H1126.09V428.879H1128.21V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.44 423.942H1129.62V428.879H1132.44V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.96 423.942H1133.85V428.879H1135.96V423.942Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.24 410.2C1190.24 406.499 1193.24 403.505 1196.94 403.505C1200.64 403.505 1203.63 406.505 1203.63 410.2V450.377H1190.24V410.2Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.11 438.039H1194.47V445.792H1200.11V438.039Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.06 415.486C1193.06 414.709 1193.69 414.078 1194.47 414.078C1195.24 414.078 1195.87 414.709 1195.87 415.486V420.067H1193.05V415.486H1193.06Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198 415.486C1198 414.709 1198.63 414.078 1199.4 414.078C1200.18 414.078 1200.81 414.709 1200.81 415.486V420.067H1197.99V415.486H1198Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.47 427.112C1194.47 425.747 1195.58 424.646 1196.94 424.646C1198.3 424.646 1199.4 425.752 1199.4 427.112V433.457H1194.47V427.112H1194.47Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.577 431.701H983.709V435.224H993.577V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.59 431.701H1014.72V435.224H1024.59V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.8 431.701H1030.94V435.224H1040.8V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.02 431.701H1047.15V435.224H1057.02V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.73 431.701H1078.87V435.224H1088.73V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.95 431.701H1095.08V435.224H1104.95V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.16 431.701H1111.29V435.224H1121.16V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.47 431.701H1141.61V435.224H1151.47V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.68 431.701H1157.82V435.224H1167.68V431.701Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.39 407.028C1211.39 406.251 1212.02 405.62 1212.79 405.62C1213.56 405.62 1214.2 406.251 1214.2 407.028V450.377H1211.38V407.028H1211.39Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.625 409.845H80.0376V450.022H207.625V409.845Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.291 409.845H274.588V450.022H404.291V409.845Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0367 421.127H37.0381V450.028H80.0367V421.127Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5591 419.011C83.5591 417.064 85.1399 415.488 87.0821 415.488C89.0243 415.488 90.605 417.069 90.605 419.011V424.649H83.5537V419.011H83.5591Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.02 419.011C92.02 417.064 93.6008 415.488 95.543 415.488C97.4852 415.488 99.066 417.069 99.066 419.011V424.649H92.0146V419.011H92.02Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.479 419.011C100.479 417.064 102.059 415.488 104.002 415.488C105.944 415.488 107.524 417.069 107.524 419.011V424.649H100.473V419.011H100.479Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.938 419.011C108.938 417.064 110.519 415.488 112.461 415.488C114.403 415.488 115.984 417.069 115.984 419.011V424.649H108.933V419.011H108.938Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.392 419.011C117.392 417.064 118.973 415.488 120.915 415.488C122.857 415.488 124.438 417.069 124.438 419.011V424.649H117.387V419.011H117.392Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.852 419.011C125.852 417.064 127.432 415.488 129.375 415.488C131.317 415.488 132.898 417.069 132.898 419.011V424.649H125.846V419.011H125.852Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.018 419.011C135.018 417.064 136.598 415.488 138.541 415.488C140.483 415.488 142.064 417.069 142.064 419.011V424.649H135.012V419.011H135.018Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.478 419.011C143.478 417.064 145.058 415.488 147.001 415.488C148.943 415.488 150.524 417.069 150.524 419.011V424.649H143.472V419.011H143.478Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.937 419.011C151.937 417.064 153.518 415.488 155.46 415.488C157.402 415.488 158.983 417.069 158.983 419.011V424.649H151.932V419.011H151.937Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.391 419.011C160.391 417.064 161.972 415.488 163.914 415.488C165.856 415.488 167.437 417.069 167.437 419.011V424.649H160.386V419.011H160.391Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.851 419.011C168.851 417.064 170.431 415.488 172.374 415.488C174.316 415.488 175.897 417.069 175.897 419.011V424.649H168.845V419.011H168.851Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.31 419.011C177.31 417.064 178.89 415.488 180.833 415.488C182.775 415.488 184.356 417.069 184.356 419.011V424.649H177.304V419.011H177.31Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.769 419.011C185.769 417.064 187.35 415.488 189.292 415.488C191.234 415.488 192.815 417.069 192.815 419.011V424.649H185.764V419.011H185.769Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.229 419.011C194.229 417.064 195.81 415.488 197.752 415.488C199.694 415.488 201.275 417.069 201.275 419.011V424.649H194.224V419.011H194.229Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.688 419.011C202.688 417.064 204.269 415.488 206.211 415.488C208.153 415.488 209.734 417.069 209.734 419.011V424.649H202.683V419.011H202.688Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.289 419.011C275.289 417.064 276.87 415.488 278.812 415.488C280.754 415.488 282.335 417.069 282.335 419.011V424.649H275.284V419.011H275.289Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.749 419.011C283.749 417.064 285.33 415.488 287.272 415.488C289.214 415.488 290.795 417.069 290.795 419.011V424.649H283.744V419.011H283.749Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.208 419.011C292.208 417.064 293.788 415.488 295.731 415.488C297.673 415.488 299.253 417.069 299.253 419.011V424.649H292.202V419.011H292.208Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.422 391.517H219.602V409.844H265.422V391.517Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.668 419.011C300.668 417.064 302.248 415.488 304.19 415.488C306.133 415.488 307.713 417.069 307.713 419.011V424.649H300.662V419.011H300.668Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.127 419.011C309.127 417.064 310.708 415.488 312.65 415.488C314.592 415.488 316.173 417.069 316.173 419.011V424.649H309.122V419.011H309.127Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.585 419.011C317.585 417.064 319.166 415.488 321.108 415.488C323.051 415.488 324.631 417.069 324.631 419.011V424.649H317.58V419.011H317.585Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.748 419.011C326.748 417.064 328.328 415.488 330.271 415.488C332.213 415.488 333.794 417.069 333.794 419.011V424.649H326.742V419.011H326.748Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.207 419.011C335.207 417.064 336.787 415.488 338.73 415.488C340.672 415.488 342.253 417.069 342.253 419.011V424.649H335.201V419.011H335.207Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.667 419.011C343.667 417.064 345.248 415.488 347.19 415.488C349.132 415.488 350.713 417.069 350.713 419.011V424.649H343.662V419.011H343.667Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.126 419.011C352.126 417.064 353.707 415.488 355.649 415.488C357.592 415.488 359.172 417.069 359.172 419.011V424.649H352.121V419.011H352.126Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58 419.011C360.58 417.064 362.16 415.488 364.103 415.488C366.045 415.488 367.626 417.069 367.626 419.011V424.649H360.574V419.011H360.58Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.039 419.011C369.039 417.064 370.619 415.488 372.562 415.488C374.504 415.488 376.085 417.069 376.085 419.011V424.649H369.033V419.011H369.039Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.498 419.011C377.498 417.064 379.079 415.488 381.021 415.488C382.963 415.488 384.544 417.069 384.544 419.011V424.649H377.493V419.011H377.498Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.959 419.011C385.959 417.064 387.539 415.488 389.481 415.488C391.424 415.488 393.004 417.069 393.004 419.011V424.649H385.953V419.011H385.959Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.418 419.011C394.418 417.064 395.998 415.488 397.94 415.488C399.883 415.488 401.463 417.069 401.463 419.011V424.649H394.412V419.011H394.418Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.015 401.74C221.015 399.599 222.752 397.861 224.894 397.861C227.036 397.861 228.773 399.599 228.773 401.74V407.734H221.02V401.74H221.015Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.176 401.74C230.176 399.599 231.913 397.861 234.055 397.861C236.197 397.861 237.934 399.599 237.934 401.74V407.734H230.182V401.74H230.176Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.928 401.74C237.928 399.599 239.665 397.861 241.807 397.861C243.949 397.861 245.686 399.599 245.686 401.74V407.734H237.934V401.74H237.928Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.094 401.74C247.094 399.599 248.831 397.861 250.973 397.861C253.115 397.861 254.852 399.599 254.852 401.74V407.734H247.1V401.74H247.094Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.848 401.74C254.848 399.599 256.585 397.861 258.727 397.861C260.869 397.861 262.606 399.599 262.606 401.74V407.734H254.853V401.74H254.848Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.026 368.961H232.291V391.518H252.026V368.961Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.641 371.074H233.705V388.694H238.641V371.074Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.98 371.074H240.043V388.694H244.98V371.074Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.618 371.074H246.389V388.694H250.618V371.074Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.641 371.074H233.705V372.482H238.641V371.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.98 371.074H240.043V372.482H244.98V371.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.807 361.915C242.39 361.915 242.865 362.39 242.865 362.972V365.794C242.865 366.377 242.39 366.852 241.807 366.852C241.225 366.852 240.75 366.377 240.75 365.794V362.972C240.75 362.39 241.225 361.915 241.807 361.915Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.291 362.972C232.291 362.39 232.765 361.915 233.348 361.915C233.931 361.915 234.405 362.39 234.405 362.972V364.381C234.405 365.621 233.488 366.652 232.291 366.825V362.972Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.917 362.972C249.917 362.39 250.391 361.915 250.974 361.915C251.557 361.915 252.031 362.39 252.031 362.972V366.825C250.834 366.652 249.917 365.627 249.917 364.381V362.972Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.618 371.074H246.389V372.482H250.618V371.074Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.256 388.701H228.062V391.523H256.256V388.701Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.813 404.205H232.291V407.728H235.813V404.205Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53 406.323H102.593V409.846H107.53V406.323Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.644 406.323H147.708V409.846H152.644V406.323Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.756 406.323H192.82V409.846H197.756V406.323Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.507 406.323H286.571V409.846H291.507V406.323Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.621 406.323H331.684V409.846H336.621V406.323Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.734 406.323H376.797V409.846H381.734V406.323Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.352 402.799H105.76C106.731 402.799 107.524 403.587 107.524 404.563C107.524 405.534 106.737 406.327 105.76 406.327H104.352C103.381 406.327 102.588 405.54 102.588 404.563C102.588 403.592 103.376 402.799 104.352 402.799Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.465 402.799H150.873C151.844 402.799 152.637 403.587 152.637 404.563C152.637 405.534 151.849 406.327 150.873 406.327H149.465C148.494 406.327 147.701 405.54 147.701 404.563C147.701 403.592 148.488 402.799 149.465 402.799Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.579 402.799H195.987C196.958 402.799 197.751 403.587 197.751 404.563C197.751 405.534 196.964 406.327 195.987 406.327H194.579C193.608 406.327 192.815 405.54 192.815 404.563C192.815 403.592 193.603 402.799 194.579 402.799Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.329 402.799H289.737C290.708 402.799 291.501 403.587 291.501 404.563C291.501 405.534 290.714 406.327 289.737 406.327H288.329C287.358 406.327 286.565 405.54 286.565 404.563C286.565 403.592 287.353 402.799 288.329 402.799Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.442 402.799H334.851C335.822 402.799 336.615 403.587 336.615 404.563C336.615 405.534 335.827 406.327 334.851 406.327H333.442C332.471 406.327 331.678 405.54 331.678 404.563C331.678 403.592 332.466 402.799 333.442 402.799Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.556 402.799H379.964C380.935 402.799 381.728 403.587 381.728 404.563C381.728 405.534 380.941 406.327 379.964 406.327H378.556C377.585 406.327 376.792 405.54 376.792 404.563C376.792 403.592 377.58 402.799 378.556 402.799Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.566 404.205H240.043V407.728H243.566V404.205Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.732 404.205H249.209V407.728H252.732V404.205Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.026 367.554H232.291V368.962H252.026V367.554Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.801 340.766H235.819V368.96H247.801V340.766Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.094 325.261H236.52V340.766H247.094V325.261Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.073 325.26C246.895 323.674 245.552 322.438 243.922 322.438H239.693C238.058 322.438 236.715 323.674 236.542 325.26H247.079H247.073Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.048 322.44L240.744 261.114H242.163L242.859 322.44H240.048Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.457 252.655V261.115",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4453 429.586H88.4967V438.752H81.4453V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.853 444.384H87.0827V450.022H82.853V444.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6113 444.384H96.2492V450.022H90.6113V444.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.772 444.384H105.41V450.022H99.772V444.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.938 444.384H114.576V450.022H108.938V444.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.099 444.384H123.737V450.022H118.099V444.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.558 444.384H132.196V450.022H126.558V444.384Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.558 444.384H132.196V450.022H126.558V444.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.132 442.975H139.954V450.026H137.132V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.886 442.975H149.116V450.026H144.886V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.046 442.975H157.569V450.026H154.046V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.506 442.975H166.029V450.026H162.506V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.672 442.975H175.195V450.026H171.672V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.131 442.975H184.361V450.026H180.131V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.59 442.975H192.82V450.026H188.59V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.044 442.975H201.274V450.026H197.044V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.803 442.975H207.625V450.026H204.803V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.996 442.975H278.818V450.026H275.996V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.749 442.975H287.978V450.026H283.749V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.916 442.975H296.439V450.026H292.916V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.37 442.975H304.893V450.026H301.37V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.535 442.975H314.058V450.026H310.535V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.288 442.975H322.517V450.026H318.288V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.748 442.975H330.977V450.026H326.748V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.914 442.975H340.144V450.026H335.914V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.074 442.975H347.896V450.026H345.074V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0367 421.127H37.0381V438.747H80.0367V421.127Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.126 442.975H357.063V450.026H352.126V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.994 442.975H366.223V450.026H361.994V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.452 442.975H375.389V450.026H370.452V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.613 442.975H384.55V450.026H379.613V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.779 442.975H393.716V450.026H388.779V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.238 442.975H402.175V450.026H397.238V442.975Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9048 429.586H96.9561V438.752H89.9048V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3628 429.586H105.414V438.752H98.3628V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6587 429.586H61.71V438.752H54.6587V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1177 429.586H70.169V438.752H63.1177V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7393 429.586H44.7906V438.752H37.7393V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1987 429.586H53.2501V438.752H46.1987V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5771 429.586H78.6285V438.752H71.5771V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.887 419.712H106.116V424.648H101.887V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.347 419.712H114.577V424.648H110.347V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.507 419.712H123.03V424.648H119.507V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.966 419.712H131.489V424.648H127.966V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.132 419.712H140.655V424.648H137.132V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.592 419.712H149.115V424.648H145.592V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.046 419.712H157.569V424.648H154.046V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.506 419.712H166.029V424.648H162.506V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.965 419.712H174.488V424.648H170.965V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.425 419.712H182.948V424.648H179.425V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.884 419.712H191.407V424.648H187.884V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.344 419.712H199.867V424.648H196.344V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.096 419.712H207.619V424.648H204.096V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.703 419.712H280.932V424.648H276.703V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.156 419.712H289.385V424.648H285.156V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.323 419.712H297.846V424.648H294.323V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.782 419.712H306.305V424.648H302.782V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.241 419.712H314.764V424.648H311.241V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.696 419.712H323.219V424.648H319.696V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.862 419.712H332.385V424.648H328.862V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.321 419.712H340.844V424.648H337.321V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.781 419.712H349.304V424.648H345.781V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.24 419.712H357.763V424.648H354.24V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.694 419.712H366.217V424.648H362.694V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.154 419.712H374.677V424.648H371.154V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.912 419.712H382.435V424.648H378.912V419.712Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.938 429.586H115.989V438.752H108.938V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.393 429.586H124.444V438.752H117.393V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.852 429.586H132.903V438.752H125.852V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.018 429.586H142.069V438.752H135.018V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.477 429.586H150.528V438.752H143.477V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.937 429.586H158.988V438.752H151.937V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.391 429.586H167.442V438.752H160.391V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.85 429.586H175.901V438.752H168.85V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.31 429.586H184.361V438.752H177.31V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.769 429.586H192.82V438.752H185.769V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.229 429.586H201.28V438.752H194.229V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.688 429.586H207.625V438.752H202.688V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.588 429.586H281.64V438.752H274.588V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.042 429.586H290.094V438.752H283.042V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.5 429.586H298.551V438.752H291.5V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.075 429.586H309.127V438.752H302.075V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.535 429.586H317.586V438.752H310.535V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.995 429.586H326.046V438.752H318.995V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.155 429.586H335.207V438.752H328.155V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.615 429.586H343.667V438.752H336.615V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.074 429.586H352.126V438.752H345.074V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.285 421.127H404.286V449.322H447.285V421.127Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.533 429.586H360.585V438.752H353.533V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.994 429.586H369.045V438.752H361.994V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.452 429.586H377.503V438.752H370.452V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.912 429.586H385.963V438.752H378.912V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.366 429.586H394.418V438.752H387.366V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.827 429.586H402.878V438.752H395.827V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.693 429.586H412.744V438.752H405.693V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.152 429.586H421.203V438.752H414.152V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.612 429.586H429.663V438.752H422.612V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.071 429.586H438.123V438.752H431.071V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.53 429.586H446.582V438.752H439.53V429.586Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.285 421.127H404.286V449.322H447.285V421.127Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.285 421.127H404.286V424.65H447.285V421.127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0367 421.127H37.0381V425.357H80.0367V421.127Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.807 356.277C243.95 356.277 245.686 354.54 245.686 352.398C245.686 350.255 243.95 348.519 241.807 348.519C239.665 348.519 237.928 350.255 237.928 352.398C237.928 354.54 239.665 356.277 241.807 356.277Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.808 353.805C242.585 353.805 243.216 353.175 243.216 352.397C243.216 351.62 242.585 350.989 241.808 350.989C241.03 350.989 240.399 351.62 240.399 352.397C240.399 353.175 241.03 353.805 241.808 353.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.055 402.792C235.417 402.792 236.52 401.689 236.52 400.327C236.52 398.965 235.417 397.861 234.055 397.861C232.693 397.861 231.589 398.965 231.589 400.327C231.589 401.689 232.693 402.792 234.055 402.792Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.808 402.792C243.17 402.792 244.273 401.689 244.273 400.327C244.273 398.965 243.17 397.861 241.808 397.861C240.446 397.861 239.342 398.965 239.342 400.327C239.342 401.689 240.446 402.792 241.808 402.792Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.974 402.792C252.336 402.792 253.44 401.689 253.44 400.327C253.44 398.965 252.336 397.861 250.974 397.861C249.613 397.861 248.509 398.965 248.509 400.327C248.509 401.689 249.613 402.792 250.974 402.792Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.456 245.688L242.465 248.796L242.546 249.039H246.069L243.426 250.959L243.221 251.111L243.302 251.353L244.31 254.461L241.667 252.54L241.462 252.389L241.257 252.54L238.613 254.461L239.622 251.353L239.703 251.111L239.498 250.959L236.854 249.039H240.377L240.458 248.796L241.467 245.688H241.456Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.98 327.374H243.572V331.604H244.98V327.374Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.336 327.374H237.928V331.604H239.336V327.374Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.181 433.814H105.411V438.751H101.181V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.347 433.814H114.577V438.751H110.347V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.507 433.814H123.03V438.751H119.507V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.966 433.814H131.489V438.751H127.966V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.132 433.814H140.655V438.751H137.132V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.592 433.814H149.115V438.751H145.592V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.046 433.814H157.569V438.751H154.046V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.506 433.814H166.029V438.751H162.506V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.965 433.814H174.488V438.751H170.965V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.425 433.814H182.948V438.751H179.425V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.884 433.814H191.407V438.751H187.884V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.344 433.814H199.867V438.751H196.344V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.096 433.814H207.619V438.751H204.096V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.703 433.814H280.932V438.751H276.703V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.156 433.814H289.385V438.751H285.156V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.323 433.814H297.846V438.751H294.323V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.782 433.814H306.305V438.751H302.782V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.241 433.814H314.764V438.751H311.241V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.696 433.814H323.219V438.751H319.696V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.862 433.814H332.385V438.751H328.862V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.321 433.814H340.844V438.751H337.321V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.781 433.814H349.304V438.751H345.781V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.24 433.814H357.763V438.751H354.24V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.694 433.814H366.217V438.751H362.694V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.154 433.814H374.677V438.751H371.154V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.912 433.814H382.435V438.751H378.912V433.814Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.583 409.845H207.619V450.022H274.583V409.845Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.309 423.239C220.309 420.515 222.515 418.303 225.245 418.303C227.975 418.303 230.182 420.509 230.182 423.239V438.745H220.314V423.239H220.309Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.228 423.239C237.228 420.515 239.434 418.303 242.164 418.303C244.894 418.303 247.1 420.509 247.1 423.239V438.745H237.233V423.239H237.228Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.848 423.239C254.848 420.515 257.054 418.303 259.784 418.303C262.514 418.303 264.721 420.509 264.721 423.239V438.745H254.853V423.239H254.848Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.583 438.747H207.619V450.023H274.583V438.747Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.583 438.747H207.619V440.155H274.583V438.747Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.583 441.567H207.619V442.975H274.583V441.567Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.583 444.384H207.619V445.792H274.583V444.384Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.583 447.205H207.619V448.613H274.583V447.205Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.286 409.845H80.0376V412.666H404.286V409.845Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.286 409.845H279.52V412.666H404.286V409.845Z",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.327 409.845H80.0376V412.666H208.327V409.845Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.315 417.597H213.263V438.745H220.315V417.597Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.228 417.597H230.176V438.745H237.228V417.597Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.847 417.597H247.094V438.745H254.847V417.597Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.468 417.597H264.715V438.745H272.468V417.597Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.192 428.172H257.669V438.746H261.192V428.172Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.273 428.172H240.75V438.746H244.273V428.172Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.653 428.172H223.13V438.746H226.653V428.172Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.43 423.24C217.404 423.24 218.194 422.45 218.194 421.476C218.194 420.502 217.404 419.712 216.43 419.712C215.455 419.712 214.666 420.502 214.666 421.476C214.666 422.45 215.455 423.24 216.43 423.24Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.43 428.877C217.404 428.877 218.194 428.087 218.194 427.113C218.194 426.138 217.404 425.349 216.43 425.349C215.455 425.349 214.666 426.138 214.666 427.113C214.666 428.087 215.455 428.877 216.43 428.877Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.43 434.523C217.404 434.523 218.194 433.734 218.194 432.759C218.194 431.785 217.404 430.995 216.43 430.995C215.455 430.995 214.666 431.785 214.666 432.759C214.666 433.734 215.455 434.523 216.43 434.523Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.348 423.24C234.322 423.24 235.112 422.45 235.112 421.476C235.112 420.502 234.322 419.712 233.348 419.712C232.373 419.712 231.583 420.502 231.583 421.476C231.583 422.45 232.373 423.24 233.348 423.24Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.348 428.877C234.322 428.877 235.112 428.087 235.112 427.113C235.112 426.138 234.322 425.349 233.348 425.349C232.373 425.349 231.583 426.138 231.583 427.113C231.583 428.087 232.373 428.877 233.348 428.877Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.348 434.523C234.322 434.523 235.112 433.734 235.112 432.759C235.112 431.785 234.322 430.995 233.348 430.995C232.373 430.995 231.583 431.785 231.583 432.759C231.583 433.734 232.373 434.523 233.348 434.523Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.974 423.24C251.948 423.24 252.738 422.45 252.738 421.476C252.738 420.502 251.948 419.712 250.974 419.712C249.999 419.712 249.209 420.502 249.209 421.476C249.209 422.45 249.999 423.24 250.974 423.24Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.974 428.877C251.948 428.877 252.738 428.087 252.738 427.113C252.738 426.138 251.948 425.349 250.974 425.349C249.999 425.349 249.209 426.138 249.209 427.113C249.209 428.087 249.999 428.877 250.974 428.877Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.974 434.523C251.948 434.523 252.738 433.734 252.738 432.759C252.738 431.785 251.948 430.995 250.974 430.995C249.999 430.995 249.209 431.785 249.209 432.759C249.209 433.734 249.999 434.523 250.974 434.523Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.594 423.24C269.569 423.24 270.358 422.45 270.358 421.476C270.358 420.502 269.569 419.712 268.594 419.712C267.62 419.712 266.83 420.502 266.83 421.476C266.83 422.45 267.62 423.24 268.594 423.24Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.594 428.877C269.569 428.877 270.358 428.087 270.358 427.113C270.358 426.138 269.569 425.349 268.594 425.349C267.62 425.349 266.83 426.138 266.83 427.113C266.83 428.087 267.62 428.877 268.594 428.877Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.594 434.523C269.569 434.523 270.358 433.734 270.358 432.759C270.358 431.785 269.569 430.995 268.594 430.995C267.62 430.995 266.83 431.785 266.83 432.759C266.83 433.734 267.62 434.523 268.594 434.523Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.176 420.768C230.176 421.351 229.728 421.966 228.817 422.452C227.921 422.932 226.659 423.234 225.245 423.234C223.832 423.234 222.569 422.926 221.674 422.452C220.762 421.966 220.314 421.356 220.314 420.768C220.314 420.18 220.762 419.571 221.674 419.085C222.569 418.605 223.832 418.303 225.245 418.303C226.659 418.303 227.921 418.61 228.817 419.085C229.728 419.571 230.176 420.18 230.176 420.768Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.095 420.768C247.095 421.351 246.647 421.966 245.735 422.452C244.839 422.932 243.577 423.234 242.164 423.234C240.75 423.234 239.488 422.926 238.592 422.452C237.68 421.966 237.232 421.356 237.232 420.768C237.232 420.18 237.68 419.571 238.592 419.085C239.488 418.605 240.75 418.303 242.164 418.303C243.577 418.303 244.839 418.61 245.735 419.085C246.647 419.571 247.095 420.18 247.095 420.768Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.716 420.768C264.716 421.351 264.268 421.966 263.356 422.452C262.461 422.932 261.198 423.234 259.785 423.234C258.371 423.234 257.109 422.926 256.213 422.452C255.301 421.966 254.854 421.356 254.854 420.768C254.854 420.18 255.301 419.571 256.213 419.085C257.109 418.605 258.371 418.303 259.785 418.303C261.198 418.303 262.461 418.61 263.356 419.085C264.268 419.571 264.716 420.18 264.716 420.768Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.312 367.552C232.49 365.966 233.833 364.73 235.462 364.73H248.853C250.488 364.73 251.831 365.966 252.003 367.552H232.306H232.312Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.684 340.765L231.805 333.013H251.81L247.931 340.765H235.679H235.684Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.336 335.13H237.928V339.36H239.336V335.13Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.158 335.13H240.75V339.36H242.158V335.13Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.98 335.13H243.572V339.36H244.98V335.13Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.062 386.936C228.062 386.354 228.536 385.879 229.119 385.879C229.702 385.879 230.176 386.354 230.176 386.936V388.344C230.176 389.585 229.259 390.616 228.062 390.788V386.936Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.146 386.936C254.146 386.354 254.621 385.879 255.204 385.879C255.787 385.879 256.261 386.354 256.261 386.936V390.788C255.064 390.616 254.146 389.591 254.146 388.344V386.936Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1929.68 396.453H1797.86V449.319H1929.68V396.453Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1929.68 433.108H1797.86V449.321H1929.68V433.108Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.03 407.026H1804.2V414.078H1807.03V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1933.55 400.327H1793.98V402.442H1933.55V400.327Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.03 421.828H1804.2V428.879H1807.03V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.73 436.632H1800.68V449.321H1807.73V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.65 436.632H1814.07V449.321H1824.65V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.15 436.632H1829.58V449.321H1840.15V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.66 436.632H1845.09V449.321H1855.66V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.19 439.096C1859.19 436.566 1861.24 434.516 1863.77 434.516C1866.3 434.516 1868.35 436.566 1868.35 439.096V449.32H1859.18V439.096H1859.19Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.45 436.632H1871.88V449.321H1882.45V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.96 436.632H1887.38V449.321H1897.96V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1914.17 436.632H1903.59V449.321H1914.17V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1926.15 436.632H1919.8V449.321H1926.15V436.632Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.73 438.747H1800.68V449.321H1807.73V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.65 438.747H1814.07V449.321H1824.65V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840.15 438.747H1829.58V449.321H1840.15V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.66 438.747H1845.09V449.321H1855.66V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1859.19 441.212C1859.19 438.682 1861.24 436.632 1863.77 436.632C1866.3 436.632 1868.35 438.682 1868.35 441.212V449.321H1859.18V441.212H1859.19Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1882.45 438.747H1871.88V449.321H1882.45V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.96 438.747H1887.38V449.321H1897.96V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1914.17 438.747H1903.59V449.321H1914.17V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1926.15 438.747H1919.8V449.321H1926.15V438.747Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819.01 407.026H1816.19V414.078H1819.01V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1819.01 421.828H1816.19V428.879H1819.01V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.76 407.026H1823.94V414.078H1826.76V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.76 421.828H1823.94V428.879H1826.76V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.51 407.026H1831.69V414.078H1834.51V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.51 421.828H1831.69V428.879H1834.51V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.56 407.026H1838.74V414.078H1841.56V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.56 421.828H1838.74V428.879H1841.56V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850.02 407.026H1847.2V414.078H1850.02V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1850.02 421.828H1847.2V428.879H1850.02V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.07 407.026H1854.25V414.078H1857.07V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.07 421.828H1854.25V428.879H1857.07V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.53 407.026H1862.71V414.078H1865.53V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.53 421.828H1862.71V428.879H1865.53V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1873.99 407.026H1871.17V414.078H1873.99V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1873.99 421.828H1871.17V428.879H1873.99V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.74 407.026H1878.92V414.078H1881.74V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.74 421.828H1878.92V428.879H1881.74V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.79 407.026H1885.97V414.078H1888.79V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1888.79 421.828H1885.97V428.879H1888.79V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.25 407.026H1894.43V414.078H1897.25V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1897.25 421.828H1894.43V428.879H1897.25V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.01 407.026H1902.18V414.078H1905.01V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.01 421.828H1902.18V428.879H1905.01V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.05 407.026H1909.23V414.078H1912.05V407.026Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1912.05 421.828H1909.23V428.879H1912.05V421.828Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931.79 396.453H1795.75V400.683H1931.79V396.453Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.84 397.861H1797.86V399.269H1809.84V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.76 397.861H1814.77V399.269H1826.76V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1843.67 397.861H1831.69V399.269H1843.67V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.59 397.861H1848.61V399.269H1860.59V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.51 397.861H1865.53V399.269H1877.51V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.43 397.861H1882.44V399.269H1894.43V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1911.35 397.861H1899.36V399.269H1911.35V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1928.26 397.861H1916.28V399.269H1928.26V397.861Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.63 393.283L1867.94 393.423L1868.05 393.989H1868.63V393.283ZM1871.52 393.283H1872.22V392.576H1871.52V393.283ZM1871.52 396.806V397.512H1872.22V396.806H1871.52ZM1857.42 396.806H1856.71V397.512H1857.42V396.806ZM1857.42 393.283V392.576H1856.71V393.283H1857.42ZM1860.31 393.283V393.989H1860.89L1861 393.423L1860.31 393.283ZM1868.63 393.989H1871.52V392.581H1868.63V393.989ZM1870.82 393.283V396.806H1872.22V393.283H1870.82ZM1871.52 396.099H1857.42V397.507H1871.52V396.099ZM1858.13 396.806V393.283H1856.72V396.806H1858.13ZM1857.42 393.989H1860.31V392.581H1857.42V393.989ZM1861 393.423C1861.26 392.139 1862.41 391.168 1863.77 391.168V389.76C1861.72 389.76 1860.02 391.211 1859.62 393.142L1861 393.423ZM1863.77 391.168H1865.17V389.76H1863.77V391.168ZM1865.17 391.168C1866.53 391.168 1867.68 392.139 1867.94 393.423L1869.32 393.142C1868.92 391.211 1867.22 389.76 1865.17 389.76V391.168Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1868.63 393.282H1871.52V396.805H1857.42V393.282H1860.31C1860.64 391.674 1862.06 390.46 1863.77 390.46H1865.17C1866.88 390.46 1868.3 391.668 1868.63 393.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.794 414.782C467.467 414.782 471.254 418.57 471.254 423.242V433.816C471.254 438.488 467.467 442.275 462.794 442.275C458.122 442.275 454.335 438.488 454.335 433.816V423.242C454.335 418.57 458.122 414.782 462.794 414.782Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.852 417.247C467.747 417.247 470.903 420.403 470.903 424.298V434.166C470.903 438.061 467.747 441.217 463.852 441.217C459.957 441.217 456.801 438.061 456.801 434.166V424.298C456.801 420.403 459.957 417.247 463.852 417.247Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.438 424.298V450.378",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.726 426.414L462.789 431.351",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.857 432.051L462.794 436.987",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.858 426.414L462.795 431.351",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.265 414.782C506.937 414.782 510.725 418.57 510.725 423.242C510.725 427.914 506.937 431.701 502.265 431.701C497.593 431.701 493.806 427.914 493.806 423.242C493.806 418.57 497.593 414.782 502.265 414.782Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.264 417.956H502.97C506.671 417.956 509.666 420.956 509.666 424.651C509.666 428.352 506.666 431.347 502.97 431.347H502.264C498.563 431.347 495.568 428.347 495.568 424.651C495.568 420.95 498.568 417.956 502.264 417.956Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.914 424.298V450.378",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.845 425L501.908 429.936",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.334 425L502.27 429.936",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.07 436.686C474.07 433.676 474.69 430.703 475.888 427.946L477.091 425.184C479.427 419.821 487.034 419.821 489.37 425.184L490.573 427.946C491.776 430.703 492.391 433.676 492.391 436.686C492.391 437.436 491.782 438.046 491.032 438.046H475.424C474.674 438.046 474.064 437.436 474.064 436.686H474.07Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.535 436.34C476.535 433.886 477.048 431.458 478.046 429.213L478.618 427.929C480.803 423.009 487.784 423.009 489.969 427.929L490.541 429.213C491.533 431.458 492.051 433.886 492.051 436.34C492.051 437.085 491.447 437.695 490.697 437.695H477.895C477.15 437.695 476.541 437.09 476.541 436.34H476.535Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.236 432.76V450.029",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.817 431.345L483.236 435.574",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.708 433.461L483.231 437.34",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.738 449.979C432.464 447.028 432.928 441.763 436.672 439.432L442.881 435.569C443.842 434.976 445.061 434.997 445.989 435.634L451.497 439.394C455.063 441.833 455.538 446.91 452.485 449.963C452.447 450.001 452.393 450.022 452.339 450.022H435.857C435.814 450.022 435.765 450.006 435.733 449.974L435.738 449.979Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.733 449.974C435.765 450.006 435.814 450.022 435.857 450.022H452.339C452.393 450.022 452.447 450.001 452.485 449.963C455.538 446.91 455.063 441.833 451.497 439.394L445.989 435.634C445.061 434.997 443.842 434.976 442.881 435.569L436.672 439.432C432.928 441.763 432.464 447.028 435.738 449.979L435.733 449.974ZM435.733 449.974L435.496 450.238",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.235 449.526C434.087 446.953 434.778 443.068 437.675 441.385L444.629 437.355C445.395 436.912 446.345 436.923 447.106 437.382L451.869 440.29C455.258 442.356 455.495 447.185 452.333 449.58C452.258 449.639 452.166 449.666 452.069 449.666H436.547C436.423 449.666 436.305 449.612 436.229 449.515L436.235 449.526Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.404 444.035V449.673",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.991 442.627L443.41 446.857",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.882 444.741L443.405 448.62",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.719 450.378H514.095C515.908 450.378 517.651 449.693 518.973 448.458L519.927 447.567C520.24 447.276 520.467 446.909 520.591 446.499L520.677 446.197C521.341 443.958 518.627 442.27 516.912 443.861V442.663C516.912 440.198 513.815 439.092 512.256 441.007C513 438.029 509.58 435.768 507.136 437.624L506.44 438.153L506.251 437.565C505.593 435.52 503.37 434.425 501.352 435.153C499.335 435.882 498.32 438.132 499.108 440.122L499.459 441.007C496.459 441.007 494.786 444.465 496.648 446.818L498.056 448.598C498.946 449.72 500.3 450.378 501.73 450.378H501.719Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.788 450.027L501.559 443.332",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.379 447.205L506.844 441.918",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.781 450.379L515.304 445.799",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.432 444.741L513.897 447.207",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.316 450.027L502.265 438.396",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.545 439.783C667.957 437.248 668.437 433.439 666.727 430.385L657.026 413.018C656.082 411.33 653.66 411.33 652.716 413.018L642.729 430.898C641.176 433.682 641.51 437.145 643.582 439.578C645.033 441.289 647.164 442.27 649.409 442.27H659.751C661.941 442.27 664.034 441.369 665.545 439.783Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.963 440.14C667.289 437.971 667.747 434.453 666.048 431.761L657.961 418.926C656.855 417.173 654.292 417.173 653.186 418.926L643.95 433.59C642.909 435.241 643.13 437.388 644.478 438.802C646.394 440.798 649.037 441.925 651.8 441.925H660.432C662.11 441.925 663.728 441.289 664.953 440.145L664.963 440.14Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.874 424.299V450.379",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.586 426.414L654.522 431.351",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.161 432.052L655.225 436.988",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.454 426.414L654.518 431.351",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.58 449.982C684.854 447.031 684.391 441.766 680.646 439.435L674.437 435.572C673.476 434.979 672.257 435 671.329 435.637L665.821 439.397C662.255 441.836 661.78 446.912 664.833 449.966C664.871 450.004 664.925 450.025 664.979 450.025H681.461C681.504 450.025 681.553 450.009 681.585 449.977L681.58 449.982Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.585 449.977C681.553 450.009 681.504 450.025 681.461 450.025H664.979C664.925 450.025 664.871 450.004 664.833 449.966C661.78 446.912 662.255 441.836 665.821 439.397L671.329 435.637C672.257 435 673.476 434.979 674.437 435.572L680.646 439.435C684.391 441.766 684.854 447.031 681.58 449.982L681.585 449.977ZM681.585 449.977L681.822 450.241",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.492 449.527C684.639 446.954 683.949 443.069 681.052 441.386L674.097 437.356C673.331 436.913 672.382 436.924 671.621 437.383L666.857 440.291C663.469 442.357 663.232 447.186 666.393 449.581C666.469 449.64 666.561 449.667 666.658 449.667H682.179C682.303 449.667 682.422 449.613 682.497 449.516L682.492 449.527Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.907 444.036V449.674",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.327 442.626L673.908 446.856",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.429 444.74L673.906 448.619",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.66 449.32H-12.3047V471.17H2298.66V449.32Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.66 453.9H-12.6558V470.819H2298.66V453.9Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.4521 470.819H466.463L307.158 465.883H117.544L-11.4521 470.819Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.528 470.819H875.51L739.468 465.883H549.854L316.534 470.819H316.528Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.606 470.819H1660.76L1433.07 465.883H989.698L803.606 470.819Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.98 470.819H2298.66V465.883H1937.07L1750.98 470.819Z",
    fill: "#6F9392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.55 460.951C1300.35 462.953 1298.67 464.474 1296.66 464.474H1296.15C1294.08 464.474 1292.31 462.991 1291.95 460.951C1291.63 462.98 1289.85 464.474 1287.79 464.474C1285.72 464.474 1283.93 462.985 1283.57 460.951C1283.2 462.991 1281.42 464.474 1279.35 464.474H1279.08C1277 464.474 1275.24 462.991 1274.87 460.951L1274.74 461.55C1274.38 463.26 1272.87 464.48 1271.12 464.48H1270.94C1268.99 464.48 1267.42 462.899 1267.42 460.957",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M962.349 477.045C957.742 475.508 954.235 477.687 953.064 478.966C952.633 479.176 951.715 479.414 951.462 478.648C954.019 475.767 959.144 474.806 962.344 477.045H962.349Z",
    fill: "url(#paint5_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.386 461.222V463.504L408.871 463.239C408.223 461.945 406.902 461.13 405.456 461.13H385.478C385.429 461.13 385.386 461.173 385.386 461.222Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.527 488.31H363.757C363.757 489.475 362.813 490.424 361.642 490.424H359.527V488.31Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.98 435.929H1780.52L1827.68 458.485H1756.98V435.929Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.6 435.929H1756.98V458.485H1774.6V435.929Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.96 441.567H1762.61V458.486H1768.96V441.567Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 434.398L1768.11 428.555H1768.04L1766.53 431.776L1764.96 428.522L1762.82 434.392H1762.26V434.862H1765.3V434.392H1764.7L1765.3 432.558L1766.53 434.867L1767.71 432.558L1768.31 434.392H1767.71V434.862H1770.72V434.392H1770.19L1770.2 434.398Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.75 459.942C1119.75 456.932 1120.37 453.959 1121.57 451.202L1122.77 448.44C1125.1 443.077 1132.72 443.077 1135.05 448.44L1136.25 451.202C1137.45 453.959 1138.07 456.932 1138.07 459.942C1138.07 460.692 1137.47 461.302 1136.71 461.302H1121.1C1120.35 461.302 1119.75 460.692 1119.75 459.942H1119.75Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.22 459.596C1122.22 457.141 1122.73 454.714 1123.73 452.469L1124.3 451.185C1126.49 446.265 1133.47 446.265 1135.65 451.185L1136.23 452.469C1137.22 454.714 1137.74 457.141 1137.74 459.596C1137.74 460.341 1137.13 460.95 1136.38 460.95H1123.58C1122.83 460.95 1122.23 460.346 1122.23 459.596H1122.22Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.92 456.016V461.653",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.5 454.607L1128.92 458.837",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.39 456.722L1128.92 460.601",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.96 461.254C1069.68 458.303 1070.15 453.037 1073.89 450.706L1080.1 446.844C1081.06 446.25 1082.28 446.272 1083.2 446.908L1088.72 450.669C1092.28 453.107 1092.76 458.184 1089.71 461.238C1089.66 461.275 1089.61 461.297 1089.56 461.297H1073.08C1073.04 461.297 1072.99 461.281 1072.96 461.248V461.254Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.96 461.248C1072.99 461.281 1073.04 461.297 1073.08 461.297H1089.56C1089.61 461.297 1089.66 461.275 1089.71 461.238C1092.76 458.184 1092.28 453.107 1088.72 450.669L1083.2 446.908C1082.28 446.272 1081.06 446.25 1080.1 446.844L1073.89 450.706C1070.15 453.037 1069.68 458.303 1072.96 461.254V461.248ZM1072.96 461.248L1072.72 461.513",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.46 460.801C1071.31 458.228 1072 454.344 1074.9 452.66L1081.85 448.63C1082.62 448.188 1083.57 448.199 1084.33 448.657L1089.09 451.565C1092.48 453.631 1092.72 458.46 1089.55 460.855C1089.48 460.915 1089.39 460.942 1089.3 460.942H1073.78C1073.65 460.942 1073.54 460.888 1073.46 460.791V460.801Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.63 455.314V460.952",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.21 453.899L1080.63 458.129",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.11 456.016L1080.63 459.895",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.94 461.653H1151.32C1153.13 461.653 1154.87 460.968 1156.19 459.732L1157.14 458.842C1157.46 458.551 1157.69 458.184 1157.81 457.774L1157.9 457.472C1158.56 455.233 1155.85 453.544 1154.13 455.135V453.938C1154.13 451.472 1151.03 450.366 1149.47 452.281C1150.22 449.303 1146.8 447.043 1144.35 448.899L1143.65 449.427L1143.47 448.839C1142.8 446.795 1140.59 445.7 1138.56 446.428C1136.54 447.156 1135.53 449.406 1136.32 451.397L1136.67 452.281C1133.68 452.281 1132 455.74 1133.86 458.092L1135.27 459.872C1136.16 460.994 1137.51 461.653 1138.94 461.653Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.01 461.303L1138.78 454.607",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.61 458.481L1144.07 453.193",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149 461.652L1152.53 457.071",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.65 456.016L1151.12 458.481",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.54 461.303L1139.49 449.671",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.443 459.942C124.443 456.932 125.064 453.959 126.262 451.202L127.465 448.44C129.801 443.077 137.408 443.077 139.744 448.44L140.947 451.202C142.15 453.959 142.765 456.932 142.765 459.942C142.765 460.692 142.155 461.302 141.405 461.302H125.798C125.048 461.302 124.438 460.692 124.438 459.942H124.443Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.909 459.598C126.909 457.143 127.422 454.716 128.42 452.471L128.992 451.187C131.177 446.267 138.158 446.267 140.343 451.187L140.915 452.471C141.907 454.716 142.425 457.143 142.425 459.598C142.425 460.343 141.821 460.952 141.071 460.952H128.269C127.524 460.952 126.915 460.348 126.915 459.598H126.909Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.605 456.016V461.653",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19 454.607L133.61 458.837",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.082 456.723L133.605 460.602",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6519 461.254C74.3771 458.303 74.8411 453.037 78.5853 450.706L84.795 446.844C85.7553 446.25 86.9746 446.272 87.9025 446.908L93.4109 450.669C96.977 453.107 97.4518 458.184 94.3982 461.238C94.3604 461.275 94.3064 461.297 94.2525 461.297H77.7706C77.7274 461.297 77.6789 461.281 77.6465 461.248L77.6519 461.254Z",
    fill: "#FFD6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6465 461.248C77.6789 461.281 77.7274 461.297 77.7706 461.297H94.2525C94.3064 461.297 94.3604 461.275 94.3982 461.238C97.4518 458.184 96.977 453.107 93.4109 450.669L87.9025 446.908C86.9746 446.272 85.7553 446.25 84.795 446.844L78.5853 450.706C74.8411 453.037 74.3771 458.303 77.6519 461.254L77.6465 461.248ZM77.6465 461.248L77.4091 461.513",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1491 460.801C76.0019 458.228 76.6924 454.344 79.5896 452.66L86.5438 448.63C87.3099 448.188 88.2594 448.199 89.0201 448.657L93.784 451.565C97.1721 453.631 97.4095 458.46 94.248 460.855C94.1724 460.915 94.0807 460.942 93.9836 460.942H78.462C78.3379 460.942 78.2192 460.888 78.1437 460.791L78.1491 460.801Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3242 455.312V460.949",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9046 453.9L85.3242 458.13",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7964 456.016L85.3194 459.895",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.634 461.654H156.01C157.823 461.654 159.566 460.968 160.888 459.733L161.842 458.843C162.155 458.551 162.382 458.185 162.506 457.775L162.592 457.472C163.256 455.234 160.542 453.545 158.827 455.136V453.939C158.827 451.473 155.73 450.367 154.171 452.282C154.915 449.304 151.495 447.044 149.051 448.9L148.355 449.428L148.166 448.84C147.508 446.796 145.285 445.7 143.267 446.429C141.25 447.157 140.235 449.407 141.023 451.398L141.374 452.282C138.374 452.282 136.702 455.741 138.563 458.093L139.971 459.873C140.861 460.995 142.215 461.654 143.645 461.654H143.634Z",
    fill: "#62AE80",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.707 461.303L143.477 454.607",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.293 458.479L148.759 453.191",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.695 461.652L157.218 457.071",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.344 456.016L155.81 458.481",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.231 461.303L144.179 449.671",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1837.33 457.126C1837.33 454.115 1836.71 451.143 1835.51 448.386L1834.31 445.624C1831.98 440.261 1824.36 440.261 1822.03 445.624L1820.83 448.386C1819.63 451.143 1819.01 454.115 1819.01 457.126C1819.01 457.876 1819.61 458.485 1820.37 458.485H1835.98C1836.73 458.485 1837.33 457.876 1837.33 457.126H1837.33Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1834.86 456.781C1834.86 454.326 1834.35 451.898 1833.35 449.654L1832.78 448.37C1830.6 443.45 1823.62 443.45 1821.43 448.37L1820.86 449.654C1819.87 451.898 1819.35 454.326 1819.35 456.781C1819.35 457.525 1819.95 458.135 1820.7 458.135H1833.51C1834.25 458.135 1834.86 457.531 1834.86 456.781H1834.86Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.17 453.198V458.836",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1823.59 451.785L1828.17 456.015",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.69 453.9L1828.17 457.779",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.12 458.437C1887.4 455.486 1886.93 450.221 1883.19 447.89L1876.98 444.027C1876.02 443.434 1874.81 443.455 1873.88 444.092L1868.36 447.852C1864.8 450.291 1864.32 455.368 1867.38 458.421C1867.42 458.459 1867.47 458.48 1867.52 458.48H1884C1884.05 458.48 1884.09 458.464 1884.12 458.432V458.437Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.12 458.432C1884.09 458.464 1884.05 458.48 1884 458.48H1867.52C1867.47 458.48 1867.42 458.459 1867.38 458.421C1864.32 455.368 1864.8 450.291 1868.36 447.852L1873.88 444.092C1874.81 443.455 1876.02 443.434 1876.98 444.027L1883.19 447.89C1886.93 450.221 1887.4 455.486 1884.12 458.437V458.432ZM1884.12 458.432L1884.36 458.696",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1883.63 457.979C1885.77 455.406 1885.08 451.521 1882.19 449.838L1875.24 445.808C1874.47 445.366 1873.52 445.376 1872.76 445.835L1868 448.743C1864.61 450.809 1864.37 455.638 1867.53 458.033C1867.6 458.092 1867.69 458.119 1867.79 458.119H1883.31C1883.44 458.119 1883.54 458.065 1883.63 457.968V457.979Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1876.46 452.492V458.13",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.88 451.084L1876.46 455.314",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879.98 453.198L1876.46 457.077",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818.14 458.836H1805.77C1803.96 458.836 1802.21 458.151 1800.89 456.916L1799.94 456.025C1799.62 455.734 1799.4 455.367 1799.28 454.957L1799.19 454.655C1798.52 452.416 1801.24 450.727 1802.95 452.319V451.121C1802.95 448.656 1806.05 447.55 1807.61 449.465C1806.86 446.487 1810.28 444.226 1812.74 446.082L1813.43 446.611L1813.62 446.023C1814.28 443.978 1816.5 442.883 1818.52 443.611C1820.54 444.34 1821.55 446.589 1820.76 448.58L1820.41 449.465C1823.4 449.465 1825.08 452.923 1823.22 455.276L1821.82 457.056C1820.93 458.178 1819.58 458.836 1818.14 458.836Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.07 458.48L1818.3 451.785",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815.48 455.664L1813.01 450.377",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.08 458.838L1804.55 454.258",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.44 453.198L1805.97 455.664",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.54 458.482L1817.6 446.851",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6807 447.032C42.6807 446.544 42.2846 446.147 41.7959 446.147C41.3073 446.147 40.9111 446.544 40.9111 447.032V461.173C40.9111 461.661 41.3073 462.057 41.7959 462.057C42.2846 462.057 42.6807 461.661 42.6807 461.173V447.032Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7375 447.323H42.6816V453.215H72.7375V447.323Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.737 451.45H42.6812V452.038H72.737V451.45Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.737 449.094H42.6812V449.682H72.737V449.094Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9678 447.032C70.9678 446.541 71.3616 446.147 71.8526 446.147C72.3435 446.147 72.7374 446.541 72.7374 447.032V461.178C72.7374 461.664 72.3435 462.063 71.8526 462.063C71.3616 462.063 70.9678 461.669 70.9678 461.178V447.032Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3975 457.05C47.3975 456.561 47.0014 456.165 46.5127 456.165C46.0241 456.165 45.6279 456.561 45.6279 457.05V462.353C45.6279 462.842 46.0241 463.238 46.5127 463.238C47.0014 463.238 47.3975 462.842 47.3975 462.353V457.05Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8643 457.05C76.8643 456.561 76.4682 456.165 75.9795 456.165C75.4909 456.165 75.0947 456.561 75.0947 457.05V462.353C75.0947 462.842 75.4909 463.238 75.9795 463.238C76.4682 463.238 76.8643 462.842 76.8643 462.353V457.05Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6807 456.166L40.9111 454.693H72.7366L76.8638 456.166V457.936H45.6264L42.6807 456.166Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8653 456.165H45.6279V457.935H76.8653V456.165Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9111 454.693L45.6264 456.166V458.524L40.9111 456.463V454.693Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.29 446.147C1034.77 446.147 1035.17 446.541 1035.17 447.032V461.178C1035.17 461.664 1034.78 462.063 1034.29 462.063C1033.8 462.063 1033.4 461.669 1033.4 461.178V447.032C1033.4 446.547 1033.8 446.147 1034.29 446.147Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.23 447.323H1035.17V453.215H1065.23V447.323Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.23 451.45H1035.17V452.038H1065.23V451.45Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.23 449.094H1035.17V449.682H1065.23V449.094Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.46 447.032C1063.46 446.541 1063.85 446.147 1064.34 446.147C1064.82 446.147 1065.23 446.541 1065.23 447.032V461.178C1065.23 461.664 1064.83 462.063 1064.34 462.063C1063.84 462.063 1063.46 461.669 1063.46 461.178V447.032Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039 456.165C1039.49 456.165 1039.89 456.559 1039.89 457.05V462.353C1039.89 462.839 1039.49 463.238 1039 463.238C1038.52 463.238 1038.12 462.844 1038.12 462.353V457.05C1038.12 456.564 1038.51 456.165 1039 456.165Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.46 456.165C1068.95 456.165 1069.35 456.559 1069.35 457.05V462.353C1069.35 462.839 1068.96 463.238 1068.46 463.238C1067.98 463.238 1067.58 462.844 1067.58 462.353V457.05C1067.58 456.564 1067.97 456.165 1068.46 456.165Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.17 456.166L1033.4 454.693H1065.23L1069.35 456.166V457.936H1038.12L1035.17 456.166Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.35 456.165H1038.12V457.935H1069.35V456.165Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.4 454.693L1038.12 456.166V458.524L1033.4 456.463V454.693Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.59 446.147C1698.08 446.147 1698.48 446.541 1698.48 447.032V461.178C1698.48 461.664 1698.08 462.063 1697.59 462.063C1697.11 462.063 1696.71 461.669 1696.71 461.178V447.032C1696.71 446.547 1697.1 446.147 1697.59 446.147Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.53 447.323H1698.48V453.215H1728.53V447.323Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.53 451.45H1698.48V452.038H1728.53V451.45Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.53 449.094H1698.48V449.682H1728.53V449.094Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726.76 447.032C1726.76 446.541 1727.16 446.147 1727.64 446.147C1728.13 446.147 1728.53 446.541 1728.53 447.032V461.178C1728.53 461.664 1728.14 462.063 1727.64 462.063C1727.15 462.063 1726.76 461.669 1726.76 461.178V447.032Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.31 456.165C1702.79 456.165 1703.19 456.559 1703.19 457.05V462.353C1703.19 462.839 1702.8 463.238 1702.31 463.238C1701.82 463.238 1701.42 462.844 1701.42 462.353V457.05C1701.42 456.564 1701.82 456.165 1702.31 456.165Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.77 456.165C1732.26 456.165 1732.66 456.559 1732.66 457.05V462.353C1732.66 462.839 1732.26 463.238 1731.77 463.238C1731.28 463.238 1730.89 462.844 1730.89 462.353V457.05C1730.89 456.564 1731.28 456.165 1731.77 456.165Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.48 456.166L1696.71 454.693H1728.53L1732.66 456.166V457.936H1701.42L1698.48 456.166Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1732.66 456.165H1701.42V457.935H1732.66V456.165Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.71 454.693L1701.42 456.166V458.524L1696.71 456.463V454.693Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.55 255.807H99.6572L106.279 253.051C108.48 252.133 110.98 252.215 113.115 253.283C114.241 252.157 117.659 250.254 122.369 251.603C116.31 252.952 113.678 256.652 113.115 258.332C110.93 256.693 108.273 255.807 105.542 255.807H105.55Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.347 185.003H458.454L465.076 182.246C467.285 181.328 469.777 181.41 471.912 182.478C473.038 181.361 476.456 179.449 481.166 180.798C475.107 182.147 472.475 185.847 471.912 187.527C469.727 185.888 467.07 185.003 464.339 185.003H464.347Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.76 247.258H1844.66L1838.03 244.501C1835.82 243.583 1833.33 243.665 1831.2 244.733C1830.07 243.616 1826.65 241.704 1821.94 243.053C1828 244.402 1830.63 248.102 1831.2 249.782C1833.38 248.143 1836.04 247.258 1838.77 247.258H1838.76Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.66 513.111H-12.6558V521.5H2298.66V513.111Z",
    fill: "#C3E1B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.66 520.75H-12.6558V526.5H2298.66V520.75Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.004 454.608C730.799 455.828 729.741 456.723 728.506 456.723H725.22C723.909 456.723 722.76 455.86 722.393 454.608C722.064 455.855 720.942 456.723 719.652 456.723H716.842C715.531 456.723 714.381 455.86 714.015 454.608C713.642 455.865 712.482 456.723 711.171 456.723H708.145C706.834 456.723 705.685 455.86 705.318 454.608C704.865 455.876 703.661 456.723 702.324 456.723H699.982C698.811 456.723 697.867 455.779 697.867 454.608",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.609 460.952C674.409 462.954 672.726 464.475 670.714 464.475H670.201C668.13 464.475 666.36 462.991 666.004 460.952C665.686 462.981 663.9 464.475 661.844 464.475C659.778 464.475 657.976 462.986 657.62 460.952C657.253 462.991 655.478 464.475 653.406 464.475H653.131C651.06 464.475 649.29 462.991 648.934 460.952L648.805 461.551C648.438 463.261 646.932 464.481 645.184 464.481H645.006C643.059 464.481 641.483 462.9 641.483 460.958",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.626 454.608C330.421 455.828 329.369 456.723 328.128 456.723H324.842C323.537 456.723 322.387 455.86 322.015 454.608C321.686 455.855 320.559 456.723 319.275 456.723H316.458C315.153 456.723 314.004 455.86 313.631 454.608C313.254 455.865 312.099 456.723 310.788 456.723H307.761C306.456 456.723 305.307 455.86 304.934 454.608C304.481 455.876 303.284 456.723 301.935 456.723H299.599C298.433 456.723 297.484 455.779 297.484 454.608",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.232 460.952C274.032 462.954 272.349 464.475 270.336 464.475H269.824C267.752 464.475 265.983 462.991 265.626 460.952C265.308 462.981 263.522 464.475 261.467 464.475C259.401 464.475 257.599 462.986 257.243 460.952C256.876 462.991 255.101 464.475 253.029 464.475H252.754C250.682 464.475 248.913 462.991 248.557 460.952L248.427 461.551C248.06 463.261 246.555 464.481 244.807 464.481H244.629C242.681 464.481 241.106 462.9 241.106 460.958",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.014 454.608C933.809 455.828 932.752 456.723 931.516 456.723H928.231C926.92 456.723 925.771 455.86 925.404 454.608C925.075 455.855 923.953 456.723 922.663 456.723H919.852C918.541 456.723 917.392 455.86 917.025 454.608C916.653 455.865 915.493 456.723 914.182 456.723H911.155C909.844 456.723 908.695 455.86 908.328 454.608C907.875 455.876 906.672 456.723 905.334 456.723H902.993C901.822 456.723 900.878 455.779 900.878 454.608",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.619 460.952C877.419 462.954 875.736 464.475 873.729 464.475H873.216C871.145 464.475 869.375 462.991 869.014 460.952C868.69 462.981 866.915 464.475 864.854 464.475C862.788 464.475 860.991 462.986 860.63 460.952C860.263 462.991 858.488 464.475 856.416 464.475H856.141C854.069 464.475 852.3 462.991 851.938 460.952L851.809 461.551C851.442 463.261 849.931 464.481 848.183 464.481H848.005C846.058 464.481 844.482 462.9 844.482 460.958",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.95 454.608C1356.74 455.828 1355.69 456.723 1354.45 456.723H1351.17C1349.85 456.723 1348.71 455.86 1348.34 454.608C1348.01 455.855 1346.89 456.723 1345.6 456.723H1342.79C1341.48 456.723 1340.33 455.86 1339.96 454.608C1339.59 455.865 1338.43 456.723 1337.12 456.723H1334.09C1332.78 456.723 1331.63 455.86 1331.26 454.608C1330.81 455.876 1329.61 456.723 1328.27 456.723H1325.93C1324.76 456.723 1323.81 455.779 1323.81 454.608",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.78 457.514C1655.57 458.733 1654.51 459.629 1653.28 459.629H1649.99C1648.68 459.629 1647.53 458.765 1647.16 457.514C1646.84 458.76 1645.71 459.629 1644.42 459.629H1641.61C1640.3 459.629 1639.15 458.765 1638.79 457.514C1638.41 458.771 1637.25 459.629 1635.94 459.629H1632.92C1631.61 459.629 1630.46 458.765 1630.09 457.514C1629.64 458.782 1628.43 459.629 1627.09 459.629H1624.75C1623.58 459.629 1622.64 458.684 1622.64 457.514",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1514.85 460.952C1514.65 462.954 1512.96 464.475 1510.96 464.475H1510.44C1508.37 464.475 1506.6 462.991 1506.24 460.952C1505.92 462.981 1504.14 464.475 1502.08 464.475C1500.01 464.475 1498.22 462.986 1497.86 460.952C1497.49 462.991 1495.71 464.475 1493.64 464.475H1493.37C1491.3 464.475 1489.53 462.991 1489.16 460.952L1489.04 461.551C1488.67 463.261 1487.16 464.481 1485.41 464.481H1485.23C1483.28 464.481 1481.71 462.9 1481.71 460.958",
    stroke: "#615E66",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.517 409.145C874.189 409.145 877.976 412.932 877.976 417.604V428.178C877.976 432.85 874.189 436.638 869.517 436.638C864.845 436.638 861.058 432.85 861.058 428.178V417.604C861.058 412.932 864.845 409.145 869.517 409.145Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.574 411.609C874.469 411.609 877.625 414.765 877.625 418.661V428.528C877.625 432.423 874.469 435.58 870.574 435.58C866.679 435.58 863.522 432.423 863.522 428.528V418.661C863.522 414.765 866.679 411.609 870.574 411.609Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.161 418.655V449.671",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.447 420.771L869.16 426.652",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.58 426.414L869.16 430.994",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.58 420.771L869.16 425.352",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.889 421.829C899.561 421.829 903.349 425.616 903.349 430.289C903.349 434.961 899.561 438.748 894.889 438.748C890.217 438.748 886.43 434.961 886.43 430.289C886.43 425.616 890.217 421.829 894.889 421.829Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.889 425.001H895.595C899.296 425.001 902.291 428.001 902.291 431.696C902.291 435.397 899.291 438.391 895.595 438.391H894.889C891.188 438.391 888.193 435.392 888.193 431.696C888.193 427.995 891.193 425.001 894.889 425.001Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.539 431.347V449.323",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.47 432.052L894.533 436.988",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.958 432.052L894.894 436.988",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.755 449.323C846.755 449.323 846.631 449.172 846.571 449.096C844.23 446.07 844.931 441.549 848.325 439.434L854.534 435.571C855.495 434.978 856.714 434.999 857.642 435.636L863.156 439.396C866.376 441.597 867.072 445.951 864.931 449.026C864.86 449.123 864.715 449.323 864.715 449.323H846.76H846.755Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.871 448.906C845.756 446.365 846.436 442.534 849.295 440.873L856.152 436.897C856.913 436.46 857.852 436.47 858.591 436.924L863.29 439.794C866.635 441.833 866.872 446.597 863.748 448.96C863.678 449.014 863.586 449.046 863.489 449.046H848.184C848.059 449.046 847.946 448.992 847.865 448.901L847.871 448.906Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.062 444.034V449.321",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.643 442.626L855.062 446.856",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.54 444.741L855.063 448.62",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.546 449.322C893.546 449.322 894.328 448.788 894.679 448.459L895.629 447.568C895.947 447.277 896.174 446.91 896.292 446.5L896.384 446.198C897.048 443.959 894.334 442.27 892.618 443.862V442.664C892.618 440.199 889.516 439.093 887.957 441.008C888.701 438.03 885.286 435.769 882.832 437.625L882.136 438.154L881.952 437.566C881.289 435.521 879.071 434.426 877.048 435.154C875.03 435.883 874.016 438.132 874.809 440.123L875.16 441.008C872.166 441.008 870.488 444.466 872.349 446.819L873.752 448.599C873.962 448.869 874.464 449.322 874.464 449.322H893.546Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.05 449.322L877.269 443.328",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.562 446.964L882.557 441.92",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.303 449.323L891.016 445.8",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.136 444.741L889.833 447.331",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.594 449.324L877.975 438.399",
    stroke: "#615E66",
    strokeWidth: 0.539505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.08 234.085H1274.73C1272.52 234.085 1270.72 235.881 1270.72 238.095C1270.72 240.309 1272.52 242.104 1274.73 242.104H1287.11C1288.33 242.104 1289.32 243.095 1289.32 244.315C1289.32 245.535 1288.33 246.529 1287.11 246.529H1280.63C1278.73 246.529 1277.18 248.078 1277.18 249.987C1277.18 251.896 1278.73 253.444 1280.63 253.444H1348.69C1350.6 253.444 1352.15 251.896 1352.15 249.987C1352.15 248.078 1350.6 246.529 1348.69 246.529H1330.45C1329.23 246.529 1328.23 245.538 1328.23 244.315C1328.23 243.092 1329.23 242.104 1330.45 242.104H1338.08C1340.3 242.104 1342.09 240.309 1342.09 238.095C1342.09 235.881 1340.3 234.085 1338.08 234.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.571 197.444H558.557C560.411 197.444 561.916 195.941 561.916 194.085C561.916 192.232 560.414 190.726 558.557 190.726H554.165V189.443C554.165 183.606 547.908 179.905 542.794 182.714L540.184 184.147V183.364C540.184 177.502 535.536 172.595 529.673 172.5C523.684 172.399 518.8 177.225 518.8 183.189V184.147L517.269 183.212C512.327 180.19 506.539 185.586 509.207 190.726H504.479C502.568 190.726 501.034 192.318 501.123 194.246C501.209 196.054 502.763 197.441 504.571 197.441V197.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.484 263.692H767.78C766.279 263.692 765 262.491 765.028 260.994C765.057 259.448 763.815 258.188 762.277 258.188H745.581C744.121 258.188 742.886 257.184 742.493 255.777C741.012 250.474 734.77 247.587 729.627 250.519L727.45 251.758C726.588 252.25 725.489 251.877 725.104 250.962C723.107 246.225 718.263 243.33 713.145 243.818L712.468 243.884C706.427 244.458 701.813 249.531 701.813 255.597C701.813 257.028 700.653 258.184 699.225 258.184H696.404C694.903 258.184 693.623 259.386 693.652 260.883C693.681 262.38 692.438 263.688 690.9 263.688H689.986C687.964 263.688 686.196 265.214 686.065 267.232C685.921 269.442 687.673 271.279 689.854 271.279H697.733C699.025 271.279 700.132 272.313 700.107 273.605C700.083 274.938 701.153 276.024 702.478 276.024H749.461C752.081 276.024 754.206 273.9 754.206 271.279H771.348C773.37 271.279 775.138 269.754 775.269 267.736C775.413 265.525 773.661 263.688 771.48 263.688L771.484 263.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1927.58 266.576H1924.25C1922.9 266.576 1921.75 265.496 1921.78 264.15C1921.8 262.761 1920.69 261.629 1919.31 261.629H1904.3C1902.99 261.629 1901.88 260.726 1901.53 259.462C1900.2 254.697 1894.59 252.102 1889.96 254.737L1888.01 255.85C1887.23 256.293 1886.24 255.957 1885.9 255.135C1884.1 250.878 1879.75 248.276 1875.15 248.715L1874.54 248.774C1869.11 249.29 1864.97 253.849 1864.97 259.3C1864.97 260.586 1863.92 261.626 1862.64 261.626H1860.11C1858.76 261.626 1857.61 262.706 1857.63 264.051C1857.66 265.396 1856.54 266.572 1855.16 266.572H1854.34C1852.52 266.572 1850.93 267.943 1850.82 269.756C1850.69 271.743 1852.26 273.394 1854.22 273.394H1861.3C1862.46 273.394 1863.46 274.323 1863.43 275.484C1863.41 276.682 1864.37 277.658 1865.56 277.658H1907.79C1910.14 277.658 1912.05 275.749 1912.05 273.394H1927.46C1929.27 273.394 1930.86 272.023 1930.98 270.21C1931.11 268.223 1929.54 266.572 1927.58 266.572L1927.58 266.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.903 222.566H65.9466C62.8069 222.566 60.2578 220.017 60.2578 216.877C60.2578 213.737 62.8007 211.188 65.9466 211.188H95.7709V209.012C95.7709 199.133 106.365 192.866 115.026 197.622L119.446 200.047V198.424C119.446 188.427 127.554 180.319 137.551 180.319C147.548 180.319 155.656 188.427 155.656 198.424V200.047L158.248 198.461C166.617 193.345 176.415 202.478 171.902 211.188H179.909C183.049 211.188 185.598 213.737 185.598 216.877C185.598 220.017 183.055 222.566 179.909 222.566H179.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.64 185H1715.74C1718.64 185 1720.99 182.653 1720.99 179.755C1720.99 176.857 1718.64 174.51 1715.74 174.51H1688.23V172.502C1688.23 163.388 1678.47 157.61 1670.48 161.995L1666.4 164.235V162.735C1666.4 153.513 1658.93 146.037 1649.71 146.037C1640.48 146.037 1633.01 153.513 1633.01 162.735V164.235L1630.61 162.774C1622.9 158.053 1613.86 166.479 1618.02 174.51H1610.64C1607.74 174.51 1605.39 176.857 1605.39 179.755C1605.39 182.653 1607.74 185 1610.64 185H1610.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.53 462.052V463.374L484.907 463.109L466.963 461H445.588C445.005 461 444.53 461.475 444.53 462.057V462.052Z",
    fill: "#CDD9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.45 466.54C376.45 464.501 378.106 462.845 380.146 462.845H516.948C520.18 462.845 523.201 464.447 525.014 467.128C527.469 470.765 529.405 474.725 530.76 478.9L530.84 479.154C531.704 481.814 532.146 484.587 532.146 487.381V499.79C532.146 501.829 530.49 503.486 528.45 503.486H380.146C378.106 503.486 376.45 501.829 376.45 499.79V466.54Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.672 469.32L533.991 470.766L532.146 471.559C532.146 469.148 529.88 467.378 527.538 467.961L525.812 468.392L523.967 466.019H529.551C531.531 466.019 533.241 467.394 533.672 469.326V469.32Z",
    fill: "#FFF9DE",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.502 488.444H512.842",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.529 488.704V503.481",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 490.291H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 491.876H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 493.457H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 495.039H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 496.624H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 498.205H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 499.789H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.643 501.371H403.362",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.117 488.704V503.481",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.699 488.704V503.481",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.752 488.704V503.481",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.312 488.704V503.481",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.451 489.759V503.478",
    stroke: "#76736C",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.14 484.221V481.054H493.086C498.572 481.054 501.356 481.933 502.058 482.376L516.042 488.181L525.014 489.761H532.14C532.318 490.463 532.561 492.135 532.14 493.193C527.916 493.457 517.892 492.928 516.042 491.871C507.809 485.958 500.293 484.307 497.569 484.215H380.135L380.14 484.221Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.505 510.35C419.588 510.35 422.897 506.923 422.897 502.695C422.897 498.467 419.588 495.039 415.505 495.039C411.423 495.039 408.114 498.467 408.114 502.695C408.114 506.923 411.423 510.35 415.505 510.35Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.242 506.123C417.137 506.123 418.673 504.587 418.673 502.692C418.673 500.797 417.137 499.261 415.242 499.261C413.347 499.261 411.811 500.797 411.811 502.692C411.811 504.587 413.347 506.123 415.242 506.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.782 510.35C500.864 510.35 504.173 506.923 504.173 502.695C504.173 498.467 500.864 495.039 496.782 495.039C492.7 495.039 489.391 498.467 489.391 502.695C489.391 506.923 492.7 510.35 496.782 510.35Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.517 506.123C498.412 506.123 499.948 504.587 499.948 502.692C499.948 500.797 498.412 499.261 496.517 499.261C494.622 499.261 493.086 500.797 493.086 502.692C493.086 504.587 494.622 506.123 496.517 506.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.674 500.849H433.449V502.958H437.674V500.849Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.256 500.849H454.031V502.958H458.256V500.849Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.316 500.849H474.092V502.958H478.316V500.849Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.202 492.928H511.035V495.037H514.202V492.928Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.202 497.682H511.035V499.791H514.202V497.682Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.14 468.122C380.14 466.957 381.084 466.013 382.25 466.013H516.565C518.842 466.013 521.108 466.363 523.276 467.054L523.438 467.108C524.96 467.593 526.233 468.64 527.004 470.043L528.99 473.657C531.73 478.653 532.923 484.356 532.405 490.031H525.014L516.042 488.451L504.167 483.444C500.854 482.047 497.299 481.329 493.706 481.329H380.135V468.133L380.14 468.122Z",
    fill: "url(#paint6_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.474 466.812L526.141 470.584C528.881 476.793 530.295 483.505 530.295 490.292",
    stroke: "white",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.396 481.335L505.23 464.065H510.733L489.396 485.273V481.335Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.965 482.377L502.592 464.169L503.272 465.113L485.97 483.321V482.377H485.965Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.686 481.335L466.52 464.065V468.916L450.686 485.279V481.34V481.335Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.255 482.377L463.882 464.169L464.562 465.113L447.26 483.321V482.377H447.255Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.872 481.335L425.707 464.065V468.916L409.872 485.279V481.34V481.335Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.529 466.013V481.971",
    stroke: "white",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.418 466.013V482.673",
    stroke: "white",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.116 466.013V481.971",
    stroke: "white",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.698 466.013V482.673",
    stroke: "white",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.752 466.013V482.322",
    stroke: "white",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.312 466.013V488.71",
    stroke: "white",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.699 476.919V471.47C534.699 471.082 534.38 470.764 533.992 470.764H533.199C532.325 470.764 531.618 471.47 531.618 472.344V476.04C531.618 476.914 532.325 477.626 533.199 477.626H533.992C534.38 477.626 534.699 477.308 534.699 476.919Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.359 505.341C772.189 505.341 773.598 497.661 768.359 492.085C763.121 486.509 754.052 475 748.476 475H706.368C702.003 475 701.507 505.361 703.789 505.361H768.359V505.341Z",
    fill: "#F5DDC0",
    stroke: "#222B54",
    strokeWidth: 0.644733
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.657 504.031C748.657 507.603 751.554 510.5 755.126 510.5C758.698 510.5 761.595 507.603 761.595 504.031C761.595 500.46 758.698 497.562 755.126 497.562C751.554 497.562 748.657 500.46 748.657 504.031Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.106 504.031C752.106 505.698 753.456 507.047 755.123 507.047C756.789 507.047 758.139 505.698 758.139 504.031C758.139 502.364 756.789 501.015 755.123 501.015C753.456 501.015 752.106 502.364 752.106 504.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.424 504.031C704.424 507.603 707.321 510.5 710.893 510.5C714.465 510.5 717.362 507.603 717.362 504.031C717.362 500.46 714.465 497.562 710.893 497.562C707.321 497.562 704.424 500.46 704.424 504.031Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.877 504.031C707.877 505.698 709.226 507.047 710.893 507.047C712.56 507.047 713.909 505.698 713.909 504.031C713.909 502.364 712.56 501.015 710.893 501.015C709.226 501.015 707.877 502.364 707.877 504.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.296 491.708C764.748 490.557 759.887 484.148 752.108 477.897C751.652 477.54 751.83 476.667 751.91 476.071C757.307 479.068 764.113 487.541 768.36 492.085C768.717 492.462 766.772 492.085 766.296 491.708Z",
    fill: "url(#paint7_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.376 491.706C761.931 491.706 762.427 491.369 762.626 490.873C762.844 490.357 762.705 489.781 762.328 489.385L751.315 478.55C750.898 478.133 750.343 477.915 749.747 477.915H740.5C739.746 477.915 739.151 478.53 739.151 479.264V490.357C739.151 491.111 739.766 491.706 740.5 491.706H761.376Z",
    fill: "url(#paint8_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.424 491.706H736.372C737.126 491.706 737.722 491.091 737.722 490.357V479.264C737.722 478.51 737.107 477.915 736.372 477.915H707.5C706.885 477.915 706.369 478.332 706.21 478.907C705.655 481.07 704.424 486.388 704.424 491.726V491.706Z",
    fill: "url(#paint9_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1582.87 461.022C1588.33 462.279 1596.34 466.687 1600.79 468.899L1600.9 475.427C1601.2 475.81 1601.86 476.905 1601.93 478.21C1602 479.284 1601.18 481.037 1600.55 482.176C1600.32 482.58 1599.88 482.818 1599.42 482.818H1533.81C1533.06 482.818 1532.45 482.214 1532.45 481.464V478.496C1532.45 475.81 1535.37 473.598 1537.35 472.832C1538.94 472.217 1544.32 470.015 1548.5 468.99C1548.5 468.99 1554.85 463.514 1564.12 461.113C1570.26 459.522 1577.46 459.77 1582.88 461.016L1582.87 461.022Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.49095
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1590.1 473.766C1585.49 472.228 1581.98 474.408 1580.81 475.687C1580.38 475.897 1579.46 476.134 1579.21 475.368C1581.77 472.487 1586.89 471.527 1590.09 473.766H1590.1Z",
    fill: "url(#paint10_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.45 477.287C1575.31 479.078 1556.27 479.316 1547.52 479.208V481.771H1600.65C1601.09 480.918 1601.94 479.019 1601.94 478.248C1601.94 477.476 1601.09 476.009 1600.65 475.367C1596.81 475.259 1587.6 475.496 1581.45 477.287Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1595.63 469.95L1600.79 468.796L1600.84 473.214L1595.53 471.251C1594.91 471.013 1594.96 470.102 1595.63 469.956L1595.63 469.95Z",
    fill: "#B7594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.22 486.18C1547.47 486.18 1550.11 483.663 1550.11 480.558C1550.11 477.453 1547.47 474.937 1544.22 474.937C1540.97 474.937 1538.33 477.453 1538.33 480.558C1538.33 483.663 1540.97 486.18 1544.22 486.18Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.22 483.111C1545.7 483.111 1546.89 481.967 1546.89 480.557C1546.89 479.147 1545.7 478.004 1544.22 478.004C1542.75 478.004 1541.55 479.147 1541.55 480.557C1541.55 481.967 1542.75 483.111 1544.22 483.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586.98 486.18C1590.24 486.18 1592.87 483.663 1592.87 480.558C1592.87 477.453 1590.24 474.937 1586.98 474.937C1583.73 474.937 1581.09 477.453 1581.09 480.558C1581.09 483.663 1583.73 486.18 1586.98 486.18Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586.98 483.111C1588.45 483.111 1589.65 481.967 1589.65 480.557C1589.65 479.147 1588.45 478.004 1586.98 478.004C1585.51 478.004 1584.31 479.147 1584.31 480.557C1584.31 481.967 1585.51 483.111 1586.98 483.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1571.82 469.183C1565.5 469.89 1552.97 469.183 1552.97 469.183C1559.74 463.901 1566.1 462.304 1570.68 462.175C1584.01 461.792 1587.35 465.73 1587.35 465.73C1587.35 465.73 1579.53 468.325 1571.82 469.188V469.183Z",
    fill: "url(#paint11_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.73 469.403L1574.02 461.86V465.526L1570.7 469.403H1566.73Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.1 469.497L1570.56 462.064H1572.18L1565.3 469.497H1564.1Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.391 464.613C229.582 461.107 233.425 459 237.571 459H253.499C257.629 459 261.472 461.124 263.68 464.613L267.287 470.344H223.817L227.424 464.613H227.391Z",
    fill: "#E4BE82",
    stroke: "#222B54",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.13 482.142C274.989 482.142 275.68 481.451 275.68 480.592V471.288C275.68 470.293 274.939 469.467 273.961 469.349L264.101 468.203H225.216L214.631 469.029C210.131 469.383 206.574 473.024 206.355 477.541L206.187 480.946C206.187 481.249 206.288 481.552 206.49 481.788C206.709 482.008 206.996 482.142 207.316 482.142H274.13Z",
    fill: "#CFD284",
    stroke: "#222B54",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.278 468.22H244.211V459.742H239.559C233.761 459.742 231.401 463.99 229.261 468.22H229.278Z",
    fill: "url(#paint12_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.758 468.22H245.392V459.742H251.476C254.561 459.742 257.443 461.327 259.078 463.939L261.775 468.22H261.758Z",
    fill: "url(#paint13_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.391 464.614C229.026 462.018 231.572 460.181 234.454 459.405C235.111 459.557 235.347 459.894 234.083 460.653C230.813 462.574 228.352 468.237 228.352 468.237H225.133L227.408 464.63L227.391 464.614Z",
    fill: "url(#paint14_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.735 482.141C256.735 485.175 259.196 487.636 262.23 487.636C265.264 487.636 267.725 485.175 267.725 482.141C267.725 479.107 265.264 476.646 262.23 476.646C259.196 476.646 256.735 479.107 256.735 482.141Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.229 484.704C263.644 484.704 264.791 483.557 264.791 482.142C264.791 480.727 263.644 479.58 262.229 479.58C260.814 479.58 259.667 480.727 259.667 482.142C259.667 483.557 260.814 484.704 262.229 484.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.147 482.141C213.147 485.175 215.608 487.636 218.642 487.636C221.676 487.636 224.137 485.175 224.137 482.141C224.137 479.107 221.676 476.646 218.642 476.646C215.608 476.646 213.147 479.107 213.147 482.141Z",
    fill: "#6B6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.081 482.142C216.081 483.558 217.227 484.704 218.643 484.704C220.059 484.704 221.205 483.558 221.205 482.142C221.205 480.726 220.059 479.58 218.643 479.58C217.227 479.58 216.081 480.726 216.081 482.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45 480.86H209.018V478.298H204.45V480.86Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.112 480.86H277.23V478.298H271.112V480.86Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.37 483.3C1368.76 481.843 1353.82 481.962 1347.82 482.043C1346.28 482.064 1344.82 482.706 1343.75 483.818L1338.01 489.828C1338.01 489.828 1322.6 491.856 1322.6 493.351V499.053C1322.26 499.474 1321.55 500.682 1321.45 502.118C1321.38 503.299 1322.28 505.225 1322.99 506.482C1323.23 506.93 1323.72 507.189 1324.23 507.189H1396.47C1397.3 507.189 1397.96 506.525 1397.96 505.7V496.523C1397.96 495.05 1394.76 494.408 1392.58 494.084C1390.39 493.761 1384.89 493.097 1380.3 491.969C1380.3 491.969 1377.14 484.017 1374.37 483.3Z",
    fill: "#D7D0B3",
    stroke: "#382456",
    strokeWidth: 0.539505
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M1334.49 497.23C1339.57 495.536 1343.42 497.937 1344.71 499.345C1345.19 499.582 1346.19 499.836 1346.48 498.994C1343.66 495.822 1338.02 494.764 1334.49 497.23H1334.49Z",
    fill: "url(#paint15_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.59 500.047C1365.16 500.047 1391.94 500.047 1396.87 501.105V506.041H1322.86C1322.38 505.102 1321.45 503.009 1321.45 502.162C1321.45 501.315 1322.39 499.697 1322.86 498.99C1327.09 498.871 1347.53 500.047 1354.58 500.047H1354.58H1354.59Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.81 493.875L1322.72 493.168L1322.67 496.621L1327.89 495.337C1328.69 495.143 1328.63 493.988 1327.82 493.875H1327.81Z",
    fill: "#C86A3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.81 510.891C1391.58 510.891 1394.63 507.772 1394.63 503.925C1394.63 500.078 1391.58 496.96 1387.81 496.96C1384.04 496.96 1380.98 500.078 1380.98 503.925C1380.98 507.772 1384.04 510.891 1387.81 510.891Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.81 507.085C1389.52 507.085 1390.91 505.67 1390.91 503.925C1390.91 502.179 1389.52 500.765 1387.81 500.765C1386.1 500.765 1384.71 502.179 1384.71 503.925C1384.71 505.67 1386.1 507.085 1387.81 507.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.26 510.891C1342.03 510.891 1345.09 507.772 1345.09 503.925C1345.09 500.078 1342.03 496.96 1338.26 496.96C1334.49 496.96 1331.44 500.078 1331.44 503.925C1331.44 507.772 1334.49 510.891 1338.26 510.891Z",
    fill: "#76736C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.26 507.085C1339.97 507.085 1341.36 505.67 1341.36 503.925C1341.36 502.179 1339.97 500.765 1338.26 500.765C1336.55 500.765 1335.17 502.179 1335.17 503.925C1335.17 505.67 1336.55 507.085 1338.26 507.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.28 492.287H1379.04L1374.32 484.54L1359.17 483.482H1346.48L1339.78 490.534C1339.78 490.534 1349.65 492.287 1358.29 492.287H1358.28Z",
    fill: "url(#paint16_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.28 492.287H1379.04L1374.32 484.54L1359.17 483.482H1346.48L1339.78 490.534C1339.78 490.534 1349.65 492.287 1358.29 492.287H1358.28Z",
    fill: "url(#paint17_linear_7001_52055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.6 483.748H1360.11V492.666H1360.6V483.748Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.377654
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.14 492.183L1373.47 484.61V488.35L1367.27 492.183H1364.14Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360.57 492.286L1369.4 484.147L1371.48 484.425L1362.2 492.286H1360.57Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.2 478.217C1451.42 478.217 1455.66 482.452 1455.66 487.678C1455.66 492.903 1451.42 497.139 1446.2 497.139C1440.97 497.139 1436.74 492.903 1436.74 487.678C1436.74 482.452 1440.97 478.217 1446.2 478.217Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.2 481.765H1446.99C1451.13 481.765 1454.48 485.119 1454.48 489.253C1454.48 493.392 1451.12 496.74 1446.99 496.74H1446.2C1442.06 496.74 1438.71 493.386 1438.71 489.253C1438.71 485.113 1442.06 481.765 1446.2 481.765Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1445.8 488.857V518.024",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.33 489.651L1445.8 495.172",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.68 489.651L1446.2 495.172",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.81 478.217C1464.04 478.217 1468.27 482.452 1468.27 487.678C1468.27 492.903 1464.04 497.139 1458.81 497.139C1453.59 497.139 1449.35 492.903 1449.35 487.678C1449.35 482.452 1453.59 478.217 1458.81 478.217Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.81 481.765H1459.6C1463.74 481.765 1467.09 485.119 1467.09 489.253C1467.09 493.392 1463.74 496.74 1459.6 496.74H1458.81C1454.67 496.74 1451.33 493.386 1451.33 489.253C1451.33 485.113 1454.68 481.765 1458.81 481.765Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.42 488.857V518.024",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.94 489.651L1458.41 495.172",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453.29 489.651L1458.81 495.172",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.42 478.217C1476.65 478.217 1480.89 482.452 1480.89 487.678C1480.89 492.903 1476.65 497.139 1471.42 497.139C1466.2 497.139 1461.96 492.903 1461.96 487.678C1461.96 482.452 1466.2 478.217 1471.42 478.217Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.42 481.765H1472.21C1476.35 481.765 1479.7 485.119 1479.7 489.253C1479.7 493.392 1476.35 496.74 1472.21 496.74H1471.42C1467.29 496.74 1463.94 493.386 1463.94 489.253C1463.94 485.113 1467.29 481.765 1471.42 481.765Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.03 488.857V518.024",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.55 489.651L1471.03 495.172",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.91 489.651L1471.43 495.172",
    stroke: "#382456",
    strokeWidth: 0.603372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.24 477.436C1614.57 477.436 1618.89 481.754 1618.89 487.082C1618.89 492.41 1614.57 496.728 1609.24 496.728C1603.91 496.728 1599.59 492.41 1599.59 487.082C1599.59 481.754 1603.91 477.436 1609.24 477.436Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.24 481.053H1610.05C1614.27 481.053 1617.68 484.473 1617.68 488.687C1617.68 492.908 1614.26 496.322 1610.05 496.322H1609.24C1605.02 496.322 1601.61 492.902 1601.61 488.687C1601.61 484.467 1605.03 481.053 1609.24 481.053Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.84 488.285V518.024",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614.46 489.094L1608.83 494.723",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.62 489.094L1609.25 494.723",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.11 477.436C1627.43 477.436 1631.75 481.754 1631.75 487.082C1631.75 492.41 1627.43 496.728 1622.11 496.728C1616.78 496.728 1612.46 492.41 1612.46 487.082C1612.46 481.754 1616.78 477.436 1622.11 477.436Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.1 481.053H1622.91C1627.13 481.053 1630.54 484.473 1630.54 488.687C1630.54 492.908 1627.12 496.322 1622.91 496.322H1622.1C1617.88 496.322 1614.47 492.902 1614.47 488.687C1614.47 484.467 1617.89 481.053 1622.1 481.053Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.7 488.285V518.024",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.33 489.094L1621.7 494.723",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.47 489.094L1622.1 494.723",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.96 477.436C1640.29 477.436 1644.61 481.754 1644.61 487.082C1644.61 492.41 1640.29 496.728 1634.96 496.728C1629.64 496.728 1625.32 492.41 1625.32 487.082C1625.32 481.754 1629.64 477.436 1634.96 477.436Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.96 481.053H1635.77C1639.99 481.053 1643.4 484.473 1643.4 488.687C1643.4 492.908 1639.98 496.322 1635.77 496.322H1634.96C1630.74 496.322 1627.33 492.902 1627.33 488.687C1627.33 484.467 1630.75 481.053 1634.96 481.053Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.56 488.285V518.024",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.19 489.094L1634.56 494.723",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.34 489.094L1634.97 494.723",
    stroke: "#382456",
    strokeWidth: 0.615203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.64 480.095C1265.61 480.095 1269.65 484.131 1269.65 489.109C1269.65 494.088 1265.61 498.124 1260.64 498.124C1255.66 498.124 1251.62 494.088 1251.62 489.109C1251.62 484.131 1255.66 480.095 1260.64 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.64 483.476H1261.39C1265.33 483.476 1268.52 486.672 1268.52 490.61C1268.52 494.554 1265.33 497.745 1261.39 497.745H1260.64C1256.69 497.745 1253.5 494.548 1253.5 490.61C1253.5 486.666 1256.7 483.476 1260.64 483.476Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.26 490.233V518.024",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.52 490.99L1260.26 496.251",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.38 490.99L1260.64 496.251",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.65 480.095C1277.63 480.095 1281.67 484.131 1281.67 489.109C1281.67 494.088 1277.63 498.124 1272.65 498.124C1267.67 498.124 1263.64 494.088 1263.64 489.109C1263.64 484.131 1267.67 480.095 1272.65 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.65 483.476H1273.4C1277.35 483.476 1280.54 486.672 1280.54 490.61C1280.54 494.554 1277.34 497.745 1273.4 497.745H1272.65C1268.71 497.745 1265.52 494.548 1265.52 490.61C1265.52 486.666 1268.71 483.476 1272.65 483.476Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1272.28 490.233V518.024",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.54 490.99L1272.28 496.251",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.4 490.99L1272.66 496.251",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.67 480.095C1289.65 480.095 1293.69 484.131 1293.69 489.109C1293.69 494.088 1289.65 498.124 1284.67 498.124C1279.69 498.124 1275.66 494.088 1275.66 489.109C1275.66 484.131 1279.69 480.095 1284.67 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.67 483.476H1285.42C1289.37 483.476 1292.56 486.672 1292.56 490.61C1292.56 494.554 1289.36 497.745 1285.42 497.745H1284.67C1280.73 497.745 1277.54 494.548 1277.54 490.61C1277.54 486.666 1280.73 483.476 1284.67 483.476Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.55 490.99L1284.29 496.251",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.41 490.99L1284.67 496.251",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.29 490.233V518.024",
    stroke: "#382456",
    strokeWidth: 0.574907
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.775 480.095C638.213 480.095 642.621 484.503 642.621 489.94C642.621 495.378 638.213 499.786 632.775 499.786C627.338 499.786 622.93 495.378 622.93 489.94C622.93 484.503 627.338 480.095 632.775 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.775 483.787H633.597C637.905 483.787 641.39 487.278 641.39 491.579C641.39 495.887 637.899 499.372 633.597 499.372H632.775C628.467 499.372 624.982 495.881 624.982 491.579C624.982 487.272 628.474 483.787 632.775 483.787Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.361 491.168V521.521",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.107 491.994L632.361 497.74",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.03 491.994L632.776 497.74",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.899 480.095C651.337 480.095 655.745 484.503 655.745 489.94C655.745 495.378 651.337 499.786 645.899 499.786C640.462 499.786 636.054 495.378 636.054 489.94C636.054 484.503 640.462 480.095 645.899 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.899 483.787H646.721C651.029 483.787 654.514 487.278 654.514 491.579C654.514 495.887 651.023 499.372 646.721 499.372H645.899C641.591 499.372 638.106 495.881 638.106 491.579C638.106 487.272 641.598 483.787 645.899 483.787Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.49 491.168V521.521",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.229 491.994L645.483 497.74",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.153 491.994L645.899 497.74",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.028 480.095C664.466 480.095 668.874 484.503 668.874 489.94C668.874 495.378 664.466 499.786 659.028 499.786C653.591 499.786 649.183 495.378 649.183 489.94C649.183 484.503 653.591 480.095 659.028 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.028 483.787H659.85C664.158 483.787 667.643 487.278 667.643 491.579C667.643 495.887 664.151 499.372 659.85 499.372H659.028C654.72 499.372 651.235 495.881 651.235 491.579C651.235 487.272 654.727 483.787 659.028 483.787Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.613 491.168V521.521",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.359 491.994L658.613 497.74",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.282 491.994L659.028 497.74",
    stroke: "#382456",
    strokeWidth: 0.627911
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6255 481.664C39.9266 481.664 44.2237 485.961 44.2237 491.262C44.2237 496.563 39.9266 500.86 34.6255 500.86C29.3245 500.86 25.0273 496.563 25.0273 491.262C25.0273 485.961 29.3245 481.664 34.6255 481.664Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6258 485.264H35.4277C39.6269 485.264 43.0242 488.667 43.0242 492.86C43.0242 497.059 39.6208 500.457 35.4277 500.457H34.6258C30.4266 500.457 27.0293 497.053 27.0293 492.86C27.0293 488.661 30.4328 485.264 34.6258 485.264Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2285 492.459V522.049",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8227 493.265L34.2217 498.866",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0244 493.265L34.6254 498.866",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4195 481.664C52.7205 481.664 57.0176 485.961 57.0176 491.262C57.0176 496.563 52.7205 500.86 47.4195 500.86C42.1184 500.86 37.8213 496.563 37.8213 491.262C37.8213 485.961 42.1184 481.664 47.4195 481.664Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4197 485.264H48.2216C52.4208 485.264 55.8182 488.667 55.8182 492.86C55.8182 497.059 52.4147 500.457 48.2216 500.457H47.4197C43.2205 500.457 39.8232 497.053 39.8232 492.86C39.8232 488.661 43.2267 485.264 47.4197 485.264Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0215 492.459V522.049",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6224 493.265L47.0215 498.866",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8242 493.265L47.4252 498.866",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2198 481.664C65.5208 481.664 69.8179 485.961 69.8179 491.262C69.8179 496.563 65.5208 500.86 60.2198 500.86C54.9187 500.86 50.6216 496.563 50.6216 491.262C50.6216 485.961 54.9187 481.664 60.2198 481.664Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2191 485.264H61.021C65.2202 485.264 68.6175 488.667 68.6175 492.86C68.6175 497.059 65.2141 500.457 61.021 500.457H60.2191C56.0199 500.457 52.6226 497.053 52.6226 492.86C52.6226 488.661 56.026 485.264 60.2191 485.264Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8208 492.459V522.049",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4159 493.265L59.8149 498.866",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6182 493.265L60.2192 498.866",
    stroke: "#382456",
    strokeWidth: 0.612129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.342 480.095C338.623 480.095 342.904 484.375 342.904 489.656C342.904 494.937 338.623 499.218 333.342 499.218C328.061 499.218 323.781 494.937 323.781 489.656C323.781 484.375 328.061 480.095 333.342 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.342 483.681H334.141C338.324 483.681 341.708 487.071 341.708 491.248C341.708 495.431 338.318 498.816 334.141 498.816H333.342C329.159 498.816 325.774 495.425 325.774 491.248C325.774 487.065 329.165 483.681 333.342 483.681Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.946 490.849V520.326",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.519 491.651L332.939 497.231",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.763 491.651L333.342 497.231",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.088 480.095C351.368 480.095 355.649 484.375 355.649 489.656C355.649 494.937 351.368 499.218 346.088 499.218C340.807 499.218 336.526 494.937 336.526 489.656C336.526 484.375 340.807 480.095 346.088 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.087 483.681H346.886C351.069 483.681 354.454 487.071 354.454 491.248C354.454 495.431 351.063 498.816 346.886 498.816H346.087C341.904 498.816 338.52 495.425 338.52 491.248C338.52 487.065 341.91 483.681 346.087 483.681Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.69 490.849V520.326",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.27 491.651L345.69 497.231",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.513 491.651L346.093 497.231",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.838 480.095C364.119 480.095 368.4 484.375 368.4 489.656C368.4 494.937 364.119 499.218 358.838 499.218C353.558 499.218 349.277 494.937 349.277 489.656C349.277 484.375 353.558 480.095 358.838 480.095Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.838 483.681H359.637C363.82 483.681 367.204 487.071 367.204 491.248C367.204 495.431 363.814 498.816 359.637 498.816H358.838C354.655 498.816 351.271 495.425 351.271 491.248C351.271 487.065 354.661 483.681 358.838 483.681Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.435 490.849V520.326",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.014 491.651L358.435 497.231",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.259 491.651L358.839 497.231",
    stroke: "#382456",
    strokeWidth: 0.609795
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 480.852C118.486 480.852 122.87 485.235 122.87 490.643C122.87 496.05 118.486 500.434 113.079 500.434C107.671 500.434 103.288 496.05 103.288 490.643C103.288 485.235 107.671 480.852 113.079 480.852Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.079 484.523H113.897C118.181 484.523 121.647 487.995 121.647 492.273C121.647 496.556 118.175 500.022 113.897 500.022H113.079C108.796 500.022 105.33 496.55 105.33 492.273C105.33 487.989 108.802 484.523 113.079 484.523Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.673 491.863V522.048",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.381 492.686L112.667 498.399",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.365 492.686L113.079 498.399",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.129 480.852C131.537 480.852 135.921 485.235 135.921 490.643C135.921 496.05 131.537 500.434 126.129 500.434C120.722 500.434 116.338 496.05 116.338 490.643C116.338 485.235 120.722 480.852 126.129 480.852Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13 484.523H126.948C131.231 484.523 134.697 487.995 134.697 492.273C134.697 496.556 131.225 500.022 126.948 500.022H126.13C121.846 500.022 118.38 496.55 118.38 492.273C118.38 487.989 121.852 484.523 126.13 484.523Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.724 491.863V522.048",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.437 492.686L125.724 498.399",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.421 492.686L126.135 498.399",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.186 480.852C144.593 480.852 148.977 485.235 148.977 490.643C148.977 496.05 144.593 500.434 139.186 500.434C133.778 500.434 129.395 496.05 129.395 490.643C129.395 485.235 133.778 480.852 139.186 480.852Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.186 484.523H140.004C144.288 484.523 147.753 487.995 147.753 492.273C147.753 496.556 144.282 500.022 140.004 500.022H139.186C134.903 500.022 131.437 496.55 131.437 492.273C131.437 487.989 134.909 484.523 139.186 484.523Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.779 491.863V522.048",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.488 492.686L138.774 498.399",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.472 492.686L139.186 498.399",
    stroke: "#382456",
    strokeWidth: 0.624434
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.923 462.396C298.62 462.396 299.186 462.963 299.186 463.66V470.407H301.925C302.434 470.407 302.84 470.819 302.84 471.322C302.84 471.825 302.429 472.237 301.925 472.237H299.186V518.519C299.186 519.216 298.62 519.782 297.923 519.782H297.405C296.708 519.782 296.141 519.216 296.141 518.519V472.237H293.47C292.961 472.237 292.555 471.825 292.555 471.322C292.555 470.819 292.966 470.407 293.47 470.407H296.141V463.66C296.141 462.963 296.708 462.396 297.405 462.396H297.923Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.111 462.463H295.285C294.777 462.463 294.37 462.874 294.37 463.378C294.37 463.886 294.782 464.293 295.285 464.293H300.111C300.619 464.293 301.025 463.881 301.025 463.378C301.025 462.869 300.614 462.463 300.111 462.463Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.761 444.134H295.627C294.929 444.134 294.364 444.699 294.364 445.397V447.759C294.364 448.457 294.929 449.022 295.627 449.022H299.761C300.458 449.022 301.024 448.457 301.024 447.759V445.397C301.024 444.699 300.458 444.134 299.761 444.134Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.975 463.078L290.435 452.996L298 449.941V463.078H294.975Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.681 450.405L290.856 453.159L295.179 462.753H297.686V450.4L297.681 450.405Z",
    stroke: "#615E66",
    strokeWidth: 0.484025,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 450.552V445.358H295.991C295.164 445.358 294.389 445.765 293.915 446.447L288.717 453.94C288.596 454.114 288.775 454.337 288.968 454.255L297.995 450.552H298Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.42 463.079L304.96 452.997L297.395 449.942V463.079H300.42Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.709 450.406L304.534 453.16L300.212 462.754H297.705V450.401L297.709 450.406Z",
    stroke: "#615E66",
    strokeWidth: 0.484025,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.395 450.552V445.358H299.403C300.231 445.358 301.005 445.765 301.48 446.447L306.678 453.94C306.799 454.114 306.62 454.337 306.426 454.255L297.399 450.552H297.395Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.942 515.938H294.446C293.398 515.938 292.549 516.787 292.549 517.835V520.933C292.549 521.981 293.398 522.83 294.446 522.83H300.942C301.99 522.83 302.839 521.981 302.839 520.933V517.835C302.839 516.787 301.99 515.938 300.942 515.938Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M936.845 463.935C937.542 463.935 938.109 464.501 938.109 465.198V471.945H940.848C941.357 471.945 941.763 472.357 941.763 472.86C941.763 473.363 941.352 473.775 940.848 473.775H938.109V520.057C938.109 520.754 937.538 521.321 936.845 521.321H936.328C935.631 521.321 935.064 520.754 935.064 520.057V473.775H932.397C931.889 473.775 931.482 473.363 931.482 472.86C931.482 472.357 931.894 471.945 932.397 471.945H935.064V465.198C935.064 464.501 935.635 463.935 936.328 463.935H936.845Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.033 464.001H934.208C933.7 464.001 933.293 464.412 933.293 464.916C933.293 465.424 933.704 465.831 934.208 465.831H939.033C939.542 465.831 939.948 465.419 939.948 464.916C939.948 464.408 939.537 464.001 939.033 464.001Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.69 445.672H934.556C933.859 445.672 933.293 446.237 933.293 446.935V449.297C933.293 449.995 933.859 450.561 934.556 450.561H938.69C939.388 450.561 939.953 449.995 939.953 449.297V446.935C939.953 446.237 939.388 445.672 938.69 445.672Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.898 464.614L929.357 454.532L936.923 451.478V464.614H933.898Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.608 451.941L929.783 454.695L934.101 464.289H936.603V451.937L936.608 451.941Z",
    stroke: "#615E66",
    strokeWidth: 0.484025,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.923 452.09V446.896H934.919C934.091 446.896 933.312 447.303 932.842 447.986L927.644 455.478C927.523 455.652 927.702 455.875 927.895 455.793L936.918 452.09H936.923Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.344 464.614L943.885 454.532L936.319 451.478V464.614H939.344Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.638 451.941L943.462 454.695L939.145 464.289H936.643V451.937L936.638 451.941Z",
    stroke: "#615E66",
    strokeWidth: 0.484025,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.322 452.09V446.896H938.326C939.154 446.896 939.928 447.303 940.403 447.986L945.601 455.478C945.722 455.652 945.538 455.875 945.349 455.793L936.327 452.09H936.322Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.872 517.476H933.376C932.328 517.476 931.479 518.325 931.479 519.373V522.471C931.479 523.519 932.328 524.368 933.376 524.368H939.872C940.919 524.368 941.769 523.519 941.769 522.471V519.373C941.769 518.325 940.919 517.476 939.872 517.476Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1505.62 462.671C1506.32 462.671 1506.89 463.237 1506.89 463.934V470.681H1509.63C1510.14 470.681 1510.54 471.093 1510.54 471.596C1510.54 472.1 1510.13 472.511 1509.63 472.511H1506.89V518.794C1506.89 519.491 1506.32 520.057 1505.62 520.057H1505.11C1504.41 520.057 1503.84 519.491 1503.84 518.794V472.511H1501.18C1500.67 472.511 1500.26 472.1 1500.26 471.596C1500.26 471.093 1500.67 470.681 1501.18 470.681H1503.84V463.934C1503.84 463.237 1504.41 462.671 1505.11 462.671H1505.62Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.81 462.738H1502.99C1502.48 462.738 1502.07 463.15 1502.07 463.653C1502.07 464.161 1502.48 464.568 1502.99 464.568H1507.81C1508.32 464.568 1508.73 464.156 1508.73 463.653C1508.73 463.145 1508.32 462.738 1507.81 462.738Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.47 444.406H1503.34C1502.64 444.406 1502.07 444.972 1502.07 445.67V448.032C1502.07 448.729 1502.64 449.295 1503.34 449.295H1507.47C1508.17 449.295 1508.73 448.729 1508.73 448.032V445.67C1508.73 444.972 1508.17 444.406 1507.47 444.406Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502.68 463.351L1498.14 453.269L1505.7 450.215V463.351H1502.68Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.38 450.679L1498.56 453.433L1502.88 463.026H1505.38V450.674L1505.38 450.679Z",
    stroke: "#615E66",
    strokeWidth: 0.484025,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.7 450.825V445.632H1503.7C1502.87 445.632 1502.09 446.038 1501.62 446.721L1496.42 454.214C1496.3 454.388 1496.48 454.61 1496.67 454.528L1505.7 450.825H1505.7Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.12 463.351L1512.66 453.269L1505.1 450.215V463.351H1508.12Z",
    fill: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.42 450.679L1512.24 453.433L1507.92 463.026H1505.42V450.674L1505.42 450.679Z",
    stroke: "#615E66",
    strokeWidth: 0.484025,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.1 450.826V445.633H1507.1C1507.93 445.633 1508.7 446.039 1509.18 446.722L1514.38 454.215C1514.5 454.389 1514.31 454.611 1514.12 454.529L1505.1 450.826H1505.1Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.65 516.21H1502.16C1501.11 516.21 1500.26 517.059 1500.26 518.107V521.205C1500.26 522.253 1501.11 523.102 1502.16 523.102H1508.65C1509.7 523.102 1510.55 522.253 1510.55 521.205V518.107C1510.55 517.059 1509.7 516.21 1508.65 516.21Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.617 537.637C134.801 537.175 133.523 536.757 131.697 536.966C129.893 537.172 128.85 538.074 128.254 538.921C127.955 539.347 127.767 539.761 127.655 540.067C127.599 540.22 127.562 540.346 127.539 540.433C127.527 540.476 127.519 540.509 127.514 540.531C127.512 540.542 127.51 540.55 127.509 540.556C127.509 540.558 127.509 540.56 127.508 540.562L127.44 540.923L127.168 540.676L127.167 540.675C127.165 540.673 127.162 540.67 127.158 540.667C127.15 540.66 127.138 540.649 127.122 540.636C127.089 540.609 127.04 540.57 126.979 540.523C126.856 540.43 126.681 540.309 126.474 540.194C126.052 539.961 125.53 539.778 125.045 539.877C124.854 539.916 124.737 540.039 124.665 540.239C124.589 540.449 124.573 540.727 124.592 541.021C124.611 541.31 124.664 541.596 124.712 541.811C124.737 541.917 124.759 542.006 124.776 542.067C124.784 542.098 124.792 542.122 124.796 542.138C124.799 542.145 124.8 542.151 124.801 542.155C124.802 542.157 124.802 542.158 124.802 542.159L124.803 542.16L124.437 542.336L124.436 542.334C124.435 542.333 124.434 542.331 124.432 542.328C124.429 542.323 124.423 542.315 124.416 542.305C124.401 542.283 124.378 542.252 124.35 542.212C124.293 542.132 124.211 542.016 124.107 541.878C123.899 541.601 123.608 541.233 123.276 540.864C122.943 540.495 122.573 540.131 122.208 539.859C121.835 539.583 121.496 539.426 121.22 539.421C121.082 539.419 120.988 539.449 120.923 539.491C120.858 539.533 120.807 539.597 120.767 539.687C120.684 539.874 120.668 540.15 120.699 540.46C120.729 540.763 120.801 541.071 120.866 541.306C120.898 541.422 120.928 541.519 120.95 541.587C120.961 541.621 120.97 541.647 120.976 541.665C120.979 541.674 120.981 541.68 120.983 541.685C120.984 541.687 120.985 541.688 120.985 541.689L120.986 541.69L120.631 541.836C120.612 541.845 120.608 541.847 120.607 541.848L120.606 541.847C120.605 541.846 120.605 541.843 120.604 541.841C120.602 541.836 120.598 541.828 120.592 541.817C120.582 541.796 120.565 541.764 120.542 541.723C120.495 541.639 120.423 541.518 120.322 541.369C120.12 541.072 119.803 540.666 119.348 540.242C118.44 539.396 116.976 538.471 114.755 538.179C113.645 538.033 112.948 538.174 112.518 538.433C112.096 538.687 111.899 539.072 111.826 539.493C111.751 539.92 111.807 540.373 111.885 540.728C111.924 540.903 111.968 541.051 112.001 541.154C112.018 541.206 112.033 541.246 112.042 541.273C112.047 541.287 112.052 541.297 112.054 541.304C112.055 541.307 112.057 541.309 112.057 541.311V541.312L112.304 541.923L111.754 541.561L111.753 541.56L111.736 541.548C111.723 541.54 111.703 541.527 111.678 541.512C111.628 541.48 111.553 541.436 111.461 541.384C111.277 541.278 111.02 541.141 110.732 541.015C110.443 540.888 110.126 540.774 109.822 540.713C109.515 540.651 109.238 540.646 109.015 540.717C108.926 540.745 108.889 540.785 108.87 540.825C108.847 540.873 108.836 540.949 108.853 541.062C108.888 541.293 109.025 541.596 109.211 541.911C109.394 542.221 109.611 542.523 109.784 542.749C109.87 542.862 109.945 542.955 109.998 543.02C110.024 543.052 110.045 543.077 110.059 543.094C110.066 543.102 110.071 543.108 110.075 543.112C110.076 543.114 110.078 543.116 110.079 543.117L110.08 543.118V543.119L109.837 543.438L109.836 543.438C109.835 543.437 109.834 543.437 109.832 543.436C109.827 543.433 109.819 543.43 109.81 543.426C109.791 543.417 109.763 543.405 109.727 543.39C109.654 543.358 109.547 543.314 109.414 543.262C109.146 543.157 108.772 543.023 108.348 542.904C107.489 542.665 106.468 542.503 105.701 542.737C105.531 542.789 105.461 542.862 105.43 542.927C105.397 542.997 105.388 543.101 105.429 543.253C105.512 543.563 105.77 543.96 106.102 544.368C106.429 544.769 106.808 545.157 107.108 545.446C107.257 545.59 107.386 545.709 107.477 545.792C107.512 545.823 107.541 545.85 107.564 545.87H150.624C150.636 545.858 150.651 545.845 150.667 545.829C150.735 545.766 150.833 545.674 150.95 545.555C151.184 545.317 151.496 544.976 151.81 544.565C152.444 543.737 153.062 542.656 153.096 541.575C153.104 541.312 153.061 541.137 152.998 541.023C152.937 540.914 152.849 540.846 152.736 540.808C152.491 540.724 152.123 540.775 151.702 540.916C151.291 541.054 150.874 541.262 150.556 541.438C150.398 541.526 150.266 541.605 150.173 541.662C150.127 541.69 150.091 541.714 150.067 541.729C150.055 541.737 150.046 541.743 150.04 541.747C150.037 541.749 150.034 541.75 150.033 541.751L150.031 541.753L149.741 541.479H149.74L149.741 541.478C149.741 541.476 149.743 541.475 149.745 541.472C149.748 541.466 149.752 541.456 149.758 541.444C149.771 541.421 149.788 541.386 149.806 541.343C149.844 541.255 149.885 541.141 149.904 541.024C149.923 540.906 149.916 540.804 149.881 540.727C149.851 540.658 149.788 540.585 149.639 540.537L149.64 540.536C149.517 540.497 149.32 540.526 149.056 540.64C148.802 540.749 148.524 540.919 148.263 541.104C148.004 541.287 147.768 541.478 147.596 541.624C147.511 541.697 147.442 541.759 147.394 541.802C147.37 541.823 147.352 541.84 147.339 541.852C147.333 541.857 147.329 541.861 147.326 541.864C147.324 541.866 147.322 541.867 147.322 541.867L147.321 541.868L146.98 542.188L146.975 541.721V541.711C146.975 541.704 146.975 541.692 146.974 541.678C146.973 541.648 146.971 541.603 146.967 541.546C146.96 541.431 146.946 541.265 146.919 541.065C146.866 540.664 146.762 540.128 146.562 539.582C146.185 538.556 145.484 537.532 144.163 537.255L143.89 537.21C142.342 537.018 141.367 537.489 140.78 537.992C140.484 538.246 140.282 538.511 140.155 538.712C140.091 538.812 140.046 538.896 140.018 538.954C140.004 538.983 139.994 539.005 139.988 539.02C139.985 539.027 139.982 539.032 139.981 539.035V539.038H139.98L139.781 539.552L139.595 539.033C139.595 539.033 139.595 539.032 139.594 539.03C139.593 539.028 139.592 539.023 139.589 539.018C139.585 539.006 139.578 538.989 139.569 538.967C139.551 538.922 139.523 538.857 139.486 538.779C139.412 538.622 139.302 538.414 139.158 538.206C138.861 537.779 138.456 537.408 137.958 537.395C137.698 537.388 137.534 537.454 137.427 537.539C137.318 537.626 137.247 537.747 137.205 537.883C137.162 538.019 137.149 538.161 137.148 538.271C137.148 538.326 137.15 538.371 137.153 538.402C137.154 538.417 137.155 538.429 137.156 538.437C137.156 538.44 137.157 538.443 137.157 538.444V538.445L136.788 538.595L136.786 538.592C136.783 538.589 136.779 538.584 136.774 538.577C136.764 538.564 136.748 538.543 136.725 538.517C136.68 538.464 136.609 538.387 136.513 538.295C136.321 538.111 136.026 537.868 135.617 537.637Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.410417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.662 537.63C175.958 537.173 174.86 536.758 173.286 536.965C171.736 537.168 170.835 538.06 170.315 538.91C170.054 539.336 169.892 539.751 169.793 540.059C169.745 540.212 169.712 540.339 169.692 540.426C169.682 540.469 169.675 540.503 169.67 540.525C169.668 540.537 169.666 540.545 169.666 540.551C169.665 540.553 169.665 540.556 169.665 540.557V540.558L169.598 540.963L169.314 540.666L169.312 540.664C169.31 540.662 169.307 540.661 169.304 540.657C169.297 540.65 169.287 540.639 169.273 540.626C169.245 540.599 169.204 540.561 169.151 540.515C169.044 540.422 168.893 540.301 168.714 540.188C168.348 539.955 167.908 539.78 167.507 539.875C167.362 539.909 167.26 540.02 167.194 540.23C167.127 540.445 167.112 540.728 167.129 541.022C167.146 541.314 167.193 541.601 167.235 541.816C167.256 541.923 167.276 542.012 167.291 542.073C167.298 542.104 167.303 542.128 167.307 542.145C167.309 542.152 167.311 542.158 167.312 542.162C167.313 542.164 167.313 542.166 167.313 542.167L167.314 542.168L166.939 542.325H166.938V542.323C166.937 542.322 166.936 542.32 166.934 542.317C166.931 542.312 166.926 542.304 166.919 542.293C166.907 542.272 166.887 542.24 166.863 542.2C166.813 542.12 166.742 542.005 166.652 541.867C166.471 541.59 166.218 541.222 165.929 540.854C165.64 540.484 165.319 540.121 165.002 539.851C164.678 539.574 164.392 539.425 164.17 539.421C164.06 539.419 163.989 539.446 163.939 539.483C163.887 539.522 163.841 539.584 163.805 539.677C163.731 539.87 163.719 540.15 163.746 540.462C163.772 540.767 163.834 541.077 163.89 541.312C163.918 541.429 163.945 541.527 163.964 541.595C163.974 541.629 163.982 541.655 163.988 541.673C163.99 541.682 163.992 541.689 163.994 541.693C163.994 541.695 163.994 541.696 163.995 541.697L163.996 541.699L163.61 541.838L163.609 541.837C163.608 541.836 163.608 541.834 163.607 541.831C163.605 541.826 163.602 541.818 163.597 541.808C163.588 541.786 163.573 541.754 163.552 541.712C163.512 541.628 163.448 541.506 163.361 541.357C163.185 541.06 162.911 540.655 162.516 540.232C161.728 539.388 160.462 538.469 158.544 538.179C157.587 538.034 156.996 538.175 156.632 538.426C156.272 538.675 156.097 539.06 156.032 539.489C155.967 539.92 156.016 540.377 156.084 540.732C156.118 540.909 156.156 541.058 156.186 541.162C156.201 541.214 156.213 541.254 156.222 541.281C156.227 541.295 156.23 541.306 156.232 541.312C156.233 541.316 156.233 541.318 156.234 541.319L156.235 541.321L156.461 541.965L155.917 541.553L155.917 541.552C155.916 541.551 155.915 541.551 155.914 541.55C155.911 541.548 155.907 541.545 155.902 541.541C155.891 541.533 155.874 541.52 155.852 541.505C155.808 541.474 155.744 541.429 155.665 541.377C155.505 541.272 155.283 541.135 155.034 541.01C154.784 540.884 154.512 540.772 154.252 540.712C154.056 540.666 153.877 540.653 153.723 540.677L153.579 540.714C153.514 540.738 153.483 540.772 153.464 540.815C153.443 540.867 153.433 540.949 153.448 541.065C153.478 541.301 153.6 541.607 153.761 541.922C153.92 542.232 154.109 542.534 154.259 542.76C154.334 542.872 154.399 542.966 154.445 543.03C154.468 543.063 154.486 543.088 154.499 543.104C154.505 543.113 154.509 543.12 154.512 543.124C154.514 543.126 154.515 543.128 154.516 543.129L154.517 543.13L154.255 543.434L154.254 543.433C154.254 543.432 154.252 543.432 154.25 543.431C154.247 543.429 154.24 543.425 154.232 543.421C154.216 543.413 154.192 543.4 154.161 543.385C154.097 543.353 154.005 543.309 153.889 543.257C153.657 543.153 153.334 543.02 152.967 542.902C152.222 542.663 151.348 542.506 150.697 542.734C150.561 542.782 150.502 542.849 150.474 542.917C150.443 542.993 150.436 543.105 150.472 543.26C150.546 543.574 150.771 543.972 151.059 544.379C151.343 544.78 151.673 545.168 151.933 545.457C152.063 545.601 152.174 545.719 152.253 545.802C152.279 545.828 152.302 545.851 152.32 545.87H189.711C189.72 545.861 189.73 545.851 189.741 545.84C189.799 545.777 189.883 545.684 189.985 545.565C190.188 545.328 190.46 544.987 190.733 544.576C191.283 543.75 191.823 542.665 191.853 541.576C191.86 541.309 191.822 541.13 191.765 541.013C191.711 540.901 191.637 540.839 191.549 540.805C191.354 540.728 191.051 540.772 190.685 540.913C190.332 541.049 189.971 541.256 189.696 541.432C189.559 541.519 189.445 541.598 189.365 541.654C189.325 541.683 189.294 541.706 189.273 541.722C189.262 541.729 189.254 541.735 189.249 541.739C189.246 541.741 189.244 541.742 189.243 541.743L189.242 541.744V541.745L189.24 541.742L188.934 541.489V541.488C188.935 541.487 188.936 541.484 188.937 541.481C188.94 541.476 188.944 541.467 188.95 541.455C188.961 541.431 188.975 541.395 188.992 541.352C189.025 541.263 189.061 541.147 189.078 541.028C189.095 540.907 189.089 540.799 189.057 540.717C189.036 540.662 189 540.611 188.935 540.57L188.859 540.534C188.772 540.502 188.617 540.522 188.388 540.635C188.171 540.742 187.932 540.911 187.706 541.095C187.481 541.277 187.276 541.468 187.127 541.614C187.053 541.687 186.993 541.749 186.952 541.792C186.931 541.813 186.914 541.829 186.904 541.841C186.899 541.846 186.895 541.851 186.892 541.854C186.891 541.855 186.89 541.857 186.889 541.857H186.888L186.538 542.237L186.533 541.721V541.71C186.533 541.703 186.532 541.691 186.532 541.677C186.531 541.647 186.529 541.601 186.526 541.544C186.52 541.429 186.507 541.262 186.484 541.062C186.437 540.659 186.347 540.122 186.172 539.574C185.841 538.536 185.23 537.526 184.103 537.254L183.871 537.209C182.543 537.02 181.708 537.483 181.202 537.982C180.946 538.235 180.771 538.499 180.66 538.701C180.604 538.802 180.565 538.886 180.541 538.944C180.528 538.973 180.519 538.996 180.513 539.011C180.51 539.018 180.508 539.023 180.507 539.026L180.506 539.03L180.304 539.63L180.116 539.025L180.115 539.022C180.114 539.02 180.113 539.015 180.111 539.01C180.107 538.998 180.101 538.98 180.093 538.958C180.077 538.913 180.053 538.848 180.021 538.77C179.956 538.612 179.861 538.403 179.735 538.195C179.472 537.761 179.126 537.408 178.72 537.395C178.507 537.389 178.374 537.45 178.287 537.529C178.194 537.613 178.133 537.735 178.094 537.875C178.056 538.014 178.044 538.159 178.043 538.271C178.043 538.327 178.046 538.373 178.048 538.404C178.049 538.42 178.051 538.432 178.051 538.439C178.052 538.443 178.051 538.447 178.051 538.448L178.052 538.449L177.678 538.581C177.674 538.584 177.674 538.584 177.674 538.584L177.663 538.566C177.654 538.553 177.639 538.532 177.62 538.506C177.58 538.453 177.52 538.376 177.437 538.285C177.271 538.102 177.015 537.86 176.662 537.63Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.410417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.742 544.232V547.89H191.684V544.232H105.742Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.410417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.416 347.762H-98.019V546.83H184.416V347.762Z",
    fill: "#F9E3E1",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.416 500.863H-98.019V546.832H184.416V500.863Z",
    fill: "#D7C7A3",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9344 509.831H-1.72217V546.832H20.9344V509.831Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1566 509.831H31.5V546.832H54.1566V509.831Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7913 509.831H60.1348V546.832H82.7913V509.831Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9498 517.017C88.9498 509.639 96.0237 503.661 104.754 503.661C113.485 503.661 120.559 509.639 120.559 517.017V546.829H88.9312V517.017H88.9498Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58 509.831H125.923V546.832H148.58V509.831Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.006 509.831H155.35V546.832H178.006V509.831Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9344 516H-1.72217V546.834H20.9344V516Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1566 516H31.5V546.834H54.1566V516Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7913 516H60.1348V546.834H82.7913V516Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9498 523.187C88.9498 515.809 96.0237 509.831 104.754 509.831C113.485 509.831 120.559 515.809 120.559 523.187V546.832H88.9312V523.187H88.9498Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58 516H125.923V546.834H148.58V516Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.006 516H155.35V546.834H178.006V516Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.629 438.951H1.03516V457.457H10.629V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.629 475.963H1.03516V494.469H10.629V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0167 438.951H19.4229V457.457H29.0167V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0167 475.963H19.4229V494.469H29.0167V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4054 438.951H37.8115V457.457H47.4054V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4054 475.963H37.8115V494.469H47.4054V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7936 438.951H56.1997V457.457H65.7936V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7936 475.963H56.1997V494.469H65.7936V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1818 438.951H74.5879V457.457H84.1818V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1818 475.963H74.5879V494.469H84.1818V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57 438.951H92.9761V457.457H102.57V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57 475.963H92.9761V494.469H102.57V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.959 438.951H111.365V457.457H120.959V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.959 475.963H111.365V494.469H120.959V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.347 438.951H129.753V457.457H139.347V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.347 475.963H129.753V494.469H139.347V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.735 438.951H148.141V457.457H157.735V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.735 475.963H148.141V494.469H157.735V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.123 438.951H166.529V457.457H176.123V438.951Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.123 475.963H166.529V494.469H176.123V475.963Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.629 362.151H1.03516V380.657H10.629V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.629 399.163H1.03516V417.669H10.629V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0167 362.151H19.4229V380.657H29.0167V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0167 399.163H19.4229V417.669H29.0167V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4054 362.151H37.8115V380.657H47.4054V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4054 399.163H37.8115V417.669H47.4054V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7936 362.151H56.1997V380.657H65.7936V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7936 399.163H56.1997V417.669H65.7936V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1818 362.151H74.5879V380.657H84.1818V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1818 399.163H74.5879V417.669H84.1818V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57 362.151H92.9761V380.657H102.57V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57 399.163H92.9761V417.669H102.57V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.959 362.151H111.365V380.657H120.959V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.959 399.163H111.365V417.669H120.959V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.347 362.151H129.753V380.657H139.347V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.347 399.163H129.753V417.669H139.347V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.735 362.151H148.141V380.657H157.735V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.735 399.163H148.141V417.669H157.735V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.123 362.151H166.529V380.657H176.123V362.151Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.123 399.163H166.529V417.669H176.123V399.163Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.713 347.119H-106.333V351.651H192.713V347.119Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.935 337.619H-102.551V346.682H188.935V337.619Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.143475 340.436H-25.5303V343.453H0.143475V340.436Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3964 340.436H10.7227V343.453H36.3964V340.436Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6449 340.236H46.9712V343.253H72.6449V340.236Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.884 340.236H83.21V343.253H108.884V340.236Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.135 340.236H119.461V343.253H145.135V340.236Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.388 340.236H155.714V343.253H181.388V340.236Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.15596
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.469 509.381L142.458 509.586L142.624 510.416H143.469V509.381ZM147.706 509.381H148.741V508.345H147.706V509.381ZM147.706 514.542V515.577H148.741V514.542H147.706ZM127.054 514.542H126.019V515.577H127.054V514.542ZM127.054 509.381V508.345H126.019V509.381H127.054ZM131.29 509.381V510.416H132.136L132.302 509.586L131.29 509.381ZM143.469 510.416H146.678H147.706V508.353H143.469V510.416ZM146.678 509.381V510.416V513.506V514.542H148.741V509.381H146.678ZM147.706 513.506H146.678H128.089H127.054V515.569H147.706V513.506ZM128.089 514.542V513.506V510.416V509.381H126.026V514.542H128.089ZM127.054 510.416H128.089H131.29V508.353H127.054V510.416ZM132.302 509.586C132.681 507.705 134.357 506.283 136.348 506.283V504.22C133.353 504.22 130.855 506.346 130.278 509.175L132.302 509.586ZM136.348 506.283H138.411V504.22H136.348V506.283ZM138.411 506.283C140.403 506.283 142.078 507.705 142.458 509.586L144.481 509.175C143.904 506.346 141.407 504.22 138.411 504.22V506.283Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.624 510.416L142.458 509.586C142.078 507.705 140.403 506.283 138.411 506.283H136.348C134.357 506.283 132.681 507.705 132.302 509.586L132.136 510.416H131.29H128.089V513.506H146.678V510.416H143.469H142.624Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1295 509.381L48.1179 509.586L48.284 510.416H49.1295V509.381ZM53.3659 509.381H54.4013V508.345H53.3659V509.381ZM53.3659 514.542V515.577H54.4013V514.542H53.3659ZM32.7139 514.542H31.6787V515.577H32.7139V514.542ZM32.7139 509.381V508.345H31.6787V509.381H32.7139ZM36.9503 509.381V510.416H37.796L37.962 509.586L36.9503 509.381ZM49.1295 510.416H52.3384H53.3659V508.353H49.1295V510.416ZM52.3384 509.381V510.416V513.506V514.542H54.4013V509.381H52.3384ZM53.3659 513.506H52.3384H33.7493H32.7139V515.569H53.3659V513.506ZM33.7493 514.542V513.506V510.416V509.381H31.6866V514.542H33.7493ZM32.7139 510.416H33.7493H36.9503V508.353H32.7139V510.416ZM37.962 509.586C38.3413 507.705 40.0168 506.283 42.0085 506.283V504.22C39.013 504.22 36.5156 506.346 35.9386 509.175L37.962 509.586ZM42.0085 506.283H44.0714V504.22H42.0085V506.283ZM44.0714 506.283C46.0631 506.283 47.7385 507.705 48.1179 509.586L50.1412 509.175C49.5643 506.346 47.0668 504.22 44.0714 504.22V506.283Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.284 510.416L48.1179 509.586C47.7385 507.705 46.0631 506.283 44.0714 506.283H42.0085C40.0168 506.283 38.3413 507.705 37.962 509.586L37.796 510.416H36.9503H33.7493V513.506H52.3384V510.416H49.1295H48.284Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05 509.381L172.038 509.586L172.204 510.416H173.05V509.381ZM177.286 509.381H178.322V508.345H177.286V509.381ZM177.286 514.542V515.577H178.322V514.542H177.286ZM156.634 514.542H155.599V515.577H156.634V514.542ZM156.634 509.381V508.345H155.599V509.381H156.634ZM160.871 509.381V510.416H161.716L161.882 509.586L160.871 509.381ZM173.05 510.416H176.259H177.286V508.353H173.05V510.416ZM176.259 509.381V510.416V513.506V514.542H178.322V509.381H176.259ZM177.286 513.506H176.259H157.67H156.634V515.569H177.286V513.506ZM157.67 514.542V513.506V510.416V509.381H155.607V514.542H157.67ZM156.634 510.416H157.67H160.871V508.353H156.634V510.416ZM161.882 509.586C162.262 507.705 163.937 506.283 165.929 506.283V504.22C162.933 504.22 160.436 506.346 159.859 509.175L161.882 509.586ZM165.929 506.283H167.992V504.22H165.929V506.283ZM167.992 506.283C169.983 506.283 171.659 507.705 172.038 509.586L174.062 509.175C173.485 506.346 170.987 504.22 167.992 504.22V506.283Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.204 510.416L172.038 509.586C171.659 507.705 169.983 506.283 167.992 506.283H165.929C163.937 506.283 162.262 507.705 161.882 509.586L161.716 510.416H160.871H157.67V513.506H176.259V510.416H173.05H172.204Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7101 509.381L77.6984 509.586L77.8646 510.416H78.7101V509.381ZM82.9465 509.381H83.9819V508.345H82.9465V509.381ZM82.9465 514.542V515.577H83.9819V514.542H82.9465ZM62.2945 514.542H61.2593V515.577H62.2945V514.542ZM62.2945 509.381V508.345H61.2593V509.381H62.2945ZM66.5309 509.381V510.416H67.3766L67.5425 509.586L66.5309 509.381ZM78.7101 510.416H81.919H82.9465V508.353H78.7101V510.416ZM81.919 509.381V510.416V513.506V514.542H83.9819V509.381H81.919ZM82.9465 513.506H81.919H63.3299H62.2945V515.569H82.9465V513.506ZM63.3299 514.542V513.506V510.416V509.381H61.2672V514.542H63.3299ZM62.2945 510.416H63.3299H66.5309V508.353H62.2945V510.416ZM67.5425 509.586C67.9219 507.705 69.5973 506.283 71.589 506.283V504.22C68.5936 504.22 66.0961 506.346 65.5192 509.175L67.5425 509.586ZM71.589 506.283H73.6519V504.22H71.589V506.283ZM73.6519 506.283C75.6436 506.283 77.3191 507.705 77.6984 509.586L79.7218 509.175C79.1448 506.346 76.6474 504.22 73.6519 504.22V506.283Z",
    fill: "#6B6770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8646 510.416L77.6984 509.586C77.3191 507.705 75.6436 506.283 73.6519 506.283H71.589C69.5973 506.283 67.9219 507.705 67.5425 509.586L67.3766 510.416H66.5309H63.3299V513.506H81.919V510.416H78.7101H77.8646Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.617 537.637C134.801 537.175 133.523 536.757 131.697 536.966C129.893 537.172 128.85 538.074 128.254 538.921C127.955 539.347 127.767 539.761 127.655 540.067C127.599 540.22 127.562 540.346 127.539 540.433C127.527 540.476 127.519 540.509 127.514 540.531C127.512 540.542 127.51 540.55 127.509 540.556C127.509 540.558 127.509 540.56 127.508 540.562L127.44 540.923L127.168 540.676L127.167 540.675C127.165 540.673 127.162 540.67 127.158 540.667C127.15 540.66 127.138 540.649 127.122 540.636C127.089 540.609 127.04 540.57 126.979 540.523C126.856 540.43 126.681 540.309 126.474 540.194C126.052 539.961 125.53 539.778 125.045 539.877C124.854 539.916 124.737 540.039 124.665 540.239C124.589 540.449 124.573 540.727 124.592 541.021C124.611 541.31 124.664 541.596 124.712 541.811C124.737 541.917 124.759 542.006 124.776 542.067C124.784 542.098 124.792 542.122 124.796 542.138C124.799 542.145 124.8 542.151 124.801 542.155C124.802 542.157 124.802 542.158 124.802 542.159L124.803 542.16L124.437 542.336L124.436 542.334C124.435 542.333 124.434 542.331 124.432 542.328C124.429 542.323 124.423 542.315 124.416 542.305C124.401 542.283 124.378 542.252 124.35 542.212C124.293 542.132 124.211 542.016 124.107 541.878C123.899 541.601 123.608 541.233 123.276 540.864C122.943 540.495 122.573 540.131 122.208 539.859C121.835 539.583 121.496 539.426 121.22 539.421C121.082 539.419 120.988 539.449 120.923 539.491C120.858 539.533 120.807 539.597 120.767 539.687C120.684 539.874 120.668 540.15 120.699 540.46C120.729 540.763 120.801 541.071 120.866 541.306C120.898 541.422 120.928 541.519 120.95 541.587C120.961 541.621 120.97 541.647 120.976 541.665C120.979 541.674 120.981 541.68 120.983 541.685C120.984 541.687 120.985 541.688 120.985 541.689L120.986 541.69L120.631 541.836C120.612 541.845 120.608 541.847 120.607 541.848L120.606 541.847C120.605 541.846 120.605 541.843 120.604 541.841C120.602 541.836 120.598 541.828 120.592 541.817C120.582 541.796 120.565 541.764 120.542 541.723C120.495 541.639 120.423 541.518 120.322 541.369C120.12 541.072 119.803 540.666 119.348 540.242C118.44 539.396 116.976 538.471 114.755 538.179C113.645 538.033 112.948 538.174 112.518 538.433C112.096 538.687 111.899 539.072 111.826 539.493C111.751 539.92 111.807 540.373 111.885 540.728C111.924 540.903 111.968 541.051 112.001 541.154C112.018 541.206 112.033 541.246 112.042 541.273C112.047 541.287 112.052 541.297 112.054 541.304C112.055 541.307 112.057 541.309 112.057 541.311V541.312L112.304 541.923L111.754 541.561L111.753 541.56L111.736 541.548C111.723 541.54 111.703 541.527 111.678 541.512C111.628 541.48 111.553 541.436 111.461 541.384C111.277 541.278 111.02 541.141 110.732 541.015C110.443 540.888 110.126 540.774 109.822 540.713C109.515 540.651 109.238 540.646 109.015 540.717C108.926 540.745 108.889 540.785 108.87 540.825C108.847 540.873 108.836 540.949 108.853 541.062C108.888 541.293 109.025 541.596 109.211 541.911C109.394 542.221 109.611 542.523 109.784 542.749C109.87 542.862 109.945 542.955 109.998 543.02C110.024 543.052 110.045 543.077 110.059 543.094C110.066 543.102 110.071 543.108 110.075 543.112C110.076 543.114 110.078 543.116 110.079 543.117L110.08 543.118V543.119L109.837 543.438L109.836 543.438C109.835 543.437 109.834 543.437 109.832 543.436C109.827 543.433 109.819 543.43 109.81 543.426C109.791 543.417 109.763 543.405 109.727 543.39C109.654 543.358 109.547 543.314 109.414 543.262C109.146 543.157 108.772 543.023 108.348 542.904C107.489 542.665 106.468 542.503 105.701 542.737C105.531 542.789 105.461 542.862 105.43 542.927C105.397 542.997 105.388 543.101 105.429 543.253C105.512 543.563 105.77 543.96 106.102 544.368C106.429 544.769 106.808 545.157 107.108 545.446C107.257 545.59 107.386 545.709 107.477 545.792C107.512 545.823 107.541 545.85 107.564 545.87H150.624C150.636 545.858 150.651 545.845 150.667 545.829C150.735 545.766 150.833 545.674 150.95 545.555C151.184 545.317 151.496 544.976 151.81 544.565C152.444 543.737 153.062 542.656 153.096 541.575C153.104 541.312 153.061 541.137 152.998 541.023C152.937 540.914 152.849 540.846 152.736 540.808C152.491 540.724 152.123 540.775 151.702 540.916C151.291 541.054 150.874 541.262 150.556 541.438C150.398 541.526 150.266 541.605 150.173 541.662C150.127 541.69 150.091 541.714 150.067 541.729C150.055 541.737 150.046 541.743 150.04 541.747C150.037 541.749 150.034 541.75 150.033 541.751L150.031 541.753L149.741 541.479H149.74L149.741 541.478C149.741 541.476 149.743 541.475 149.745 541.472C149.748 541.466 149.752 541.456 149.758 541.444C149.771 541.421 149.788 541.386 149.806 541.343C149.844 541.255 149.885 541.141 149.904 541.024C149.923 540.906 149.916 540.804 149.881 540.727C149.851 540.658 149.788 540.585 149.639 540.537L149.64 540.536C149.517 540.497 149.32 540.526 149.056 540.64C148.802 540.749 148.524 540.919 148.263 541.104C148.004 541.287 147.768 541.478 147.596 541.624C147.511 541.697 147.442 541.759 147.394 541.802C147.37 541.823 147.352 541.84 147.339 541.852C147.333 541.857 147.329 541.861 147.326 541.864C147.324 541.866 147.322 541.867 147.322 541.867L147.321 541.868L146.98 542.188L146.975 541.721V541.711C146.975 541.704 146.975 541.692 146.974 541.678C146.973 541.648 146.971 541.603 146.967 541.546C146.96 541.431 146.946 541.265 146.919 541.065C146.866 540.664 146.762 540.128 146.562 539.582C146.185 538.556 145.484 537.532 144.163 537.255L143.89 537.21C142.342 537.018 141.367 537.489 140.78 537.992C140.484 538.246 140.282 538.511 140.155 538.712C140.091 538.812 140.046 538.896 140.018 538.954C140.004 538.983 139.994 539.005 139.988 539.02C139.985 539.027 139.982 539.032 139.981 539.035V539.038H139.98L139.781 539.552L139.595 539.033C139.595 539.033 139.595 539.032 139.594 539.03C139.593 539.028 139.592 539.023 139.589 539.018C139.585 539.006 139.578 538.989 139.569 538.967C139.551 538.922 139.523 538.857 139.486 538.779C139.412 538.622 139.302 538.414 139.158 538.206C138.861 537.779 138.456 537.408 137.958 537.395C137.698 537.388 137.534 537.454 137.427 537.539C137.318 537.626 137.247 537.747 137.205 537.883C137.162 538.019 137.149 538.161 137.148 538.271C137.148 538.326 137.15 538.371 137.153 538.402C137.154 538.417 137.155 538.429 137.156 538.437C137.156 538.44 137.157 538.443 137.157 538.444V538.445L136.788 538.595L136.786 538.592C136.783 538.589 136.779 538.584 136.774 538.577C136.764 538.564 136.748 538.543 136.725 538.517C136.68 538.464 136.609 538.387 136.513 538.295C136.321 538.111 136.026 537.868 135.617 537.637Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.410417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.662 537.63C175.958 537.173 174.86 536.758 173.286 536.965C171.736 537.168 170.835 538.06 170.315 538.91C170.054 539.336 169.892 539.751 169.793 540.059C169.745 540.212 169.712 540.339 169.692 540.426C169.682 540.469 169.675 540.503 169.67 540.525C169.668 540.537 169.666 540.545 169.666 540.551C169.665 540.553 169.665 540.556 169.665 540.557V540.558L169.598 540.963L169.314 540.666L169.312 540.664C169.31 540.662 169.307 540.661 169.304 540.657C169.297 540.65 169.287 540.639 169.273 540.626C169.245 540.599 169.204 540.561 169.151 540.515C169.044 540.422 168.893 540.301 168.714 540.188C168.348 539.955 167.908 539.78 167.507 539.875C167.362 539.909 167.26 540.02 167.194 540.23C167.127 540.445 167.112 540.728 167.129 541.022C167.146 541.314 167.193 541.601 167.235 541.816C167.256 541.923 167.276 542.012 167.291 542.073C167.298 542.104 167.303 542.128 167.307 542.145C167.309 542.152 167.311 542.158 167.312 542.162C167.313 542.164 167.313 542.166 167.313 542.167L167.314 542.168L166.939 542.325H166.938V542.323C166.937 542.322 166.936 542.32 166.934 542.317C166.931 542.312 166.926 542.304 166.919 542.293C166.907 542.272 166.887 542.24 166.863 542.2C166.813 542.12 166.742 542.005 166.652 541.867C166.471 541.59 166.218 541.222 165.929 540.854C165.64 540.484 165.319 540.121 165.002 539.851C164.678 539.574 164.392 539.425 164.17 539.421C164.06 539.419 163.989 539.446 163.939 539.483C163.887 539.522 163.841 539.584 163.805 539.677C163.731 539.87 163.719 540.15 163.746 540.462C163.772 540.767 163.834 541.077 163.89 541.312C163.918 541.429 163.945 541.527 163.964 541.595C163.974 541.629 163.982 541.655 163.988 541.673C163.99 541.682 163.992 541.689 163.994 541.693C163.994 541.695 163.994 541.696 163.995 541.697L163.996 541.699L163.61 541.838L163.609 541.837C163.608 541.836 163.608 541.834 163.607 541.831C163.605 541.826 163.602 541.818 163.597 541.808C163.588 541.786 163.573 541.754 163.552 541.712C163.512 541.628 163.448 541.506 163.361 541.357C163.185 541.06 162.911 540.655 162.516 540.232C161.728 539.388 160.462 538.469 158.544 538.179C157.587 538.034 156.996 538.175 156.632 538.426C156.272 538.675 156.097 539.06 156.032 539.489C155.967 539.92 156.016 540.377 156.084 540.732C156.118 540.909 156.156 541.058 156.186 541.162C156.201 541.214 156.213 541.254 156.222 541.281C156.227 541.295 156.23 541.306 156.232 541.312C156.233 541.316 156.233 541.318 156.234 541.319L156.235 541.321L156.461 541.965L155.917 541.553L155.917 541.552C155.916 541.551 155.915 541.551 155.914 541.55C155.911 541.548 155.907 541.545 155.902 541.541C155.891 541.533 155.874 541.52 155.852 541.505C155.808 541.474 155.744 541.429 155.665 541.377C155.505 541.272 155.283 541.135 155.034 541.01C154.784 540.884 154.512 540.772 154.252 540.712C154.056 540.666 153.877 540.653 153.723 540.677L153.579 540.714C153.514 540.738 153.483 540.772 153.464 540.815C153.443 540.867 153.433 540.949 153.448 541.065C153.478 541.301 153.6 541.607 153.761 541.922C153.92 542.232 154.109 542.534 154.259 542.76C154.334 542.872 154.399 542.966 154.445 543.03C154.468 543.063 154.486 543.088 154.499 543.104C154.505 543.113 154.509 543.12 154.512 543.124C154.514 543.126 154.515 543.128 154.516 543.129L154.517 543.13L154.255 543.434L154.254 543.433C154.254 543.432 154.252 543.432 154.25 543.431C154.247 543.429 154.24 543.425 154.232 543.421C154.216 543.413 154.192 543.4 154.161 543.385C154.097 543.353 154.005 543.309 153.889 543.257C153.657 543.153 153.334 543.02 152.967 542.902C152.222 542.663 151.348 542.506 150.697 542.734C150.561 542.782 150.502 542.849 150.474 542.917C150.443 542.993 150.436 543.105 150.472 543.26C150.546 543.574 150.771 543.972 151.059 544.379C151.343 544.78 151.673 545.168 151.933 545.457C152.063 545.601 152.174 545.719 152.253 545.802C152.279 545.828 152.302 545.851 152.32 545.87H189.711C189.72 545.861 189.73 545.851 189.741 545.84C189.799 545.777 189.883 545.684 189.985 545.565C190.188 545.328 190.46 544.987 190.733 544.576C191.283 543.75 191.823 542.665 191.853 541.576C191.86 541.309 191.822 541.13 191.765 541.013C191.711 540.901 191.637 540.839 191.549 540.805C191.354 540.728 191.051 540.772 190.685 540.913C190.332 541.049 189.971 541.256 189.696 541.432C189.559 541.519 189.445 541.598 189.365 541.654C189.325 541.683 189.294 541.706 189.273 541.722C189.262 541.729 189.254 541.735 189.249 541.739C189.246 541.741 189.244 541.742 189.243 541.743L189.242 541.744V541.745L189.24 541.742L188.934 541.489V541.488C188.935 541.487 188.936 541.484 188.937 541.481C188.94 541.476 188.944 541.467 188.95 541.455C188.961 541.431 188.975 541.395 188.992 541.352C189.025 541.263 189.061 541.147 189.078 541.028C189.095 540.907 189.089 540.799 189.057 540.717C189.036 540.662 189 540.611 188.935 540.57L188.859 540.534C188.772 540.502 188.617 540.522 188.388 540.635C188.171 540.742 187.932 540.911 187.706 541.095C187.481 541.277 187.276 541.468 187.127 541.614C187.053 541.687 186.993 541.749 186.952 541.792C186.931 541.813 186.914 541.829 186.904 541.841C186.899 541.846 186.895 541.851 186.892 541.854C186.891 541.855 186.89 541.857 186.889 541.857H186.888L186.538 542.237L186.533 541.721V541.71C186.533 541.703 186.532 541.691 186.532 541.677C186.531 541.647 186.529 541.601 186.526 541.544C186.52 541.429 186.507 541.262 186.484 541.062C186.437 540.659 186.347 540.122 186.172 539.574C185.841 538.536 185.23 537.526 184.103 537.254L183.871 537.209C182.543 537.02 181.708 537.483 181.202 537.982C180.946 538.235 180.771 538.499 180.66 538.701C180.604 538.802 180.565 538.886 180.541 538.944C180.528 538.973 180.519 538.996 180.513 539.011C180.51 539.018 180.508 539.023 180.507 539.026L180.506 539.03L180.304 539.63L180.116 539.025L180.115 539.022C180.114 539.02 180.113 539.015 180.111 539.01C180.107 538.998 180.101 538.98 180.093 538.958C180.077 538.913 180.053 538.848 180.021 538.77C179.956 538.612 179.861 538.403 179.735 538.195C179.472 537.761 179.126 537.408 178.72 537.395C178.507 537.389 178.374 537.45 178.287 537.529C178.194 537.613 178.133 537.735 178.094 537.875C178.056 538.014 178.044 538.159 178.043 538.271C178.043 538.327 178.046 538.373 178.048 538.404C178.049 538.42 178.051 538.432 178.051 538.439C178.052 538.443 178.051 538.447 178.051 538.448L178.052 538.449L177.678 538.581C177.674 538.584 177.674 538.584 177.674 538.584L177.663 538.566C177.654 538.553 177.639 538.532 177.62 538.506C177.58 538.453 177.52 538.376 177.437 538.285C177.271 538.102 177.015 537.86 176.662 537.63Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.410417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.742 544.232V547.89H191.684V544.232H105.742Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.410417
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.867 517C197.653 517 198.299 517.637 198.299 518.432V541.32C198.299 542.106 197.661 542.752 196.867 542.752C196.081 542.752 195.436 542.114 195.436 541.32V518.432C195.436 517.646 196.073 517 196.867 517Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.931 518.9H198.299V528.433H246.931V518.9Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.93 525.577H198.299V526.529H246.93V525.577Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.931 521.77H198.299V522.721H246.931V521.77Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.066 518.432C244.066 517.637 244.703 517 245.489 517C246.275 517 246.929 517.637 246.929 518.432V541.32C246.929 542.106 246.292 542.752 245.489 542.752C244.686 542.752 244.066 542.114 244.066 541.32V518.432Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.497 533.206C205.283 533.206 205.929 533.843 205.929 534.638V543.219C205.929 544.004 205.292 544.65 204.497 544.65C203.712 544.65 203.066 544.013 203.066 543.219V534.638C203.066 533.852 203.703 533.206 204.497 533.206Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.169 533.206C252.955 533.206 253.601 533.843 253.601 534.638V543.219C253.601 544.004 252.964 544.65 252.169 544.65C251.384 544.65 250.738 544.013 250.738 543.219V534.638C250.738 533.852 251.375 533.206 252.169 533.206Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3 533.211L195.437 530.828H246.931L253.6 533.211V536.075H203.066L198.3 533.211Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.609 533.206H203.066V536.069H253.609V533.206Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.437 530.828L203.066 533.211V537.026L195.437 533.691V530.828Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.34 559.537C1621.42 559.537 1620.67 560.277 1620.67 561.2V587.783C1620.67 588.696 1621.41 589.446 1622.34 589.446C1623.25 589.446 1624 588.706 1624 587.783V561.2C1624 560.287 1623.26 559.537 1622.34 559.537Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.19 561.744H1620.67V572.815H1564.19V561.744Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.19 569.499H1620.67V570.604H1564.19V569.499Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.19 565.076H1620.67V566.181H1564.19V565.076Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.52 561.2C1567.52 560.277 1566.78 559.537 1565.87 559.537C1564.95 559.537 1564.19 560.277 1564.19 561.2V587.783C1564.19 588.696 1564.93 589.446 1565.87 589.446C1566.8 589.446 1567.52 588.706 1567.52 587.783V561.2Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.48 578.359C1612.56 578.359 1611.81 579.1 1611.81 580.022V589.988C1611.81 590.901 1612.55 591.651 1613.48 591.651C1614.39 591.651 1615.14 590.911 1615.14 589.988V580.022C1615.14 579.11 1614.4 578.359 1613.48 578.359Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1558.11 578.359C1557.2 578.359 1556.45 579.1 1556.45 580.022V589.988C1556.45 590.901 1557.19 591.651 1558.11 591.651C1559.02 591.651 1559.77 590.911 1559.77 589.988V580.022C1559.77 579.11 1559.03 578.359 1558.11 578.359Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.67 578.365L1624 575.598H1564.19L1556.45 578.365V581.691H1615.14L1620.67 578.365Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.44 578.359H1615.14V581.685H1556.44V578.359Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624 575.598L1615.14 578.365V582.796L1624 578.923V575.598Z",
    fill: "#615E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7001_52055",
    x1: 173.405,
    y1: -0.000041539,
    x2: 1895.33,
    y2: 1016.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7001_52055",
    x1: 77.4502,
    y1: 669,
    x2: 239.759,
    y2: 1444.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727BBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7001_52055",
    x1: 958.566,
    y1: 663.133,
    x2: 958.566,
    y2: 685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7001_52055",
    x1: 3621.72,
    y1: 512.132,
    x2: 3621.72,
    y2: 243.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7001_52055",
    x1: 3621.72,
    y1: 512.132,
    x2: 3621.72,
    y2: 243.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1CADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7001_52055",
    x1: 951.419,
    y1: 477.903,
    x2: 965.176,
    y2: 476.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7001_52055",
    x1: 456.329,
    y1: 466.013,
    x2: 456.329,
    y2: 490.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7001_52055",
    x1: 760.106,
    y1: 476.071,
    x2: 760.106,
    y2: 492.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7001_52055",
    x1: 750.94,
    y1: 477.915,
    x2: 750.94,
    y2: 491.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7001_52055",
    x1: 721.073,
    y1: 477.915,
    x2: 721.073,
    y2: 491.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1BFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F6E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7001_52055",
    x1: 1579.16,
    y1: 474.624,
    x2: 1592.92,
    y2: 473.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7001_52055",
    x1: 1570.16,
    y1: 462.148,
    x2: 1570.16,
    y2: 469.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7001_52055",
    x1: 236.736,
    y1: 459.742,
    x2: 236.736,
    y2: 468.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81807C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7001_52055",
    x1: 253.583,
    y1: 459.742,
    x2: 253.583,
    y2: 468.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81807C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7001_52055",
    x1: 230.061,
    y1: 459.405,
    x2: 230.061,
    y2: 468.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7B5AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81807C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7001_52055",
    x1: 1346.53,
    y1: 498.174,
    x2: 1331.37,
    y2: 496.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7001_52055",
    x1: 1339.78,
    y1: 487.885,
    x2: 1379.04,
    y2: 487.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7001_52055",
    x1: 1359.41,
    y1: 483.482,
    x2: 1359.41,
    y2: 492.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7001_52055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 685,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPlan);
export default __webpack_public_path__ + "static/media/BackPlan.be5e032c76496aab29ea.svg";
export { ForwardRef as ReactComponent };